!(function (
  bodyScrollLock,
  themeAddresses,
  themeCurrency,
  Flickity,
  FlickityFade,
  Rellax,
  MicroModal,
  themeImages
) {
  "use strict";
  function floatLabels(e) {
    e.querySelectorAll(".form-field").forEach((e) => {
      const t = e.querySelector("label");
      e = e.querySelector("input, textarea");
      t &&
        e &&
        (e.addEventListener("keyup", (e) => {
          "" !== e.target.value
            ? t.classList.add("label--float")
            : t.classList.remove("label--float");
        }),
        e.value) &&
        e.value.length &&
        t.classList.add("label--float");
    });
  }
  (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.keyboardKeys = {
      TAB: "Tab",
      ENTER: "Enter",
      ESCAPE: "Escape",
      SPACE: "Space",
      LEFTARROW: "ArrowLeft",
      RIGHTARROW: "ArrowRight",
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let screenOrientation = getScreenOrientation();
  function readHeights() {
    var e = {};
    return (
      (e.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (e.announcementHeight = getHeight(
        '[data-section-type*="announcement"] [data-bar-top]'
      )),
      (e.footerHeight = getHeight('[data-section-type*="footer"]')),
      (e.menuHeight = getHeight("[data-header-height]")),
      (e.headerHeight = e.menuHeight + e.announcementHeight),
      (e.collectionNavHeight = getHeight("[data-collection-nav]")),
      (e.logoHeight = getFooterLogoWithPadding()),
      e
    );
  }
  function setVarsOnResize() {
    document.addEventListener("theme:resize", resizeVars), setVars();
  }
  function setVars() {
    var {
        windowHeight: e,
        announcementHeight: t,
        headerHeight: s,
        logoHeight: i,
        menuHeight: o,
        footerHeight: r,
        collectionNavHeight: a,
      } = readHeights(),
      n = document.querySelector(
        "[data-newsletter-holder].newsletter--top-left"
      );
    document.documentElement.style.setProperty("--full-screen", e + "px"),
      document.documentElement.style.setProperty(
        "--three-quarters",
        0.75 * e + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        e * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
      document.documentElement.style.setProperty("--menu-height", o + "px"),
      document.documentElement.style.setProperty(
        "--announcement-height",
        t + "px"
      ),
      document.documentElement.style.setProperty("--header-height", s + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        a + "px"
      ),
      document.documentElement.style.setProperty("--footer-height", r + "px"),
      document.documentElement.style.setProperty(
        "--content-full",
        e - s - i / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        e - s - r + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          document.querySelector(
            "[data-tracking-consent].popup-cookies--bottom"
          ).offsetHeight + "px"
        ),
      document.documentElement.style.setProperty(
        "--newsletter-small-height",
        n ? n.offsetHeight + "px" : "0px"
      ),
      document.documentElement.style.setProperty(
        "--scrollbar-width",
        getScrollbarWidth() + "px"
      );
  }
  function resizeVars() {
    var {
        windowHeight: e,
        announcementHeight: t,
        headerHeight: s,
        logoHeight: i,
        menuHeight: o,
        footerHeight: r,
        collectionNavHeight: a,
      } = readHeights(),
      n = document.querySelector(
        "[data-newsletter-holder].newsletter--top-left"
      ),
      l = getScreenOrientation();
    l !== screenOrientation &&
      (document.documentElement.style.setProperty("--full-screen", e + "px"),
      document.documentElement.style.setProperty(
        "--three-quarters",
        0.75 * e + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        e * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
      (screenOrientation = l)),
      document.documentElement.style.setProperty("--menu-height", o + "px"),
      document.documentElement.style.setProperty(
        "--announcement-height",
        t + "px"
      ),
      document.documentElement.style.setProperty("--header-height", s + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        a + "px"
      ),
      document.documentElement.style.setProperty("--footer-height", r + "px"),
      document.documentElement.style.setProperty(
        "--content-full",
        e - s - i / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        e - s - r + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          document.querySelector(
            "[data-tracking-consent].popup-cookies--bottom"
          ).offsetHeight + "px"
        ),
      document.documentElement.style.setProperty(
        "--newsletter-small-height",
        n ? n.offsetHeight + "px" : "0px"
      );
  }
  function getScreenOrientation() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function getHeight(e) {
    e = document.querySelector(e);
    return e ? e.offsetHeight : 0;
  }
  function getFooterLogoWithPadding() {
    var e = getHeight("[data-footer-logo]");
    return 0 < e ? e + 20 : 0;
  }
  function getScrollbarWidth() {
    var e = document.createElement("div"),
      t =
        ((e.style.visibility = "hidden"),
        (e.style.overflow = "scroll"),
        (e.style.msOverflowStyle = "scrollbar"),
        document.body.appendChild(e),
        document.createElement("div")),
      t = (e.appendChild(t), e.offsetWidth - t.offsetWidth);
    return e.parentNode.removeChild(e), t;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let isCompleted = !1,
    docComplete = !1;
  function preloadImages() {
    (document.onreadystatechange = () => {
      "complete" === document.readyState &&
        ((docComplete = !0), initImagesPreloader());
    }),
      requestIdleCallback(initImagesPreloader);
  }
  function initImagesPreloader() {
    setTimeout(() => {
      var e;
      isCompleted ||
        (docComplete
          ? ((e = document.querySelectorAll('img[loading="lazy"]')).length &&
              e.forEach((e) => {
                e.setAttribute("loading", "eager");
              }),
            (isCompleted = !0))
          : initImagesPreloader());
    }, 3e3);
  }
  function singles(e, t) {
    let s = 64,
      i = 0;
    t.forEach((e) => {
      var t;
      e.offsetHeight > i &&
        ((t =
          parseInt(window.getComputedStyle(e).marginTop) +
          parseInt(window.getComputedStyle(e).marginBottom)) > s && (s = t),
        (i = e.offsetHeight));
    });
    t = e.querySelectorAll("[data-overflow-background]");
    [e, ...t].forEach((e) => {
      e.style.setProperty(
        "min-height",
        `calc(${i + s}px + var(--header-padding))`
      );
    });
  }
  function doubles(s) {
    if (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < window.theme.sizes.small
    )
      s.querySelectorAll("[data-overflow-frame]").forEach((e) => {
        var t = e.querySelectorAll("[data-overflow-content]");
        singles(e, t);
      });
    else {
      const r = 2 * parseInt(getComputedStyle(s).getPropertyValue("--outer"));
      let t = 0,
        e = 0;
      var i = s.querySelectorAll("[data-overflow-frame]");
      i &&
        (e =
          parseInt(window.getComputedStyle(i[0]).borderTopWidth) +
          parseInt(window.getComputedStyle(i[0]).borderBottomWidth));
      s.querySelectorAll("[data-overflow-content]").forEach((e) => {
        e.offsetHeight > t && (t = e.offsetHeight);
      });
      var o = s.querySelectorAll("[data-overflow-background]");
      [...i, ...o].forEach((e) => {
        e.style.setProperty("min-height", t + r + "px");
      }),
        s.style.setProperty("min-height", t + r + e + "px");
    }
  }
  function preventOverflow(e) {
    var t = e.querySelectorAll(".js-overflow-container"),
      t =
        (t &&
          t.forEach((e) => {
            const t = e.querySelectorAll(".js-overflow-content");
            singles(e, t),
              document.addEventListener("theme:resize", () => {
                singles(e, t);
              });
          }),
        e.querySelectorAll("[data-overflow-wrapper]"));
    t &&
      t.forEach((e) => {
        doubles(e),
          document.addEventListener("theme:resize", () => {
            doubles(e);
          });
      });
  }
  function debounce(e, t) {
    let s;
    return function () {
      e &&
        (clearTimeout(s), (s = setTimeout(() => e.apply(this, arguments), t)));
    };
  }
  let lastWindowWidth = window.innerWidth,
    lastWindowHeight = window.innerHeight;
  function dispatch$1() {
    document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      lastWindowWidth !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", { bubbles: !0 })
        ),
        (lastWindowWidth = window.innerWidth)),
      lastWindowHeight !== window.innerHeight &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:height", { bubbles: !0 })
        ),
        (lastWindowHeight = window.innerHeight));
  }
  function resizeListener() {
    window.addEventListener(
      "resize",
      debounce(function () {
        dispatch$1();
      }, 50)
    );
  }
  let prev = window.pageYOffset,
    up = null,
    down = null,
    wasUp = null,
    wasDown = null,
    scrollLockTimeout = 0,
    scrollPosition = 0,
    targetElement = null;
  function dispatch() {
    var e = window.pageYOffset;
    e > prev
      ? ((down = !0), (up = !1))
      : e < prev
      ? ((down = !1), (up = !0))
      : ((up = null), (down = null)),
      (prev = e),
      document.dispatchEvent(
        new CustomEvent("theme:scroll", {
          detail: { up: up, down: down, position: e },
          bubbles: !1,
        })
      ),
      up &&
        !wasUp &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:up", {
            detail: { position: e },
            bubbles: !1,
          })
        ),
      down &&
        !wasDown &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:down", {
            detail: { position: e },
            bubbles: !1,
          })
        ),
      (wasDown = down),
      (wasUp = up);
  }
  function lock(e) {
    (targetElement = e.detail),
      bodyScrollLock.disableBodyScroll(targetElement, {
        allowTouchMove: (e) => {
          for (; e && e !== document.body; ) {
            if (
              null !== e.getAttribute("body-scroll-lock-ignore") ||
              null !== e.getAttribute("data-popout-list") ||
              "TEXTAREA" === e.tagName
            )
              return !0;
            e = e.parentElement;
          }
        },
      }),
      document.documentElement.hasAttribute("data-scroll-locked") ||
        ((scrollPosition = window.scrollY),
        document.documentElement.style.setProperty("scroll-behavior", "auto"),
        requestAnimationFrame(() => {
          document.documentElement.setAttribute("data-scroll-locked", ""),
            document.body.style.setProperty(
              "--scroll-top-position",
              `-${scrollPosition}px`
            ),
            document.documentElement.style.removeProperty("scroll-behavior");
        }));
  }
  function unlock() {
    (scrollLockTimeout = setTimeout(() => {
      document.body.removeAttribute("data-drawer-closing");
    }, 20)),
      document.body.hasAttribute("data-drawer-closing")
        ? (document.body.removeAttribute("data-drawer-closing"),
          scrollLockTimeout && clearTimeout(scrollLockTimeout))
        : (document.body.setAttribute("data-drawer-closing", ""),
          bodyScrollLock.clearAllBodyScrollLocks(),
          document.documentElement.removeAttribute("data-scroll-locked"),
          document.documentElement.style.setProperty("scroll-behavior", "auto"),
          window.scrollTo({ top: scrollPosition, behavior: "auto" }),
          document.documentElement.style.removeProperty("scroll-behavior"));
  }
  function scrollListener() {
    let e;
    window.addEventListener(
      "scroll",
      function () {
        e && window.cancelAnimationFrame(e),
          (e = window.requestAnimationFrame(function () {
            dispatch();
          }));
      },
      { passive: !0 }
    ),
      window.addEventListener("theme:scroll:lock", lock),
      window.addEventListener("theme:scroll:unlock", unlock);
  }
  const wrap = (e, t = "", s) => {
    s = s || document.createElement("div");
    return (
      s.classList.add(t), e.parentNode.insertBefore(s, e), s.appendChild(e)
    );
  };
  function wrapElements(e) {
    e.querySelectorAll(".rte table").forEach((e) => {
      wrap(e, "rte__table-wrapper");
    });
    e.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((e) => {
      wrap(e, "rte__video-wrapper");
    });
  }
  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      0 < navigator.maxTouchPoints ||
      0 < navigator.msMaxTouchPoints
    );
  }
  function isTouch() {
    isTouchDevice()
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1);
  }
  function ariaToggle(e) {
    e = e.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((e) => {
        e.addEventListener("click", function (e) {
          e.preventDefault();
          (e = e.currentTarget),
            e.setAttribute(
              "aria-expanded",
              "false" == e.getAttribute("aria-expanded") ? "true" : "false"
            ),
            (e = e.getAttribute("aria-controls"));
          const t = document.querySelector("#" + e),
            s = () => {
              t.classList.remove("expanding"),
                t.removeEventListener("transitionend", s);
            },
            i = () => {
              t.classList.add("expanding"),
                t.removeEventListener("transitionstart", i);
            };
          t.addEventListener("transitionstart", i),
            t.addEventListener("transitionend", s),
            t.classList.toggle("expanded");
        });
      });
  }
  function loading() {
    document.body.classList.add("is-loaded");
  }
  const classes$J = { loading: "is-loading" },
    selectors$W = { img: "img.is-loading" };
  function loadedImagesEventHook() {
    document.addEventListener(
      "load",
      (e) => {
        "IMG" == e.target.tagName &&
          e.target.classList.contains(classes$J.loading) &&
          (e.target.classList.remove(classes$J.loading),
          e.target.parentNode.classList.remove(classes$J.loading));
      },
      !0
    );
  }
  function removeLoadingClassFromLoadedImages(e) {
    e.querySelectorAll(selectors$W.img).forEach((e) => {
      e.complete &&
        (e.classList.remove(classes$J.loading),
        e.parentNode.classList.remove(classes$J.loading));
    });
  }
  const selectors$V = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
    },
    classes$I = { aosAnimate: "aos-animate" },
    observerConfig = { attributes: !1, childList: !0, subtree: !0 },
    mutationCallback = (e) => {
      for (const i of e) {
        var t, s;
        "childList" === i.type &&
          ((t = (s = i.target).querySelectorAll(selectors$V.aos)),
          (s = s.querySelectorAll(selectors$V.aosAnchor)),
          t.length &&
            t.forEach((e) => {
              aosItemObserver.observe(e);
            }),
          s.length) &&
          initAnchorObservers(s);
      }
    },
    aosItemObserver = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          e.isIntersecting &&
            (e.target.classList.add(classes$I.aosAnimate),
            t.unobserve(e.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    aosAnchorObserver = new IntersectionObserver(
      (e, s) => {
        e.forEach((e) => {
          var t;
          0.1 < e.intersectionRatio &&
            ((t = e.target.querySelectorAll(selectors$V.aos)).length &&
              t.forEach((e) => {
                e.classList.add(classes$I.aosAnimate);
              }),
            s.unobserve(e.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function bodyMutationObserver() {
    new MutationObserver(mutationCallback).observe(
      document.body,
      observerConfig
    );
  }
  function elementsIntersectionObserver() {
    var e = document.querySelectorAll(selectors$V.aos);
    e.length &&
      e.forEach((e) => {
        aosItemObserver.observe(e);
      });
  }
  function anchorsIntersectionObserver() {
    var e = document.querySelectorAll(selectors$V.aosAnchor);
    e.length && initAnchorObservers(e);
  }
  function initAnchorObservers(e) {
    let s = [];
    e.length &&
      e.forEach((e) => {
        var t,
          e = e.dataset.aosAnchor;
        -1 === s.indexOf(e) &&
          (t = document.querySelector(e)) &&
          (aosAnchorObserver.observe(t), s.push(e));
      });
  }
  function initAnimations() {
    elementsIntersectionObserver(),
      anchorsIntersectionObserver(),
      bodyMutationObserver();
  }
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (e) {
      var t = Date.now();
      return setTimeout(function () {
        e({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - t));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (e) {
        clearTimeout(e);
      }),
    window.theme.settings.enableAnimations && initAnimations(),
    resizeListener(),
    scrollListener(),
    isTouch(),
    setVars(),
    loadedImagesEventHook(),
    window.addEventListener("DOMContentLoaded", () => {
      setVarsOnResize(),
        ariaToggle(document),
        floatLabels(document),
        preventOverflow(document),
        wrapElements(document),
        removeLoadingClassFromLoadedImages(document),
        loading(),
        window.fastNetworkAndCPU && preloadImages();
    }),
    document.addEventListener("shopify:section:load", (e) => {
      e = e.target;
      floatLabels(e),
        preventOverflow(e),
        wrapElements(e),
        ariaToggle(document),
        setVarsOnResize();
    }),
    !(function () {
      function o(e) {
        var t = window.innerWidth || document.documentElement.clientWidth,
          s = window.innerHeight || document.documentElement.clientHeight,
          e = e.getBoundingClientRect();
        return 0 <= e.top && e.bottom <= s && 0 <= e.left && e.right <= t;
      }
      function r(e) {
        var t = window.innerWidth || document.documentElement.clientWidth,
          s = window.innerHeight || document.documentElement.clientHeight,
          e = e.getBoundingClientRect(),
          t = (0 <= e.left && e.left <= t) || (0 <= e.right && e.right <= t),
          e = (0 <= e.top && e.top <= s) || (0 <= e.bottom && e.bottom <= s);
        return t && e;
      }
      window.visibilityHelper = {
        isElementTotallyVisible: o,
        isElementPartiallyVisible: r,
        inViewportPartially: function (t, s) {
          function e() {
            var e = r(t);
            e != i && ((i = e), "function" == typeof s) && s(e, t);
          }
          var i = r(t);
          window.addEventListener("load", e),
            window.addEventListener("resize", e),
            window.addEventListener("scroll", e);
        },
        inViewportTotally: function (t, s) {
          function e() {
            var e = o(t);
            e != i && ((i = e), "function" == typeof s) && s(e, t);
          }
          var i = o(t);
          window.addEventListener("load", e),
            window.addEventListener("resize", e),
            window.addEventListener("scroll", e);
        },
      };
    })();
  const showElement = (e, t = !1, s = "block") => {
      e && (t ? e.style.removeProperty("display") : (e.style.display = s));
    },
    getUrlString =
      ((Shopify.Products = (function () {
        const u = {
          howManyToShow: 4,
          howManyToStoreInMemory: 10,
          wrapperId: "recently-viewed-products",
          section: null,
          onComplete: null,
        };
        let t,
          s,
          p = null;
        const m = {
            configuration: {
              expires: 90,
              path: "/",
              domain: window.location.hostname,
            },
            name: "shopify_recently_viewed",
            write: function (e) {
              e = e.join(" ");
              document.cookie =
                `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=` +
                this.configuration.domain;
            },
            read: function () {
              let e = [],
                t = null;
              var s = document.querySelector("#template-product");
              return (
                null !==
                  (t =
                    -1 !== document.cookie.indexOf("; ") &&
                    document.cookie
                      .split("; ")
                      .find((e) => e.startsWith(this.name))
                      ? document.cookie
                          .split("; ")
                          .find((e) => e.startsWith(this.name))
                          .split("=")[1]
                      : t) && (e = t.split(" ")),
                s &&
                  ((s = s.getAttribute("data-product-handle")),
                  -1 != e.indexOf(s)) &&
                  ((s = e.indexOf(s)), e.splice(s, 1)),
                e
              );
            },
            destroy: function () {
              document.cookie =
                `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=` +
                this.configuration.domain;
            },
            remove: function (e) {
              var t = this.read(),
                e = t.indexOf(e);
              -1 !== e && (t.splice(e, 1), this.write(t));
            },
          },
          g = (n, l, c, d) => {
            if (l.length && n < u.howManyToShow)
              fetch(
                `${window.theme.routes.root}products/${l[0]}?section_id=api-product-grid-item`
              )
                .then((e) => e.text())
                .then((e) => {
                  var t = 150 * n,
                    s = 100 * n + 800,
                    i = 50 * n + 800,
                    o = c.id ? "#" + c.id : "",
                    r = document.createElement("div");
                  let a = e.includes("||itemIndex||")
                    ? e.replaceAll("||itemIndex||", n)
                    : e;
                  (a = (a = (a = (a = a.includes("||itemAosDelay||")
                    ? a.replaceAll("||itemAosDelay||", t)
                    : a).includes("||itemAosImageDuration||")
                    ? a.replaceAll("||itemAosImageDuration||", s)
                    : a).includes("||itemAosTextDuration||")
                    ? a.replaceAll("||itemAosTextDuration||", i)
                    : a).includes("||itemAnimationAnchor||")
                    ? a.replaceAll("||itemAnimationAnchor||", o)
                    : a),
                    (r.innerHTML = a),
                    (c.innerHTML +=
                      r.querySelector("[data-api-content]").innerHTML),
                    l.shift(),
                    n++,
                    g(n, l, c, d);
                })
                .catch(() => {
                  m.remove(l[0]), l.shift(), g(n, l, c, d);
                });
            else {
              var i = c,
                e = d,
                t = (showElement(i, !0), m.read().length);
              if (
                Shopify.recentlyViewed &&
                p &&
                t &&
                t < p &&
                i.children.length
              ) {
                let t = [],
                  s = [],
                  e = 0;
                for (const h in Shopify.recentlyViewed) {
                  e += 1;
                  var o = Shopify.recentlyViewed[h].split(" "),
                    r = parseInt(h.split("_")[1]);
                  (t = [...t, ...o]),
                    (m.read().length !== r &&
                      (e !== Object.keys(Shopify.recentlyViewed).length ||
                        s.length)) ||
                      (s = [...s, ...o]);
                }
                for (let e = 0; e < i.children.length; e++) {
                  var a = i.children[e];
                  t.length && a.classList.remove(...t),
                    s.length && a.classList.add(...s);
                }
              }
              if (u.onComplete)
                try {
                  u.onComplete(i, e);
                } catch (e) {
                  console.log(e);
                }
            }
          };
        return {
          showRecentlyViewed: function (e) {
            e = e || {};
            Object.assign(u, e),
              (t = m.read()),
              (s = document.querySelector("#" + u.wrapperId)),
              (p = u.howManyToShow),
              (u.howManyToShow = Math.min(t.length, u.howManyToShow)),
              u.howManyToShow && s && g(0, t, s, u.section);
          },
          getConfig: function () {
            return u;
          },
          clearList: function () {
            m.destroy();
          },
          recordRecentlyViewed: function (t) {
            t = t || {};
            Object.assign(u, t);
            let s = m.read();
            if (-1 !== window.location.pathname.indexOf("/products/")) {
              let e = decodeURIComponent(window.location.pathname)
                .match(
                  /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                )[0]
                .split("/products/")[1];
              u.handle && (e = u.handle);
              t = s.indexOf(e);
              -1 === t
                ? (s.unshift(e), (s = s.splice(0, u.howManyToStoreInMemory)))
                : (s.splice(t, 1), s.unshift(e)),
                m.write(s);
            }
          },
          hasProducts: 0 < m.read().length,
        };
      })()),
      (e, i = [], o = !1) => {
        var t = Object.keys(e)
          .map((t) => {
            var s = e[t];
            if (
              "[object Object]" === Object.prototype.toString.call(s) ||
              Array.isArray(s)
            )
              return (
                Array.isArray(e) ? i.push("") : i.push(t),
                getUrlString(s, i, Array.isArray(s))
              );
            {
              let e = t;
              return (
                0 < i.length &&
                  ((t = o ? i : [...i, t]),
                  (e = t.reduce((e, t) => ("" === e ? t : e + `[${t}]`), ""))),
                o ? e + "[]=" + s : e + "=" + s
              );
            }
          })
          .join("&");
        return i.pop(), t;
      }),
    hideElement = (e) => {
      e && (e.style.display = "none");
    },
    fadeIn = (s, e, i = null) => {
      (s.style.opacity = 0), (s.style.display = e || "block");
      let o = !0;
      !(function e() {
        var t = parseFloat(s.style.opacity);
        1 < (t += 0.1) || ((s.style.opacity = t), requestAnimationFrame(e)),
          1 === parseInt(t) && o && "function" == typeof i && ((o = !1), i());
      })();
    };
  function isVisible(e) {
    e = window.getComputedStyle(e);
    return "none" !== e.display && "hidden" !== e.visibility;
  }
  function forceFocus(s, i) {
    i = i || {};
    var o = s.tabIndex;
    (s.tabIndex = -1),
      (s.dataset.tabIndex = o),
      s.focus(),
      void 0 !== i.className && s.classList.add(i.className),
      s.addEventListener("blur", function e(t) {
        t.target.removeEventListener(t.type, e);
        s.tabIndex = o;
        delete s.dataset.tabIndex;
        void 0 !== i.className && s.classList.remove(i.className);
      });
  }
  function focusHash(e) {
    e = e || {};
    var t = window.location.hash,
      s = document.getElementById(t.slice(1));
    if (s && e.ignore && s.matches(e.ignore)) return !1;
    t && s && forceFocus(s, e);
  }
  function bindInPageLinks(i) {
    return (
      (i = i || {}),
      Array.prototype.slice
        .call(document.querySelectorAll('a[href^="#"]'))
        .filter(function (e) {
          var t, s;
          return (
            "#" !== e.hash &&
            "" !== e.hash &&
            !(
              (i.ignore && e.matches(i.ignore)) ||
              ((t = e.hash.substr(1)), null === document.getElementById(t)) ||
              !(s = document.querySelector(e.hash)) ||
              (e.addEventListener("click", function () {
                forceFocus(s, i);
              }),
              0)
            )
          );
        })
    );
  }
  function focusable(e) {
    return Array.prototype.slice
      .call(
        e.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (e) {
        return !(
          !(e.offsetWidth || e.offsetHeight || e.getClientRects().length) ||
          !isVisible(e)
        );
      });
  }
  void 0 === Shopify.Cart && (Shopify.Cart = {}),
    (Shopify.Cart.ShippingCalculator = (function () {
      const _config = {
          submitButton: theme.strings.shippingCalcSubmitButton,
          submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
          templateId: "shipping-calculator-response-template",
          wrapperId: "wrapper-response",
          customerIsLoggedIn: !1,
        },
        _render = function (r) {
          var s = document.querySelector("#" + _config.templateId),
            a = document.querySelector("#" + _config.wrapperId);
          if (s && a) {
            let i = (a.innerHTML = ""),
              e = "",
              t = "error center",
              o = s.innerHTML;
            var n,
              l = /[^[\]]+(?=])/g;
            if (r.rates && r.rates.length) {
              let s = l.exec(o)[0];
              r.rates.forEach((e) => {
                let t = s;
                (t = (t = t.replace(/\|\|rateName\|\|/, e.name)).replace(
                  /\|\|ratePrice\|\|/,
                  Shopify.Cart.ShippingCalculator.formatRate(e.price)
                )),
                  (i += t);
              });
            }
            r.success
              ? ((t = "success center"),
                ((n = document.createElement("div")).innerHTML = s.innerHTML),
                (s = n.querySelector("[data-template-no-shipping]")),
                r.rates.length < 1 &&
                  s &&
                  (e = s.getAttribute("data-template-no-shipping")))
              : (e = r.errorFeedback),
              (o = (o = (o = (o = o.replace(l, "").replace("[]", "")).replace(
                /\|\|ratesList\|\|/g,
                i
              )).replace(/\|\|successClass\|\|/g, t)).replace(
                /\|\|ratesText\|\|/g,
                e
              )),
              (a.innerHTML += o);
          }
        },
        _enableButtons = function () {
          var e = document.querySelector(".get-rates");
          e.removeAttribute("disabled"),
            e.classList.remove("disabled"),
            (e.value = _config.submitButton);
        },
        _disableButtons = function () {
          var e = document.querySelector(".get-rates");
          e.setAttribute("disabled", "disabled"),
            e.classList.add("disabled"),
            (e.value = _config.submitButtonDisabled);
        },
        _getCartShippingRatesForDestination = function (t) {
          var e = encodeURI(getUrlString({ shipping_address: t })),
            e = window.theme.routes.cart + "/shipping_rates.json?" + e,
            s = new XMLHttpRequest();
          s.open("GET", e, !0),
            (s.onload = function () {
              var e;
              200 <= this.status && this.status < 400
                ? ((e = JSON.parse(this.response).shipping_rates),
                  _onCartShippingRatesUpdate(e, t))
                : _onError(this);
            }),
            (s.onerror = function () {
              _onError(this);
            }),
            s.send();
        },
        _fullMessagesFromErrors = function (e) {
          var t = [];
          for (const s in e) for (const i of e[s]) t.push(s + " " + i);
          return t;
        },
        _onError = function (XMLHttpRequest) {
          hideElement(document.querySelector("#estimated-shipping"));
          const shippingChild = document.querySelector(
            "#estimated-shipping em"
          );
          if (shippingChild)
            for (; shippingChild.firstChild; )
              shippingChild.removeChild(shippingChild.firstChild);
          _enableButtons();
          let feedback = "";
          const data = eval("(" + XMLHttpRequest.responseText + ")");
          (feedback = data.message
            ? data.message + "(" + data.status + "): " + data.description
            : "Error : " + _fullMessagesFromErrors(data).join("; ")),
            "Error : country is not supported." === feedback &&
              (feedback = "We do not ship to this destination."),
            _render({ rates: [], errorFeedback: feedback, success: !1 }),
            showElement(document.querySelector("#" + _config.wrapperId));
        },
        _onCartShippingRatesUpdate = function (e, t) {
          _enableButtons();
          let s = "";
          t.zip && (s += t.zip + ", "),
            t.province && (s += t.province + ", "),
            (s += t.country);
          (t = document.querySelector("#estimated-shipping em")),
            e.length &&
              t &&
              (t.textContent =
                "0.00" == e[0].price
                  ? window.theme.strings.free
                  : themeCurrency.formatMoney(e[0].price, theme.moneyFormat)),
            _render({ rates: e, address: s, success: !0 }),
            (t = document.querySelectorAll(
              `#${_config.wrapperId}, #estimated-shipping`
            ));
          t.length &&
            t.forEach((e) => {
              fadeIn(e);
            });
        },
        _init = function () {
          var e = document.querySelector(".get-rates"),
            t = document.querySelector("#address_container");
          const a = document.querySelector("#address_country"),
            n = document.querySelector("#address_province");
          var s = document.querySelector("html");
          let i = "en";
          s.hasAttribute("lang") &&
            "" !== s.getAttribute("lang") &&
            (i = s.getAttribute("lang")),
            t &&
              themeAddresses.AddressForm(t, i, { shippingCountriesOnly: !0 }),
            a &&
              a.hasAttribute("data-default") &&
              n &&
              n.hasAttribute("data-default") &&
              a.addEventListener("change", function () {
                a.removeAttribute("data-default"),
                  n.removeAttribute("data-default");
              }),
            e &&
              (e.addEventListener("click", function (e) {
                _disableButtons();
                for (
                  var t = document.querySelector("#" + _config.wrapperId);
                  t.firstChild;

                )
                  t.removeChild(t.firstChild);
                hideElement(t);
                var s = {};
                let i = a.value,
                  o = n.value;
                var r = a.getAttribute("data-default-fullname"),
                  r =
                    ("" === i && r && "" !== r && (i = r),
                    n.getAttribute("data-default-fullname"));
                "" === o && r && "" !== r && (o = r),
                  (s.zip = document.querySelector("#address_zip").value || ""),
                  (s.country = i || ""),
                  (s.province = o || ""),
                  _getCartShippingRatesForDestination(s);
              }),
              _config.customerIsLoggedIn) &&
              e.classList.contains("get-rates--trigger") &&
              (s = document.querySelector("#address_zip")) &&
              s.value &&
              e.dispatchEvent(new Event("click"));
        };
      return {
        show: function (e) {
          (e = e || {}),
            Object.assign(_config, e),
            document.addEventListener("DOMContentLoaded", function () {
              _init();
            });
        },
        getConfig: function () {
          return _config;
        },
        formatRate: function (e) {
          return "0.00" === e
            ? window.theme.strings.free
            : themeCurrency.formatMoney(e, theme.moneyFormat);
        },
      };
    })());
  var trapFocusHandlers = {};
  function trapFocus(t, e) {
    e = e || {};
    var s = focusable(t),
      i = e.elementToFocus || t,
      o = s[0],
      r = s[s.length - 1];
    removeTrapFocus(),
      (trapFocusHandlers.focusin = function (e) {
        t !== e.target &&
          !t.contains(e.target) &&
          o &&
          o === e.target &&
          o.focus(),
          (e.target !== t && e.target !== r && e.target !== o) ||
            document.addEventListener("keydown", trapFocusHandlers.keydown);
      }),
      (trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
      }),
      (trapFocusHandlers.keydown = function (e) {
        e.code === window.theme.keyboardKeys.TAB &&
          (e.target !== r || e.shiftKey || (e.preventDefault(), o.focus()),
          e.target === t || e.target === o) &&
          e.shiftKey &&
          (e.preventDefault(), r.focus());
      }),
      document.addEventListener("focusout", trapFocusHandlers.focusout),
      document.addEventListener("focusin", trapFocusHandlers.focusin),
      forceFocus(i, e);
  }
  function removeTrapFocus() {
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
      document.removeEventListener("focusout", trapFocusHandlers.focusout),
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }
  function accessibleLinks(e, t) {
    if ("string" != typeof e) throw new TypeError(e + " is not a String.");
    var s, r, i;
    0 !== (e = document.querySelectorAll(e)).length &&
      (((t = t || {}).messages = t.messages || {}),
      (s = {
        newWindow: t.messages.newWindow || "Opens in a new window.",
        external: t.messages.external || "Opens external website.",
        newWindowExternal:
          t.messages.newWindowExternal ||
          "Opens external website in a new window.",
      }),
      (t = t.prefix || "a11y"),
      (r = {
        newWindow: t + "-new-window-message",
        external: t + "-external-message",
        newWindowExternal: t + "-new-window-external-message",
      }),
      e.forEach(function (e) {
        var t = e.getAttribute("target"),
          s = e.getAttribute("rel"),
          i = e.hostname !== window.location.hostname,
          t = "_blank" === t,
          o = null === s || -1 === s.indexOf("noopener");
        t &&
          o &&
          e.setAttribute("rel", null === s ? "noopener" : s + " noopener"),
          i && t
            ? e.setAttribute("aria-describedby", r.newWindowExternal)
            : i
            ? e.setAttribute("aria-describedby", r.external)
            : t && e.setAttribute("aria-describedby", r.newWindow);
      }),
      (i = s),
      (t = document.createElement("ul")),
      (e = Object.keys(i).reduce(function (e, t) {
        return e + ("<li id=" + r[t] + ">" + i[t]) + "</li>";
      }, "")),
      t.setAttribute("hidden", !0),
      (t.innerHTML = e),
      document.body.appendChild(t));
  }
  var a11y = Object.freeze({
    __proto__: null,
    forceFocus: forceFocus,
    focusHash: focusHash,
    bindInPageLinks: bindInPageLinks,
    focusable: focusable,
    trapFocus: trapFocus,
    removeTrapFocus: removeTrapFocus,
    accessibleLinks: accessibleLinks,
  });
  function FetchError(e) {
    (this.status = e.status || null),
      (this.headers = e.headers || null),
      (this.json = e.json || null),
      (this.body = e.body || null);
  }
  FetchError.prototype = Error.prototype;
  const selectors$U = {
    quantityHolder: "[data-quantity-holder]",
    quantityField: "[data-quantity-field]",
    quantityButton: "[data-quantity-button]",
    quantityMinusButton: "[data-quantity-minus]",
    quantityPlusButton: "[data-quantity-plus]",
    quantityReadOnly: "read-only",
    isDisabled: "is-disabled",
  };
  class QuantityCounter {
    constructor(e, t = !1) {
      (this.holder = e), (this.quantityUpdateCart = t);
    }
    init() {
      (this.settings = selectors$U),
        (this.quantity = this.holder.querySelector(
          this.settings.quantityHolder
        )),
        this.quantity &&
          ((this.field = this.quantity.querySelector(
            this.settings.quantityField
          )),
          (this.buttons = this.quantity.querySelectorAll(
            this.settings.quantityButton
          )),
          (this.increaseButton = this.quantity.querySelector(
            this.settings.quantityPlusButton
          )),
          (this.quantityValue = Number(this.field.value || 0)),
          (this.cartItemID = this.field.getAttribute("data-id")),
          (this.maxValue =
            0 < Number(this.field.getAttribute("max"))
              ? Number(this.field.getAttribute("max"))
              : null),
          (this.minValue =
            0 < Number(this.field.getAttribute("min"))
              ? Number(this.field.getAttribute("min"))
              : 0),
          (this.disableIncrease = this.disableIncrease.bind(this)),
          (this.emptyField = !1),
          (this.updateQuantity = this.updateQuantity.bind(this)),
          (this.decrease = this.decrease.bind(this)),
          (this.increase = this.increase.bind(this)),
          this.disableIncrease(),
          this.quantity.classList.contains(this.settings.quantityReadOnly) ||
            (this.changeValueOnClick(), this.changeValueOnInput()));
    }
    changeValueOnClick() {
      const s = this;
      this.buttons.forEach((e) => {
        e.addEventListener("click", (e) => {
          e.preventDefault();
          var e = e.target,
            t =
              e.matches(s.settings.quantityMinusButton) ||
              e.closest(s.settings.quantityMinusButton),
            e =
              e.matches(s.settings.quantityPlusButton) ||
              e.closest(s.settings.quantityPlusButton);
          t && s.decrease(), e && s.increase(), s.updateQuantity();
        });
      });
    }
    changeValueOnInput() {
      this.field.addEventListener("change", () => {
        (this.quantityValue = this.field.value),
          "" === this.field.value && (this.emptyField = !0),
          this.updateQuantity();
      });
    }
    updateQuantity() {
      this.maxValue < this.quantityValue &&
        null !== this.maxValue &&
        (this.quantityValue = this.maxValue),
        this.minValue > this.quantityValue &&
          (this.quantityValue = this.minValue),
        (this.field.value = this.quantityValue),
        this.disableIncrease(),
        this.quantityUpdateCart && this.updateCart();
    }
    decrease() {
      this.quantityValue > this.minValue
        ? this.quantityValue--
        : (this.quantityValue = 0);
    }
    increase() {
      this.quantityValue++;
    }
    disableIncrease() {
      this.increaseButton.classList.toggle(
        this.settings.isDisabled,
        this.quantityValue >= this.maxValue && null !== this.maxValue
      );
    }
    updateCart() {
      var e = new CustomEvent("theme:cart:update", {
        bubbles: !0,
        detail: {
          id: this.cartItemID,
          quantity: this.quantityValue,
          valueIsEmpty: this.emptyField,
        },
      });
      this.holder.dispatchEvent(e);
    }
  }
  const classes$H = {
      animated: "is-animated",
      active: "is-active",
      added: "is-added",
      disabled: "is-disabled",
      error: "has-error",
      headerStuck: "js__header__stuck",
      hidden: "is-hidden",
      hiding: "is-hiding",
      loading: "is-loading",
      open: "is-open",
      removed: "is-removed",
      success: "is-success",
      visible: "is-visible",
      focused: "is-focused",
      expanded: "is-expanded",
      updated: "is-updated",
    },
    selectors$T = {
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      animation: "[data-animation]",
      additionalCheckoutButtons: ".additional-checkout-buttons",
      burgerButton: "[data-drawer-toggle]",
      buttonAddToCart: "[data-add-to-cart]",
      buttonQuickAddMobile: "[data-quick-add-btn-mobile]",
      buttonHolder: "[data-foot-holder]",
      buttonSkipUpsellProduct: "[data-skip-upsell-product]",
      cartBarAdd: "[data-add-to-cart-bar]",
      cartCloseError: "[data-cart-error-close]",
      cartDiscountsHolder: "[data-cart-discounts-holder]",
      cartDrawer: "[data-cart-drawer]",
      cartDrawerBody: "[data-cart-drawer-body]",
      cartEmpty: "[data-cart-empty]",
      cartErrors: "[data-cart-errors]",
      cartItemRemove: "[data-item-remove]",
      cartOriginalTotal: "[data-cart-original-total]",
      cartOriginaTotalPrice: "[data-cart-original-total-price]",
      cartPage: "[data-cart-page]",
      cartProgress: "[data-cart-progress]",
      cartProgressBar: "[data-progress-bar]",
      cartToggleElement: "[data-cart-toggle]",
      cartTotal: "[data-cart-total]",
      cartTotalDiscountsTemplate: "[data-cart-total-discount-template]",
      cartTotalDiscountTitle: "[data-cart-discount-title]",
      cartTotalDiscountAmount: "[data-cart-discount-price]",
      cartWidget: "[data-cart-widget]",
      cartWidgetContent: "[data-cart-widget-content]",
      expandButton: "[data-expand-button]",
      errorMessage: "[data-error-message]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      freeShipping: "[data-free-shipping]",
      freeShippingGraph: "[data-progress-graph]",
      freeShippingProgress: "[data-progress-bar]",
      headerWrapper: "[data-header-wrapper]",
      item: "[data-item]",
      itemsHolder: "[data-items-holder]",
      leftToSpend: "[data-left-to-spend]",
      navDrawer: "[data-drawer]",
      outerSection: "[data-section-id]",
      upsellProductsHolder: "[data-upsell-products]",
      quickAddHolder: "[data-quick-add-holder]",
      quickAddModal: "[data-quick-add-modal]",
      qtyInput: "[data-quantity-field]",
    },
    attributes$d = {
      disabled: "disabled",
      quickAddHolder: "data-quick-add-holder",
      quickAddVariant: "data-quick-add-variant",
      freeShipping: "data-free-shipping",
      freeShippingLimit: "data-free-shipping-limit",
    },
    settings$3 = {
      cartDrawerEnabled: window.theme.settings.cartDrawerEnabled,
      times: { timeoutAnimationComplete: 500, timeoutButtonReset: 1e3 },
    };
  class CartDrawer {
    constructor() {
      window.location.pathname.endsWith("/password") || this.init();
    }
    init() {
      (this.html = document.documentElement),
        (this.body = document.body),
        (this.cartPage = document.querySelector(selectors$T.cartPage)),
        (this.cartDrawer = document.querySelector(selectors$T.cartDrawer)),
        (this.cartDrawerBody = document.querySelector(
          selectors$T.cartDrawerBody
        )),
        (this.cartEmpty = document.querySelector(selectors$T.cartEmpty)),
        (this.buttonHolder = document.querySelector(selectors$T.buttonHolder)),
        (this.itemsHolder = document.querySelector(selectors$T.itemsHolder)),
        (this.items = document.querySelectorAll(selectors$T.item)),
        (this.cartTotal = document.querySelector(selectors$T.cartTotal)),
        (this.freeShipping = document.querySelectorAll(
          selectors$T.freeShipping
        )),
        (this.cartOriginalTotal = document.querySelector(
          selectors$T.cartOriginalTotal
        )),
        (this.cartOriginaTotalPrice = document.querySelector(
          selectors$T.cartOriginaTotalPrice
        )),
        (this.cartDiscountHolder = document.querySelector(
          selectors$T.cartDiscountsHolder
        )),
        (this.expandButton = document.querySelectorAll(
          selectors$T.expandButton
        )),
        (this.cartTotalDiscountTemplate = document.querySelector(
          selectors$T.cartTotalDiscountsTemplate
        ).innerHTML),
        (this.cartErrorHolder = document.querySelector(selectors$T.cartErrors)),
        (this.cartCloseErrorMessage = document.querySelector(
          selectors$T.cartCloseError
        )),
        (this.headerWrapper = document.querySelector(
          selectors$T.headerWrapper
        )),
        (this.accessibility = a11y),
        (this.navDrawer = document.querySelector(selectors$T.navDrawer)),
        (this.upsellProductsHolder = document.querySelector(
          selectors$T.upsellProductsHolder
        )),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.form = null),
        (this.build = this.build.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.addToCartCallback = this.addToCartCallback.bind(this)),
        (this.productAddCallback = this.productAddCallback.bind(this)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.animateItems = this.animateItems.bind(this)),
        (this.requestItemsAnimationFrame =
          this.requestItemsAnimationFrame.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.cartAnimationTimeout = 0),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
        (this.toggleClassesOnContainers =
          this.toggleClassesOnContainers.bind(this)),
        (this.subtotal = window.theme.subtotal),
        (this.totalItems = this.items.length),
        (this.cartDrawerIsOpen = !1),
        (this.cartDiscounts = 0),
        (this.cartDrawerEnabled = settings$3.cartDrawerEnabled),
        (this.cartUpdateFailed = !1),
        this.eventToggleCart(),
        this.expandEvents(),
        this.cartEvents(),
        this.cartEventAdd(),
        this.cartEventRemoveError(),
        this.initQuantity(),
        this.estimateShippingCalculator(),
        (this.circumference = 28 * Math.PI),
        (this.cartFreeShippingLimit = 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        document.addEventListener("theme:cart:add", this.addToCartCallback),
        document.addEventListener(
          "theme:cart:loaded",
          this.requestItemsAnimationFrame
        ),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener("theme:product:add", this.productAddCallback),
        document.addEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        );
    }
    initQuantity() {
      (this.items = document.querySelectorAll(selectors$T.item)),
        this.items.forEach((e) => {
          new QuantityCounter(e, !0).init(), this.cartUpdateEvent(e);
        });
    }
    expandEvents() {
      const i = document.querySelectorAll(selectors$T.cartWidget);
      this.expandButton.forEach((s) => {
        s.addEventListener("click", (e) => {
          e.preventDefault();
          const t = document.querySelector(s.getAttribute("href"));
          s.classList.toggle(classes$H.active),
            t.classList.toggle(classes$H.expanded),
            1 < i.length &&
              i.forEach((e) => {
                e !== t.parentElement &&
                  ((e = e.querySelector(
                    selectors$T.expandButton
                  )).classList.remove(classes$H.active),
                  e.nextElementSibling.classList.remove(classes$H.expanded));
              });
        });
      });
    }
    cartUpdateEvent(t) {
      t.addEventListener("theme:cart:update", (e) => {
        this.updateCart(
          { id: e.detail.id, quantity: e.detail.quantity },
          t,
          e.detail.valueIsEmpty
        );
      });
    }
    addToCartCallback(e) {
      var t, s;
      e.detail.data &&
        ((t = e.detail),
        (s = e.detail.button),
        (e = JSON.stringify({ items: [e.detail.data] })),
        this.addToCart(e, t, s));
    }
    cartEvents() {
      document.querySelectorAll(selectors$T.cartItemRemove).forEach((t) => {
        const s = t.closest(selectors$T.item);
        t.addEventListener("click", (e) => {
          e.preventDefault(),
            t.classList.contains(classes$H.disabled) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, s);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (e) => {
            e.preventDefault(),
              this.cartErrorHolder.classList.remove(classes$H.expanded);
          });
    }
    cartEventAdd() {
        document.addEventListener("click", (t) => {
          var s = t.target;
          if (
            s.matches(selectors$T.buttonAddToCart) ||
            (s.closest(selectors$T.buttonAddToCart) && s)
          ) {
            let e = "";
            let sub = null
            let bundle = null;
            var i = s.matches(selectors$T.buttonAddToCart)
              ? s
              : s.closest(selectors$T.buttonAddToCart);
            if (i.hasAttribute(attributes$d.quickAddVariant))
              e = JSON.stringify({
                items: [
                  {
                    id: Number(i.getAttribute(attributes$d.quickAddVariant)),
                    quantity: 1,
                  },
                ],
              });
            else {
              if (((this.form = s.closest("form")), !this.form.checkValidity()))
                return void this.form.reportValidity();
              e = new FormData(this.form);
              sub = document.querySelector('.product-sellings-plans')?.querySelector('select')?.value
              if(this.form.querySelector('#bundleId')?.textContent && document.querySelector('.products__list--item.is-bundle.is-selected')){
                  bundle = {
                      id:`${Number(this.form.querySelector('#bundleId')?.textContent)}`,
                      quantity: `${1}`
                    }
              }
              if(sub){
                e.set('selling_plan', `${sub}`)
              }
            }
            (null !== this.form && this.form.querySelector('[type="file"]')) ||
              (t.preventDefault(), s.hasAttribute("disabled")) ||
              s.parentNode.hasAttribute("disabled") ||
              (this.addToCart(e, null, i, bundle),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  bubbles: !0,
                  detail: { selector: s },
                })
              ));
          }
        });
      }
    cartEventRemoveError() {
      document.addEventListener("click", (e) => {
        var t = e.target;
        (t.matches(selectors$T.formCloseError) ||
          t.closest(selectors$T.formCloseError)) &&
          (e.preventDefault(),
          (e = t.closest(selectors$T.formErrorsContainer))) &&
          e.classList.remove(classes$H.visible);
      });
    }
    estimateShippingCalculator() {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: theme.strings.shippingCalcSubmitButton,
        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: theme.settings.customerLoggedIn,
        moneyFormat: theme.moneyWithCurrencyFormat,
      });
    }
    getCart() {
      fetch(theme.routes.root + "cart.js")
        .then(this.cartErrorsHandler)
        .then((e) => e.json())
        .then(
          (e) => (
            (this.newTotalItems = e.items.length),
            (this.subtotal = e.total_price),
            (this.itemCount = e.item_count),
            (this.cartDiscounts = e.total_discount),
            this.buildTotalPrice(e),
            document.dispatchEvent(
              new CustomEvent("theme:cart:change", {
                bubbles: !0,
                detail: { cart: e },
              })
            ),
            fetch(theme.routes.cart + "?section_id=api-cart-items")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          var t = document.createElement("div"),
            e = ((t.innerHTML = e), t.querySelector(selectors$T.apiContent));
          this.build(e);
        })
        .catch((e) => console.log(e));
    }
    async addToCart(e, t = null, s = null, bundle = null) {
        console.log(e)
        console.log(typeof e)
        var formBody = '';
          if (typeof e == "string"){
            let cartData = JSON.parse(e);
            const itemsToAdd = cartData.items;
          const cartItems = [];
          itemsToAdd.forEach((item) => {
            cartItems.push({
              id: item.id,
              quantity: item.quantity,
            });
          });

             formBody = {
              items:cartItems
          };
          }else{
            formBody = {
            items:[
                Object.fromEntries(e.entries()),
                bundle
            ]
        };
      }
        let idsToPush = formBody.items.map((item) => {
          if (item && item.id) {
            return item.id;
          }
          return null; // Use null for null items or items without 'id'
        });

        console.log(idsToPush)
        console.log(formBody)
        let cartJson = await fetch(theme.routes.root + "cart.js").then((res) => res.json());
        console.log(cartJson)

        const matchingItem = cartJson.items.find((item) => idsToPush.includes(item.id.toString().trim()));
        const product_type = document.querySelector('input[name="product_type"]')
        if(matchingItem && product_type){
          const errorsContainer = document.querySelector('.product__form__errors');
          errorsContainer.classList.add('is-visible');
          let errorsElement = errorsContainer.querySelector('.errors');
          if (!errorsElement) {
            errorsElement = document.createElement('div');
            errorsElement.classList.add('errors');
            errorsContainer.appendChild(errorsElement);
          }
          const errorMessage = document.querySelector('span[data-error-message]').getAttribute('data-error-message');

          errorsElement.innerHTML = errorMessage;
          const spanElement = document.createElement('span');
          spanElement.classList.add('errors__close');
          spanElement.setAttribute('data-close-error', '');

          spanElement.textContent = 'x';

          errorsElement.appendChild(spanElement);
          return;
       } else{
        this.cart && this.cart.classList.add(classes$H.loading);
        const i = t ? t.element : null;
        let o = null,
          r =
            (this.cartDrawerEnabled &&
              (s && (s.classList.add(classes$H.loading), (s.disabled = !0)), i) &&
              (i.classList.add(classes$H.visible),
              (o = i.querySelector(selectors$T.buttonQuickAddMobile))),
            e),
          a = { "Content-Type": "application/json" };
        "string" != typeof e &&
          ((r = new URLSearchParams(e).toString()),
          (a = {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          }));

      
          fetch(theme.routes.root + "cart/add.js", {
            method: "POST",
            headers: bundle ? { "Content-Type": "application/json" } : a,
            body: bundle ? JSON.stringify(formBody) : r,
          })
            .then((e) => e.json())
            .then((e) => {
              e.status
                ? (this.addToCartError(e, i, s),
                  s && (s.classList.remove(classes$H.loading), (s.disabled = !1)),
                  o && (o.classList.remove(classes$H.loading), (o.disabled = !1)))
                : this.cartDrawerEnabled
                ? (s &&
                    (s.classList.remove(classes$H.hidden, classes$H.loading),
                    s.classList.add(classes$H.added),
                    s.dispatchEvent(
                      new CustomEvent("theme:product:add", {
                        detail: { response: e, button: s },
                        bubbles: !0,
                      })
                    )),
                  o &&
                    (o.classList.remove(classes$H.hidden, classes$H.loading),
                    o.classList.add(classes$H.added)),
                  this.getCart())
                : (window.location = theme.routes.cart);
            })
            .catch((e) => {
              this.addToCartError(e, i, s), this.enableCartButtons();
            });
        }    
      }
    updateCart(s = {}, e = null, t = !1) {
      this.cart.classList.add(classes$H.loading);
      let i,
        o = null,
        r = null,
        a = s.quantity;
      null !== e &&
        (a
          ? e.classList.add(classes$H.loading)
          : e.classList.add(classes$H.removed)),
        this.disableCartButtons(),
        fetch(theme.routes.root + "cart.js")
          .then(this.cartErrorsHandler)
          .then((e) => e.json())
          .then((e) => {
            var t = e.items.findIndex((e) => e.key === s.id),
              e =
                ((o = e.item_count),
                (r = e.items[t].title),
                { line: "" + (t + 1), quantity: a });
            return fetch(theme.routes.root + "cart/change.js", {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(e),
            });
          })
          .then(this.cartErrorsHandler)
          .then((e) => e.json())
          .then((e) => {
            (i = e.item_count),
              0 !== (a = t ? 1 : a) &&
                ((this.cartUpdateFailed = i === o), this.updateErrorText(r)),
              this.getCart();
          })
          .catch((e) => {
            console.log(e), this.enableCartButtons();
          });
    }
    disableCartButtons() {
      var e = this.cart.querySelectorAll("input"),
        t = this.cart.querySelectorAll("button, " + selectors$T.cartItemRemove);
      e.length &&
        e.forEach((e) => {
          e.classList.add(classes$H.disabled), e.blur(), (e.disabled = !0);
        }),
        t.length &&
          t.forEach((e) => {
            e.setAttribute(attributes$d.disabled, !0);
          });
    }
    enableCartButtons() {
      var e = this.cart.querySelectorAll("input"),
        t = this.cart.querySelectorAll("button, " + selectors$T.cartItemRemove);
      e.length &&
        e.forEach((e) => {
          e.classList.remove(classes$H.disabled), (e.disabled = !1);
        }),
        t.length &&
          t.forEach((e) => {
            e.removeAttribute(attributes$d.disabled);
          }),
        this.cart.classList.remove(classes$H.loading);
    }
    updateErrorText(e) {
      this.cartErrorHolder.querySelector(selectors$T.errorMessage).innerText =
        e;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartUpdateFailed
          ? this.cartErrorHolder.classList.add(classes$H.expanded)
          : this.cartErrorHolder.classList.remove(classes$H.expanded),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new FetchError({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
    addToCartError(t, e, s) {
      if (
        (this.cartDrawerEnabled &&
          s &&
          null !== s.closest(selectors$T.cartDrawer) &&
          !s.closest(selectors$T.cartDrawer) &&
          this.closeCartDrawer(),
        null !== s)
      ) {
        let e = (
          s.closest(selectors$T.outerSection) ||
          s.closest(selectors$T.quickAddHolder) ||
          s.closest(selectors$T.quickAddModal)
        )?.querySelector(selectors$T.formErrorsContainer);
        var i = s.closest(selectors$T.quickAddHolder);
        (e =
          i && i.querySelector(selectors$T.formErrorsContainer)
            ? i.querySelector(selectors$T.formErrorsContainer)
            : e) &&
          ((e.innerHTML = `<div class="errors">${t.message}: ${t.description}<span class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`),
          e.classList.add(classes$H.visible)),
          s.dispatchEvent(
            new CustomEvent("theme:product:add-error", {
              detail: { response: t },
              bubbles: !0,
            })
          );
      }
      e &&
        e.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: e,
            },
          })
        ),
        this.cart.classList.remove(classes$H.loading);
    }
    productAddCallback(s) {
      if (theme.settings.cartDrawerEnabled) {
        let e = [],
          t = null;
        const o = "theme:product:add-error" == s.type;
        var s = s.target,
          i = document.querySelector(selectors$T.cartBarAdd);
        e.push(s),
          (t = s.closest(selectors$T.quickAddHolder)) &&
            (s = t.querySelector(selectors$T.buttonQuickAddMobile)) &&
            e.push(s),
          i && e.push(i),
          e.forEach((e) => {
            e.classList.remove(classes$H.loading),
              o || e.classList.add(classes$H.added);
          }),
          setTimeout(() => {
            e.forEach((e) => {
              e.classList.remove(classes$H.added), (e.disabled = !1);
            }),
              t && t.classList.remove(classes$H.visible);
          }, settings$3.times.timeoutButtonReset);
      }
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawer && !this.cartDrawerIsOpen && this.openCartDrawer();
    }
    openCartDrawer() {
      this.cartDrawer &&
        ((this.cartDrawerIsOpen = !0),
        document.dispatchEvent(
          new CustomEvent("theme:cart:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.cartDrawer,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.cartDrawerBody,
          })
        ),
        this.cartDrawer.classList.add(classes$H.open),
        this.observeAdditionalCheckoutButtons(),
        this.requestItemsAnimationFrame(),
        this.trapFocusAfterAnimationsComplete());
    }
    trapFocusAfterAnimationsComplete() {
      this.cartAnimationTimeout && clearTimeout(this.cartAnimationTimeout),
        (this.cartAnimationTimeout = setTimeout(() => {
          this.accessibility.trapFocus(this.cartDrawer, {
            elementToFocus: this.cartDrawer.querySelector(
              selectors$T.cartToggleElement
            ),
          });
        }, settings$3.times.timeoutAnimationComplete));
    }
    closeCartDrawer() {
      var e;
      this.cartDrawer &&
        this.cartDrawer.classList.contains(classes$H.open) &&
        ((this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart:close", { bubbles: !0 })
        ),
        this.resetAnimatedItems(),
        this.itemsHolder.classList.remove(classes$H.updated),
        this.cartEmpty.classList.remove(classes$H.updated),
        this.cartErrorHolder.classList.remove(classes$H.expanded),
        this.cartDrawer.querySelectorAll(selectors$T.animation).forEach((e) => {
          const t = () => {
            e.classList.remove(classes$H.hiding),
              e.removeEventListener("animationend", t);
          };
          e.classList.add(classes$H.hiding),
            e.addEventListener("animationend", t);
        }),
        this.cartDrawer.classList.remove(classes$H.open),
        this.accessibility.removeTrapFocus(),
        this.body.classList.contains(classes$H.focused) &&
          (e = this.headerWrapper.querySelectorAll(
            "" + selectors$T.cartToggleElement
          )).length &&
          e.forEach((e) => {
            if (isVisible(e))
              return (
                setTimeout(() => {
                  e.focus();
                }, 200),
                !0
              );
          }),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    eventToggleCart() {
      document.addEventListener("click", (e) => {
        var t = e.target,
          s = !(
            t.matches(selectors$T.cartToggleElement) ||
            t.closest(selectors$T.cartToggleElement)
          ),
          i = !(
            t.matches(selectors$T.cartDrawer) ||
            t.closest(selectors$T.cartDrawer)
          ),
          o = !(
            t.matches(selectors$T.buttonSkipUpsellProduct) ||
            t.closest(selectors$T.buttonSkipUpsellProduct)
          );
        t.matches(selectors$T.cartToggleElement) ||
        t.closest(selectors$T.cartToggleElement)
          ? (e.preventDefault(), this.toggleCartDrawer())
          : this.cartDrawerIsOpen && s && i && o && this.closeCartDrawer();
      }),
        this.cartDrawer &&
          this.cartDrawer.addEventListener("keyup", (e) => {
            e.code === window.theme.keyboardKeys.ESCAPE &&
              this.closeCartDrawer();
          });
    }
    toggleClassesOnContainers() {
      var e = this.hasItemsInCart();
      this.cartEmpty.classList.toggle(classes$H.hidden, e),
        this.buttonHolder.classList.toggle(classes$H.hidden, !e),
        this.itemsHolder.classList.toggle(classes$H.hidden, !e);
    }
    build(e) {
      console.log("build" , e)
      var t = e.querySelector(selectors$T.apiLineItems),
        s = e.querySelector(selectors$T.apiUpsellItems);
        console.log(t)
        console.log(s)
        console.log(Boolean(null === t && null === s))
      Boolean(null === t && null === s)
        ? ((this.itemsHolder.innerHTML = e),
          (this.upsellProductsHolder.innerHTML = ""))
        : ((this.itemsHolder.innerHTML = t.innerHTML),
          (this.upsellProductsHolder.innerHTML = s.innerHTML),
          this.skipUpsellProductEvent(),
          this.checkSkippedUpsellProductsFromStorage(),
          this.toggleCartUpsellWidgetVisibility()),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : themeCurrency.formatMoney(
                this.subtotal,
                theme.moneyWithCurrencyFormat
              )),
        this.cart.classList.remove(classes$H.loading),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawerIsOpen &&
          this.itemsHolder.classList.add(classes$H.updated),
        this.hasItemsInCart() ||
          this.cartEmpty
            .querySelectorAll(selectors$T.animation)
            .forEach((e) => {
              e.classList.remove(classes$H.animated);
            }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartEvents(),
        this.initQuantity(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:loaded", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        );
    }
    hasItemsInCart() {
      return 0 < this.totalItems;
    }
    buildTotalPrice(e) {
      e.original_total_price > e.total_price &&
      0 < e.cart_level_discount_applications.length
        ? (this.cartOriginalTotal.classList.remove(classes$H.hidden),
          (this.cartOriginaTotalPrice.innerHTML =
            0 === e.original_total_price
              ? window.theme.strings.free
              : themeCurrency.formatMoney(
                  e.original_total_price,
                  theme.moneyFormat
                )))
        : this.cartOriginalTotal.classList.add(classes$H.hidden),
        0 < e.cart_level_discount_applications.length
          ? ((e = this.buildCartTotalDiscounts(
              e.cart_level_discount_applications
            )),
            this.cartDiscountHolder.classList.remove(classes$H.hidden),
            (this.cartDiscountHolder.innerHTML = e))
          : this.cartDiscountHolder.classList.add(classes$H.hidden);
    }
    buildCartTotalDiscounts(e) {
      let s = "";
      return (
        e.forEach((e) => {
          var t = document.createElement("div");
          (t.innerHTML = this.cartTotalDiscountTemplate),
            (t.querySelector(selectors$T.cartTotalDiscountTitle).innerHTML =
              e.title),
            (t.querySelector(selectors$T.cartTotalDiscountAmount).innerHTML =
              themeCurrency.formatMoney(
                e.total_allocated_amount,
                theme.moneyFormat
              )),
            (s += t.innerHTML);
        }),
        s
      );
    }
    freeShippingMessageHandle(s) {
      this.freeShipping.length &&
        ((this.cartFreeShippingLimit =
          100 *
          Number(
            this.freeShipping[0].getAttribute(attributes$d.freeShippingLimit)
          ) *
          window.Shopify.currency.rate),
        this.freeShipping.forEach((e) => {
          var t =
            e.hasAttribute(attributes$d.freeShipping) &&
            "true" === e.getAttribute(attributes$d.freeShipping) &&
            0 !== s;
          e.classList.toggle(
            classes$H.success,
            t && s >= this.cartFreeShippingLimit
          );
        }));
    }
    updateProgress() {
      let section = document.querySelector('#shopify-section-announcement');
      if(section){
      let section_id = section.querySelector('[data-section-type="announcement"]')?.dataset.sectionId || section.dataset.sectionId; 
      let url = window.location.href + 'section_id='+ section_id
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
          section.querySelector('.announcement__wrapper').innerHTML = html.querySelector('.announcement__wrapper').innerHTML;
      })
    }
    }
    skipUpsellProductEvent() {
      var e;
      null !== this.upsellProductsHolder &&
        (e = this.upsellProductsHolder.querySelectorAll(
          selectors$T.buttonSkipUpsellProduct
        )).length &&
        e.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            e = t
              .closest(selectors$T.quickAddHolder)
              .getAttribute(attributes$d.quickAddHolder);
            this.skipUpsellProductsArray.includes(e) ||
              this.skipUpsellProductsArray.push(e),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(e),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      var e = window.sessionStorage.getItem("skip_upsell_products");
      e &&
        e.split(",").forEach((e) => {
          this.skipUpsellProductsArray.includes(e) ||
            this.skipUpsellProductsArray.push(e),
            this.removeUpsellProduct(e);
        });
    }
    removeUpsellProduct(e) {
      this.upsellProductsHolder &&
        (e = this.upsellProductsHolder.querySelector(
          `[${attributes$d.quickAddHolder}="${e}"]`
        )) &&
        e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      var e, t;
      this.upsellProductsHolder &&
        ((e = this.upsellProductsHolder.querySelectorAll(
          selectors$T.quickAddHolder
        )),
        (t = this.upsellProductsHolder.closest(selectors$T.cartWidget))) &&
        (t.querySelector(selectors$T.expandButton),
        t.querySelector(selectors$T.cartWidgetContent),
        t.classList.toggle(classes$H.hidden, !e.length),
        this.cartDrawer) &&
        this.cartDrawerIsOpen &&
        t.classList.toggle(classes$H.animated, e.length);
    }
    observeAdditionalCheckoutButtons() {
      var e = this.cartDrawer.querySelector(
        selectors$T.additionalCheckoutButtons
      );
      if (e) {
        const t = new MutationObserver(() => {
          this.accessibility.removeTrapFocus(),
            this.accessibility.trapFocus(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(
                selectors$T.cartToggleElement
              ),
            }),
            t.disconnect();
        });
        t.observe(e, { subtree: !0, childList: !0 });
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(selectors$T.animation).forEach((e) => {
        e.classList.remove(classes$H.animated),
          e.classList.remove(classes$H.hiding);
      });
    }
    requestItemsAnimationFrame() {
      requestAnimationFrame(this.animateItems);
    }
    animateItems() {
      this.cart.querySelectorAll(selectors$T.animation).forEach((e) => {
        e.classList.add(classes$H.animated);
      });
    }
  }
  window.cart = new CartDrawer();
  const slideUp = (e, t = 500) => {
      (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.boxSizing = "border-box"),
        (e.style.height = e.offsetHeight + "px"),
        e.offsetHeight,
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        window.setTimeout(() => {
          (e.style.display = "none"),
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property");
        }, t);
    },
    classes$G = {
      focus: "is-focused",
      open: "is-open",
      accordionToggle: "accordion-toggle",
      tabLink: "tab-link",
    },
    selectors$S = {
      inPageLink: "[data-skip-content]",
      linkesWithOnlyHash: 'a[href="#"]',
      triggerFocusElement: "[data-focus-element]",
      accordionContent: ".accordion-content",
      accordionToggle: "data-accordion-toggle",
    };
  class Accessibility {
    constructor() {
      this.init();
    }
    init() {
      (this.a11y = a11y),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(selectors$S.inPageLink)),
        (this.linkesWithOnlyHash = document.querySelectorAll(
          selectors$S.linkesWithOnlyHash
        )),
        (this.lastFocused = null),
        (this.isFocused = !1),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents(),
        this.focusEventsOff(),
        this.closeExpandedElements();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (e) => {
          e.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("keyup", (e) => {
        e.code === window.theme.keyboardKeys.TAB &&
          (this.body.classList.add(classes$G.focus), (this.isFocused = !0));
      }),
        document.addEventListener("keyup", (e) => {
          var t, s, i, o;
          this.isFocused &&
            ((t = e.target),
            (e =
              e.code === window.theme.keyboardKeys.ENTER ||
              e.code === window.theme.keyboardKeys.SPACE),
            (s =
              t.matches(selectors$S.triggerFocusElement) ||
              t.closest(selectors$S.triggerFocusElement)),
            (i =
              t.classList.contains(classes$G.accordionToggle) ||
              t.parentNode.classList.contains(classes$G.accordionToggle) ||
              t.hasAttribute(selectors$S.accordionToggle) ||
              t.parentNode.hasAttribute(selectors$S.accordionToggle)),
            (o =
              t.classList.contains(classes$G.tabLink) ||
              t.parentNode.classList.contains(classes$G.tabLink)),
            e) &&
            s &&
            (null === this.lastFocused && (this.lastFocused = t),
            i && t.click(),
            o) &&
            t.click();
        }),
        document.addEventListener("theme:cart:add", (e) => {
          this.lastFocused = e.detail.selector;
        });
    }
    focusEventsOff() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(classes$G.focus), (this.isFocused = !1);
      });
    }
    closeExpandedElements() {
      document.addEventListener("keyup", (e) => {
        if (e.code === window.theme.keyboardKeys.ESCAPE) {
          var t = document.querySelectorAll(selectors$S.accordionContent);
          if (t.length)
            for (let e = 0; e < t.length; e++)
              "block" === t[e].style.display &&
                (t[e].previousElementSibling.classList.remove(classes$G.open),
                slideUp(t[e]));
          null !== this.lastFocused &&
            setTimeout(() => {
              this.lastFocused.focus(), (this.lastFocused = null);
            }, 600);
        }
      });
    }
  }
  (window.accessibility = new Accessibility()),
    (theme.ProductModel = (function () {
      let o = {},
        a = {},
        n = {};
      const l = {
          productMediaWrapper: "[data-product-single-media-wrapper]",
          productSlideshow: "[data-product-slideshow]",
          productXr: "[data-shopify-xr]",
          dataMediaId: "data-media-id",
          dataModelId: "data-model-id",
          dataModel3d: "data-shopify-model3d-id",
          modelViewer: "model-viewer",
          modelJson: "#ModelJson-",
          classMediaHidden: "media--hidden",
          deferredMedia: "[data-deferred-media]",
          deferredMediaButton: "[data-deferred-media-button]",
        },
        c = { isLoading: "is-loading" };
      function i(e, t) {
        var s, i, o, r;
        e.querySelector(l.deferredMedia).getAttribute("loaded") ||
          (e.classList.add(c.isLoading),
          (s = document.createElement("div")).appendChild(
            e.querySelector("template").content.firstElementChild.cloneNode(!0)
          ),
          (s = s.querySelector("model-viewer")),
          (i = e.querySelector(l.deferredMedia)).appendChild(s).focus(),
          i.setAttribute("loaded", !0),
          (i = e.dataset.mediaId),
          (o = s.dataset.modelId),
          (r = e
            .closest(l.productSlideshow)
            .parentElement.querySelector(l.productXr)),
          (n[t] = { element: r, defaultId: o }),
          (a[i] = {
            modelId: o,
            mediaId: i,
            sectionId: t,
            container: e,
            element: s,
          }),
          window.Shopify.loadFeatures([
            { name: "shopify-xr", version: "1.0", onLoad: d },
            { name: "model-viewer-ui", version: "1.0", onLoad: h },
          ]));
      }
      function d(e) {
        if (e) console.warn(e);
        else if (window.ShopifyXR) {
          for (const i in o) {
            var t, s;
            !o.hasOwnProperty(i) ||
              (t = o[i]).loaded ||
              ((s = document.querySelector("" + l.modelJson + i)) &&
                (window.ShopifyXR.addModels(JSON.parse(s.innerHTML)),
                (t.loaded = !0)));
          }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            d();
          });
      }
      function h(e) {
        if (e) console.warn(e);
        else
          for (const s in a) {
            var t;
            a.hasOwnProperty(s) &&
              ((t = a[s]).modelViewerUi ||
                (t.modelViewerUi = new Shopify.ModelViewerUI(t.element)),
              (function (e) {
                const t = n[e.sectionId];
                e.container.addEventListener(
                  "theme:media:visible",
                  function () {
                    t.element.setAttribute(l.dataModel3d, e.modelId),
                      r(e.mediaId),
                      window.theme.touch || e.modelViewerUi.play();
                  }
                ),
                  e.container.addEventListener(
                    "theme:media:hidden",
                    function () {
                      e.modelViewerUi.pause();
                    }
                  ),
                  e.container.addEventListener("xrLaunch", function () {
                    e.modelViewerUi.pause();
                  }),
                  e.element.addEventListener("load", () => {
                    e.container.classList.remove(c.isLoading), r(e.mediaId);
                  }),
                  e.element.addEventListener(
                    "shopify_model_viewer_ui_toggle_play",
                    function () {
                      r(e.mediaId);
                    }
                  );
              })(t));
          }
      }
      function r(e) {
        var e = `[${l.dataMediaId}="${e}"]`,
          t = document.querySelector(l.productMediaWrapper + e),
          e = document.querySelectorAll(l.productMediaWrapper + `:not(${e})`);
        t.classList.remove(l.classMediaHidden),
          e.length &&
            e.forEach((e) => {
              e.dispatchEvent(new CustomEvent("theme:media:hidden")),
                e.classList.add(l.classMediaHidden);
            });
      }
      return {
        init: function (e, t) {
          o[t] = { loaded: !1 };
          var s = e.querySelector(l.deferredMediaButton);
          s && s.addEventListener("click", i.bind(this, e, t));
        },
        loadContent: i,
        removeSectionModels: function (e) {
          for (const t in a)
            a.hasOwnProperty(t) && a[t].sectionId === e && delete a[t];
          delete o[e], delete theme.mediaInstances[e];
        },
      };
    })());
  const selectors$R = {
    templateAddresses: ".template-addresses",
    addressNewForm: "#AddressNewForm",
    btnNew: ".address-new-toggle",
    btnEdit: ".address-edit-toggle",
    btnDelete: ".address-delete",
    classHide: "hide",
    dataFormId: "data-form-id",
    dataConfirmMessage: "data-confirm-message",
    editAddress: "#EditAddress",
    addressCountryNew: "AddressCountryNew",
    addressProvinceNew: "AddressProvinceNew",
    addressProvinceContainerNew: "AddressProvinceContainerNew",
    addressCountryOption: ".address-country-option",
    addressCountry: "AddressCountry",
    addressProvince: "AddressProvince",
    addressProvinceContainer: "AddressProvinceContainer",
  };
  class Addresses {
    constructor(e) {
      (this.section = e),
        (this.addressNewForm = this.section.querySelector(
          selectors$R.addressNewForm
        )),
        this.init();
    }
    init() {
      if (this.addressNewForm) {
        const t = this.section,
          s = this.addressNewForm;
        this.customerAddresses();
        var e = t.querySelectorAll(selectors$R.btnNew),
          e =
            (e.length &&
              e.forEach((e) => {
                e.addEventListener("click", function () {
                  s.classList.toggle(selectors$R.classHide);
                });
              }),
            t.querySelectorAll(selectors$R.btnEdit)),
          e =
            (e.length &&
              e.forEach((e) => {
                e.addEventListener("click", function () {
                  var e = this.getAttribute(selectors$R.dataFormId);
                  t.querySelector(
                    selectors$R.editAddress + "_" + e
                  ).classList.toggle(selectors$R.classHide);
                });
              }),
            t.querySelectorAll(selectors$R.btnDelete));
        e.length &&
          e.forEach((e) => {
            e.addEventListener("click", function () {
              var e = this.getAttribute(selectors$R.dataFormId),
                t = this.getAttribute(selectors$R.dataConfirmMessage);
              confirm(t) &&
                Shopify.postLink(window.theme.routes.addresses_url + "/" + e, {
                  parameters: { _method: "delete" },
                });
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(
          selectors$R.addressCountryNew,
          selectors$R.addressProvinceNew,
          { hideElement: selectors$R.addressProvinceContainerNew }
        ),
        this.section
          .querySelectorAll(selectors$R.addressCountryOption)
          .forEach((e) => {
            var e = e.getAttribute(selectors$R.dataFormId),
              t = selectors$R.addressCountry + "_" + e,
              s = selectors$R.addressProvince + "_" + e,
              e = selectors$R.addressProvinceContainer + "_" + e;
            new Shopify.CountryProvinceSelector(t, s, { hideElement: e });
          });
    }
  }
  const template$1 = document.querySelector(selectors$R.templateAddresses),
    selectors$Q =
      (template$1 && new Addresses(template$1),
      {
        accountTemplateLogged: ".customer-logged-in",
        account: ".account",
        accountSidebarMobile: ".account-sidebar--mobile",
      });
  class Account {
    constructor(e) {
      (this.section = e), this.init();
    }
    init() {
      this.section.querySelector(selectors$Q.account) &&
        this.accountMobileSidebar();
    }
    accountMobileSidebar() {
      this.section.querySelector(selectors$Q.accountSidebarMobile) &&
        this.section
          .querySelector(selectors$Q.accountSidebarMobile)
          .addEventListener("click", function () {
            var e = this.nextElementSibling;
            e && "UL" === e.tagName && e.classList.toggle("visible");
          });
    }
  }
  const template = document.querySelector(selectors$Q.accountTemplateLogged),
    selectors$P =
      (template && new Account(template),
      {
        form: "[data-account-form]",
        showReset: "[data-show-reset]",
        hideReset: "[data-hide-reset]",
        recover: "[data-recover-password]",
        recoverSuccess: "[data-recover-success]",
        login: "[data-login-form]",
        recoverHash: "#recover",
        hideClass: "is-hidden",
      });
  class Login {
    constructor(e) {
      (this.form = e),
        (this.showButton = e.querySelector(selectors$P.showReset)),
        (this.hideButton = e.querySelector(selectors$P.hideReset)),
        (this.recover = e.querySelector(selectors$P.recover)),
        (this.recoverSuccess = e.querySelector(selectors$P.recoverSuccess)),
        (this.login = e.querySelector(selectors$P.login)),
        this.init();
    }
    init() {
      window.location.hash == selectors$P.recoverHash || this.recoverSuccess
        ? this.showRecoverPasswordForm()
        : this.hideRecoverPasswordForm(),
        this.showButton.addEventListener(
          "click",
          function (e) {
            e.preventDefault(), this.showRecoverPasswordForm();
          }.bind(this),
          !1
        ),
        this.hideButton.addEventListener(
          "click",
          function (e) {
            e.preventDefault(), this.hideRecoverPasswordForm();
          }.bind(this),
          !1
        );
    }
    showRecoverPasswordForm() {
      return (
        this.login.classList.add(selectors$P.hideClass),
        this.recover.classList.remove(selectors$P.hideClass),
        (window.location.hash = selectors$P.recoverHash),
        !1
      );
    }
    hideRecoverPasswordForm() {
      return (
        this.recover.classList.add(selectors$P.hideClass),
        this.login.classList.remove(selectors$P.hideClass),
        (window.location.hash = ""),
        !1
      );
    }
  }
  const loginForm = document.querySelector(selectors$P.form),
    registered =
      (loginForm && new Login(loginForm),
      (window.Shopify = window.Shopify || {}),
      (window.Shopify.theme = window.Shopify.theme || {}),
      (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
      (window.Shopify.theme.sections.registered =
        window.Shopify.theme.sections.registered || {}),
      (window.Shopify.theme.sections.instances =
        window.Shopify.theme.sections.instances || []),
      window.Shopify.theme.sections.registered),
    instances = window.Shopify.theme.sections.instances,
    selectors$O = { id: "data-section-id", type: "data-section-type" };
  class Registration {
    constructor(e = null, t = []) {
      (this.type = e),
        (this.components = validateComponentsArray(t)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        t.forEach((e) => {
          for (var [t, s] of Object.entries(e)) {
            var i = this.callStack[t];
            Array.isArray(i) && "function" == typeof s
              ? i.push(s)
              : (console.warn(
                  `Unregisted function: '${t}' in component: '${this.type}'`
                ),
                console.warn(s));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class Section {
    constructor(e, t) {
      (this.container = validateContainerElement(e)),
        (this.id = e.getAttribute(selectors$O.id)),
        (this.type = t.type),
        (this.callStack = t.getStack());
      try {
        this.onLoad();
      } catch (e) {
        console.warn("Error in section: " + this.id),
          console.warn(this),
          console.warn(e);
      }
    }
    callFunctions(e, s = null) {
      this.callStack[e].forEach((e) => {
        var t = { id: this.id, type: this.type, container: this.container };
        s ? e.call(t, s) : e.call(t);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(e) {
      this.callFunctions("onSelect", e);
    }
    onDeselect(e) {
      this.callFunctions("onDeselect", e);
    }
    onBlockSelect(e) {
      this.callFunctions("onBlockSelect", e);
    }
    onBlockDeselect(e) {
      this.callFunctions("onBlockDeselect", e);
    }
    onReorder(e) {
      this.callFunctions("onReorder", e);
    }
  }
  function validateContainerElement(e) {
    if (!(e instanceof Element))
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    if (null === e.getAttribute(selectors$O.id))
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " +
          selectors$O.id +
          " attribute."
      );
    return e;
  }
  function validateComponentsArray(e) {
    if ((void 0 !== e && "object" != typeof e) || null === e)
      throw new TypeError(
        "Theme Sections: The components object provided is not a valid"
      );
    return e;
  }
  function register(e, t) {
    if ("string" != typeof e)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== registered[e])
      throw new Error(
        'Theme Sections: A section of type "' +
          e +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(t) || (t = [t]);
    t = new Registration(e, t);
    (registered[e] = t), registered;
  }
  function load(e, i) {
    (e = normalizeType(e)),
      (i = normalizeContainers(
        (i =
          void 0 === i
            ? document.querySelectorAll("[" + selectors$O.type + "]")
            : i)
      )),
      e.forEach(function (t) {
        const s = registered[t];
        void 0 !== s &&
          (i = i.filter(function (e) {
            if (!isInstance(e) && null !== e.getAttribute(selectors$O.type)) {
              if (e.getAttribute(selectors$O.type) !== t) return !0;
              instances.push(new Section(e, s));
            }
            return !1;
          }));
      });
  }
  function reorder(e) {
    getInstances(e).forEach(function (e) {
      e.onReorder();
    });
  }
  function unload(e) {
    getInstances(e).forEach(function (e) {
      var t = instances
        .map(function (e) {
          return e.id;
        })
        .indexOf(e.id);
      instances.splice(t, 1), e.onUnload();
    });
  }
  function getInstances(e) {
    var t,
      s = [];
    return (
      (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) && (t = e[0]),
      e instanceof Element || t instanceof Element
        ? normalizeContainers(e).forEach(function (t) {
            s = s.concat(
              instances.filter(function (e) {
                return e.container === t;
              })
            );
          })
        : ("string" != typeof e && "string" != typeof t) ||
          normalizeType(e).forEach(function (t) {
            s = s.concat(
              instances.filter(function (e) {
                return e.type === t;
              })
            );
          }),
      s
    );
  }
  function getInstanceById(e) {
    for (var t, s = 0; s < instances.length; s++)
      if (instances[s].id === e) {
        t = instances[s];
        break;
      }
    return t;
  }
  function isInstance(e) {
    return 0 < getInstances(e).length;
  }
  function normalizeType(e) {
    return (
      "*" === e
        ? (e = Object.keys(registered))
        : "string" == typeof e
        ? (e = [e])
        : e.constructor === Section
        ? (e = [e.prototype.type])
        : Array.isArray(e) &&
          e[0].constructor === Section &&
          (e = e.map(function (e) {
            return e.type;
          })),
      (e = e.map(function (e) {
        return e.toLowerCase();
      }))
    );
  }
  function normalizeContainers(e) {
    return (
      NodeList.prototype.isPrototypeOf(e) && 0 < e.length
        ? (e = Array.prototype.slice.call(e))
        : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
        ? (e = [])
        : !Array.isArray(e) && e instanceof Element && (e = [e]),
      e
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (e) {
      var t = e.detail.sectionId,
        e = e.target.querySelector("[" + selectors$O.id + '="' + t + '"]');
      null !== e && load(e.getAttribute(selectors$O.type), e);
    }),
    document.addEventListener("shopify:section:reorder", function (e) {
      var t = e.detail.sectionId,
        e = e.target.querySelector("[" + selectors$O.id + '="' + t + '"]');
      "object" == typeof getInstances(e)[0] && reorder(e);
    }),
    document.addEventListener("shopify:section:unload", function (e) {
      var t = e.detail.sectionId,
        e = e.target.querySelector("[" + selectors$O.id + '="' + t + '"]');
      "object" == typeof getInstances(e)[0] && unload(e);
    }),
    document.addEventListener("shopify:section:select", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onSelect(e);
    }),
    document.addEventListener("shopify:section:deselect", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onDeselect(e);
    }),
    document.addEventListener("shopify:block:select", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onBlockSelect(e);
    }),
    document.addEventListener("shopify:block:deselect", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onBlockDeselect(e);
    }));
  const selectors$N = {
      aos: "[data-aos]",
      collectionImage: ".collection-item__image",
      columnImage: ".column__image__wrapper",
      flickityNextArrow: ".flickity-button.next",
      flickityPrevArrow: ".flickity-button.previous",
      heroContent: ".hero__content",
      heroContentWrapper: ".hero__content__wrapper",
      link: "a:not(.hero__btn)",
      nextArrow: "[data-next-arrow]",
      prevArrow: "[data-prev-arrow]",
      productItemImage: ".product-item__image",
      slide: "[data-slide]",
      slideValue: "data-slide",
      slider: "[data-slider]",
      sliderThumb: "[data-slider-thumb]",
      slideshowSlideImg: ".slide-image-img",
    },
    attributes$c = {
      arrowPositionMiddle: "data-arrow-position-middle",
      aspectRatio: "data-aspectratio",
      equalizeHeight: "data-equalize-height",
      setHeight: "data-set-height",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slidesDesktop: "data-slides-desktop",
      slidesLargeDesktop: "data-slides-large-desktop",
      slidesMobileDesktop: "data-slides-mobile",
      slidesTabletDesktop: "data-slides-tablet",
      slideTextColor: "data-slide-text-color",
    },
    classes$F = {
      aosAnimate: "aos-animate",
      focused: "is-focused",
      flickityResize: "flickity-resize",
      flickityResizing: "flickity-resizing",
      flickityEnabled: "flickity-enabled",
      heroContentTransparent: "hero__content--transparent",
      initialized: "is-initialized",
      isLoading: "is-loading",
      isSelected: "is-selected",
      sliderArrowsHidden: "flickity-button-hide",
      sliderInitialized: "js-slider--initialized",
    },
    sections$q = {};
  class Slider {
    constructor(e, t = null) {
      (this.container = e),
        (this.slideshow =
          t || this.container.querySelector(selectors$N.slider)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(
            selectors$N.slide
          )),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderPrev = this.container.querySelector(
              selectors$N.prevArrow
            )),
            (this.sliderNext = this.container.querySelector(
              selectors$N.nextArrow
            )),
            (this.sliderThumbs = this.container.querySelectorAll(
              selectors$N.sliderThumb
            )),
            (this.multipleSlides = this.slideshow.hasAttribute(
              attributes$c.slidesLargeDesktop
            )),
            (this.isHeightEqualized =
              "true" ===
              this.slideshow.getAttribute(attributes$c.equalizeHeight)),
            (this.setMinHeightFlag =
              "true" === this.slideshow.getAttribute(attributes$c.setHeight)),
            (this.sliderCallbackEventOnResize = () =>
              this.sliderCallbackEvent()),
            (this.addRemoveSlidesForDevicesOnResize = () =>
              this.addRemoveSlidesForDevices()),
            (this.resetSliderEvent = () => this.resetSlider()),
            this.slideshow.hasAttribute(attributes$c.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(attributes$c.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
    init() {
      this.slideshow.classList.add(classes$F.isLoading),
        this.setMinHeight(),
        (this.sliderOptions = {
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(classes$F.initialized),
                  this.slideshow.classList.remove(classes$F.isLoading),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons &&
                  (this.initArrows(), this.positionArrows());
            },
            change: () => {
              this.flkty.selectedElement
                .querySelectorAll(selectors$N.aos)
                .forEach((e) => {
                  e.classList.remove(classes$F.aosAnimate),
                    requestAnimationFrame(() => {
                      e.classList.add(classes$F.aosAnimate);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new FlickityFade(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new Flickity(this.slideshow, this.sliderOptions)),
        this.isHeightEqualized && this.equalizeHeight(),
        this.sliderPrev &&
          this.sliderPrev.addEventListener("click", (e) => {
            e.preventDefault(), this.flkty.previous(!0);
          }),
        this.sliderNext &&
          this.sliderNext.addEventListener("click", (e) => {
            e.preventDefault(), this.flkty.next(!0);
          }),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.addRemoveSlidesForDevices(),
        document.addEventListener(
          "theme:resize",
          this.addRemoveSlidesForDevicesOnResize
        ),
        (this.setMinHeightFlag || this.multipleSlides) &&
          document.addEventListener(
            "theme:resize",
            this.sliderCallbackEventOnResize
          ),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              e = [...t.parentElement.children].indexOf(t);
              this.flkty.select(e);
            });
          }),
        this.container.addEventListener(
          "theme:tab:change",
          this.resetSliderEvent
        );
    }
    resetSlider() {
      this.slideshow &&
        (this.flkty && this.flkty.isActive
          ? this.flkty.select(0, !1, !0)
          : this.slideshow.scrollTo({ left: 0, behavior: "auto" }));
    }
    addRemoveSlidesForDevices() {
      if (
        ((this.hasDiffSlidesForMobileDesktop =
          0 <
          Array.prototype.filter.call(this.slideshowSlides, (e) => {
            if (
              e.classList.contains("desktop") ||
              e.classList.contains("mobile")
            )
              return e;
          }).length),
        this.hasDiffSlidesForMobileDesktop)
      ) {
        var t =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        let e = null;
        (e =
          t < theme.sizes.small
            ? `${selectors$N.slide}.mobile, ${selectors$N.slide}:not(.desktop)`
            : `${selectors$N.slide}.desktop, ${selectors$N.slide}:not(.mobile)`),
          (this.flkty.options.cellSelector = e),
          this.flkty.selectCell(0, !1, !0),
          this.flkty.reloadCells(),
          this.flkty.reposition(),
          this.flkty.resize(),
          this.slideActions();
      }
    }
    sliderCallbackEvent() {
      this.setMinHeight(),
        this.multipleSlides &&
          (this.sliderOptions.prevNextButtons && this.initArrows(),
          this.flkty.resize(),
          this.slideshow.classList.contains(classes$F.sliderInitialized) ||
            this.flkty.select(0));
    }
    slideActions(e = !1) {
      var t = this.slideshow.querySelector("." + classes$F.isSelected),
        s = t.getAttribute(attributes$c.slideTextColor),
        i = t.querySelector(selectors$N.link),
        o = this.slideshow.querySelectorAll(
          `${selectors$N.slide} a, ${selectors$N.slide} button`
        );
      document.body.classList.contains(classes$F.focused) &&
        i &&
        this.sliderOptions.groupCells &&
        e &&
        i.focus(),
        o.length &&
          o.forEach((e) => {
            var t = e.closest(selectors$N.slide);
            t &&
              ((t = t.classList.contains(classes$F.isSelected) ? 0 : -1),
              e.setAttribute("tabindex", t));
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.setMinHeight(),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          t.hasAttribute(attributes$c.slideIndex) &&
          ((e = parseInt(t.getAttribute(attributes$c.slideIndex))),
          (i = this.container.querySelector(
            selectors$N.sliderThumb + "." + classes$F.isSelected
          )) && i.classList.remove(classes$F.isSelected),
          this.sliderThumbs[e].classList.add(classes$F.isSelected));
    }
    setMinHeight() {
      this.setMinHeightFlag &&
        this.slideshowSlides.forEach((e) => {
          var t = e.querySelector(selectors$N.slideshowSlideImg);
          let s = "",
            i =
              (t &&
                t.hasAttribute(attributes$c.aspectRatio) &&
                (s = t.getAttribute(attributes$c.aspectRatio)),
              0);
          (t = e.querySelector(selectors$N.heroContent)),
            t &&
              ((r = parseInt(window.getComputedStyle(t).marginTop)),
              (a = parseInt(window.getComputedStyle(t).marginBottom)),
              (i = t.offsetHeight + (r + a))),
            (t = parseInt(getComputedStyle(e, null).width.replace("px", "")));
          let o = parseInt(t / s) || 0;
          var r = e.classList.contains(classes$F.isSelected),
            a = `calc(${(o = i > o ? i : o)}px + var(--header-padding))`,
            t =
              (e.style.setProperty("min-height", a),
              e.querySelector(selectors$N.heroContentWrapper));
          t && t.style.setProperty("min-height", a),
            r &&
              this.slideshow.parentElement.style.setProperty("min-height", a);
        });
    }
    positionArrows() {
      var e;
      this.slideshow.hasAttribute(attributes$c.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons &&
        (e =
          this.slideshow.querySelector(selectors$N.collectionImage) ||
          this.slideshow.querySelector(selectors$N.productItemImage) ||
          this.slideshow.querySelector(selectors$N.columnImage)) &&
        ((this.slideshow.querySelector(
          selectors$N.flickityPrevArrow
        ).style.top = e.clientHeight / 2 + "px"),
        (this.slideshow.querySelector(selectors$N.flickityNextArrow).style.top =
          e.clientHeight / 2 + "px"));
    }
    initArrows() {
      var e, t, s, i, o;
      this.multipleSlides &&
        ((e = parseInt(
          this.slideshow.getAttribute(attributes$c.slidesLargeDesktop)
        )),
        (i =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth),
        (t = this.slideshow.hasAttribute(attributes$c.slidesDesktop)
          ? parseInt(this.slideshow.getAttribute(attributes$c.slidesDesktop))
          : 3),
        (s = this.slideshow.hasAttribute(attributes$c.slidesTabletDesktop)
          ? parseInt(
              this.slideshow.getAttribute(attributes$c.slidesTabletDesktop)
            )
          : 2),
        (o = this.slideshow.hasAttribute(attributes$c.slidesMobileDesktop)
          ? parseInt(
              this.slideshow.getAttribute(attributes$c.slidesMobileDesktop)
            )
          : 1),
        (e = 1339 < i && this.slideshowSlides.length > e),
        (t = i <= 1339 && 1023 < i && this.slideshowSlides.length > t),
        (s = i <= 1023 && 749 < i && this.slideshowSlides.length > s),
        (i = i <= 749 && this.slideshowSlides.length > o),
        (o = Boolean(e || t || s || i)),
        this.slideshow.classList.toggle(classes$F.sliderArrowsHidden, !o),
        this.slideshow.classList.toggle(classes$F.sliderInitialized, o));
    }
    equalizeHeight() {
      (Flickity.prototype._createResizeClass = function () {
        requestAnimationFrame(() => {
          this.element.classList.add(classes$F.flickityResize);
        });
      }),
        this.flkty._createResizeClass();
      const e = Flickity.prototype.resize;
      Flickity.prototype.resize = function () {
        this.element.classList.remove(classes$F.flickityResize),
          this.element.classList.add(classes$F.flickityResizing),
          e.call(this),
          requestAnimationFrame(() => {
            this.element.classList.add(classes$F.flickityResize),
              this.element.classList.remove(classes$F.flickityResizing);
          });
      };
    }
    onUnload() {
      (this.setMinHeightFlag || this.multipleSlides) &&
        document.removeEventListener(
          "theme:resize",
          this.sliderCallbackEventOnResize
        ),
        this.slideshow &&
          this.flkty &&
          ((this.flkty.options.watchCSS = !1), this.flkty.destroy()),
        this.container.removeEventListener(
          "theme:tab:change",
          this.resetSliderEvent
        ),
        document.removeEventListener(
          "theme:resize",
          this.addRemoveSlidesForDevicesOnResize
        );
    }
    onBlockSelect(t) {
      if (this.slideshow) {
        t = this.slideshow.querySelector(
          `[${selectors$N.slideValue}="${t.detail.blockId}"]`
        );
        if (t) {
          let e = parseInt(t.getAttribute(attributes$c.slideIndex));
          this.multipleSlides &&
            !this.slideshow.classList.contains(classes$F.sliderInitialized) &&
            (e = 0),
            this.slideshow.classList.add(classes$F.isSelected),
            this.flkty &&
              this.slideshow.classList.contains(classes$F.flickityEnabled) &&
              (this.flkty.selectCell(e), this.flkty.stopPlayer());
        }
      }
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(classes$F.isSelected), this.flkty) &&
        this.sliderOptions.hasOwnProperty("autoPlay") &&
        this.sliderOptions.autoPlay &&
        this.flkty.playPlayer();
    }
  }
  const slider = {
      onLoad() {
        (sections$q[this.id] = []),
          this.container.querySelectorAll(selectors$N.slider).forEach((e) => {
            sections$q[this.id].push(new Slider(this.container, e));
          });
      },
      onUnload() {
        sections$q[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
      onBlockSelect(t) {
        sections$q[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        sections$q[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    throttle = (i, o) => {
      let r, a;
      return function e(...t) {
        var s = Date.now();
        (a = clearTimeout(a)),
          !r || s - r >= o
            ? (i.apply(null, t), (r = s))
            : (a = setTimeout(e.bind(null, ...t), o - (s - r)));
      };
    },
    selectors$M = {
      tooltip: "data-tooltip",
      tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
    },
    classes$E = {
      tooltipDefault: "tooltip-default",
      visible: "is-visible",
      hiding: "is-hiding",
    };
  let sections$p = {};
  class Tooltip {
    constructor(e, t = {}) {
      (this.tooltip = e),
        this.tooltip.hasAttribute(selectors$M.tooltip) &&
          ((this.label = this.tooltip.getAttribute(selectors$M.tooltip)),
          (this.class = t.class || classes$E.tooltipDefault),
          (this.transitionSpeed = t.transitionSpeed || 200),
          (this.hideTransitionTimeout = 0),
          (this.addPinEvent = () => this.addPin()),
          (this.addPinMouseEvent = () => this.addPin(!0)),
          (this.removePinEvent = (e) => throttle(this.removePin(e), 50)),
          (this.removePinMouseEvent = (e) => this.removePin(e, !0, !0)),
          this.init());
    }
    init() {
      var e, t;
      document.querySelector("." + this.class) ||
        ((e = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`),
        ((t = document.createElement("div")).className = this.class),
        (t.innerHTML = e),
        document.body.appendChild(t)),
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent);
    }
    addPin(t = !1) {
      var s = document.querySelector("." + this.class);
      if (
        s &&
        ((t && !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) ||
          !t)
      ) {
        var t = s.querySelector(`.${this.class}__arrow`),
          i = s.querySelector(`.${this.class}__inner`),
          o =
            ((s.querySelector(`.${this.class}__text`).textContent = this.label),
            window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth),
          r = i.offsetWidth,
          a = this.tooltip.getBoundingClientRect(),
          n = a.top,
          l = a.width,
          n = n + a.height + window.scrollY;
        let e = a.left - r / 2 + l / 2;
        r = e + r - o;
        0 < r && (e -= r),
          e < 0 && (e = 0),
          (t.style.left = a.left + l / 2 + "px"),
          s.style.setProperty("--tooltip-top", n + "px"),
          (i.style.transform = `translateX(${e}px)`),
          s.classList.remove(classes$E.hiding),
          s.classList.add(classes$E.visible),
          document.addEventListener("theme:scroll", this.removePinEvent);
      }
    }
    removePin(e, t = !1, s = !1) {
      const i = document.querySelector("." + this.class);
      var o = i.classList.contains(classes$E.visible);
      i &&
        ((t && !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) ||
          !t) &&
        (o &&
          (s || e.detail.hideTransition) &&
          (i.classList.add(classes$E.hiding),
          this.hideTransitionTimeout &&
            clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            i.classList.remove(classes$E.hiding);
          }, this.transitionSpeed))),
        i.classList.remove(classes$E.visible),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener(
          "mouseleave",
          this.removePinMouseEvent
        ),
        this.tooltip.removeEventListener(
          "theme:tooltip:init",
          this.addPinEvent
        ),
        document.removeEventListener(
          "theme:tooltip:close",
          this.removePinEvent
        ),
        document.removeEventListener("theme:scroll", this.removePinEvent);
    }
  }
  const tooltipSection = {
      onLoad() {
        (sections$p[this.id] = []),
          this.container
            .querySelectorAll(`[${selectors$M.tooltip}]`)
            .forEach((e) => {
              sections$p[this.id].push(new Tooltip(e));
            });
      },
      onUnload: function () {
        sections$p[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    slideDown = (e, t = 500, s = "block", i = !0) => {
      let o = window.getComputedStyle(e).display;
      (i && "none" !== o) ||
        (e.style.removeProperty("display"),
        "none" === o && (o = s),
        (e.style.display = o),
        (i = e.offsetHeight),
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.boxSizing = "border-box"),
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.height = i + "px"),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property");
        }, t));
    },
    slideToggle = (e, t = 500, s = "block") =>
      "none" === window.getComputedStyle(e).display
        ? slideDown(e, t, s)
        : slideUp(e, t);
  var sections$o = {};
  const parallaxHero = {
      onLoad() {
        (sections$o[this.id] = []),
          this.container
            .querySelectorAll("[data-parallax-wrapper]")
            .forEach((e) => {
              var t = e.querySelector("[data-parallax-img]");
              sections$o[this.id].push(
                new Rellax(t, { center: !0, round: !0, frame: e })
              );
            }),
          window.addEventListener("load", () => {
            sections$o[this.id].forEach((e) => {
              "function" == typeof e.refresh && e.refresh();
            });
          });
      },
      onUnload: function () {
        sections$o[this.id].forEach((e) => {
          "function" == typeof e.destroy && e.destroy();
        });
      },
    },
    selectors$L = {
      sidebar: ".sidebar",
      widgetCategories: ".widget--categories",
      widgetLinksEl: ".widget__links",
      widgetLinks: ".widget__links .has-sub-nav > a",
      widgetLinksSub: ".widget__links .submenu > li > a",
      listEl: "li",
      linkEl: "a",
      articleSingle: ".article--single",
      sidebarContents: ".sidebar__contents",
      hasSubNav: ".has-sub-nav",
    },
    classes$D = { open: "is-open", active: "is-active", submenu: "submenu" },
    sections$n = {};
  class Article {
    constructor(e) {
      (this.container = e.container),
        (this.sidebar = this.container.querySelector(selectors$L.sidebar)),
        (this.widgetCategories = this.container.querySelector(
          selectors$L.widgetCategories
        )),
        (this.resizeEvent = () => this.categories()),
        this.init();
    }
    init() {
      this.sidebar && this.sidebarNav();
    }
    sidebarNav() {
      this.navStates(),
        this.container.addEventListener("click", (e) => {
          var t = e.target.tagName.toLowerCase() === selectors$L.linkEl,
            s = e.target.closest(
              "" + selectors$L.listEl + selectors$L.hasSubNav
            ),
            i = e.target.closest(selectors$L.widgetLinksEl),
            o = e.target.nextElementSibling;
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) < theme.sizes.small ||
            !(t && s && i) ||
            !o ||
            (o.parentElement.classList.toggle(classes$D.active),
            o.classList.toggle(classes$D.open),
            o.setAttribute(
              "aria-expanded",
              o.classList.contains(classes$D.open)
            ),
            slideToggle(o),
            e.preventDefault());
        }),
        this.widgetCategories &&
          ((this.widgetCategoriesNext = this.widgetCategories.nextSibling),
          (this.widgetCategoriesParentNode = this.widgetCategories.parentNode),
          this.categories(),
          document.addEventListener("theme:resize", this.resizeEvent));
    }
    navStates() {
      var e = this.container.querySelectorAll(
        selectors$L.widgetLinks + ", " + selectors$L.widgetLinksSub
      );
      e.length &&
        e.forEach((e) => {
          var t;
          e.getAttribute("href") === window.location.pathname &&
            ((t = e.closest(selectors$L.hasSubNav)),
            e.closest("li").classList.add(classes$D.active),
            t) &&
            (t.classList.add(classes$D.active),
            (e = t.querySelector("." + classes$D.submenu))) &&
            (e.classList.toggle(classes$D.open),
            e.setAttribute(
              "aria-expanded",
              e.classList.contains(classes$D.open)
            ),
            showElement(e));
        });
    }
    categories() {
      var e =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) < theme.sizes.small,
        t = document.querySelector(selectors$L.widgetCategories);
      e
        ? document.querySelector(selectors$L.articleSingle).prepend(t)
        : this.widgetCategoriesParentNode.insertBefore(
            t,
            this.widgetCategoriesNext
          );
    }
    onUnload() {
      this.widgetCategories &&
        document.removeEventListener("theme:resize", this.resizeEvent);
    }
  }
  const articleSection = {
      onLoad() {
        sections$n[this.id] = new Article(this);
      },
      onUnload(e) {
        sections$n[this.id].onUnload(e);
      },
    },
    selectors$K =
      (register("article", [
        articleSection,
        slider,
        tooltipSection,
        parallaxHero,
      ]),
      register("blog-section", [slider]),
      register("hero", parallaxHero),
      register("double", slider),
      {
        popoutWrapper: "[data-popout]",
        popoutList: "[data-popout-list]",
        popoutToggle: "[data-popout-toggle]",
        popoutToggleText: "[data-popout-toggle-text]",
        popoutToggleTextValue: "data-popout-toggle-text",
        popoutInput: "[data-popout-input]",
        popoutOptions: "[data-popout-option]",
        popoutPrevent: "data-popout-prevent",
        popoutQuantity: "data-quantity-field",
        dataValue: "data-value",
        ariaExpanded: "aria-expanded",
        ariaCurrent: "aria-current",
        productGridImage: "[data-product-image]",
        productGrid: "[data-product-grid-item]",
      }),
    classes$C = {
      listVisible: "popout-list--visible",
      visible: "is-visible",
      active: "is-active",
      selectPopoutTop: "select-popout--top",
    };
  let sections$m = {};
  class Popout {
    constructor(e) {
      (this.container = e),
        (this.popoutList = this.container.querySelector(
          selectors$K.popoutList
        )),
        (this.popoutToggle = this.container.querySelector(
          selectors$K.popoutToggle
        )),
        (this.popoutToggleText = this.container.querySelector(
          selectors$K.popoutToggleText
        )),
        (this.popoutInput = this.container.querySelector(
          selectors$K.popoutInput
        )),
        (this.popoutOptions = this.container.querySelectorAll(
          selectors$K.popoutOptions
        )),
        (this.productGrid = this.popoutList.closest(selectors$K.productGrid)),
        (this.popoutPrevent =
          "true" === this.container.getAttribute(selectors$K.popoutPrevent)),
        (this.popupToggleFocusoutEvent = (e) => this.popupToggleFocusout(e)),
        (this.popupListFocusoutEvent = (e) => this.popupListFocusout(e)),
        (this.popupToggleClickEvent = (e) => this.popupToggleClick(e)),
        (this.containerKeyupEvent = (e) => this.containerKeyup(e)),
        (this.bodyClickEvent = (e) => this.bodyClick(e)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popupListMaxWidth();
    }
    popupToggleClick(e) {
      var t,
        s = "true" === e.currentTarget.getAttribute(selectors$K.ariaExpanded);
      this.productGrid &&
        ((t = this.productGrid.querySelector(selectors$K.productGridImage)) &&
          t.classList.toggle(classes$C.visible, !s),
        (this.popoutList.style.maxHeight =
          Math.abs(
            this.popoutToggle.getBoundingClientRect().bottom -
              this.productGrid.getBoundingClientRect().bottom
          ) + "px")),
        e.currentTarget.setAttribute(selectors$K.ariaExpanded, !s),
        this.popoutList.classList.toggle(classes$C.listVisible),
        this.popupListMaxWidth(),
        this.toggleListPosition();
    }
    popupToggleFocusout(e) {
      this.container.contains(e.relatedTarget) || this._hideList();
    }
    popupListFocusout(e) {
      console.log(e)
      e = e.currentTarget.contains(e.relatedTarget);
      this.popoutList.classList.contains(classes$C.listVisible) &&
        !e &&
        this._hideList();
    }
    toggleListPosition() {
      const e = this.popoutList.closest(selectors$K.popoutWrapper);
      var t =
          "true" ===
          e
            .querySelector(selectors$K.popoutToggle)
            .getAttribute(selectors$K.ariaExpanded),
        s = window.innerHeight,
        i = this.popoutList.getBoundingClientRect().bottom;
      const o = () => {
        e.classList.remove(classes$C.selectPopoutTop),
          this.popoutList.removeEventListener("transitionend", o);
      };
      t
        ? s < i && e.classList.add(classes$C.selectPopoutTop)
        : this.popoutList.addEventListener("transitionend", o);
    }
    popupListMaxWidth() {
      this.popoutList.style.maxWidth =
        parseInt(
          document.body.clientWidth -
            this.popoutList.getBoundingClientRect().left
        ) + "px";
    }
    popupOptionsClick(t) {
      var s, i, o;
      if (
        "#" ===
        t.target.closest(selectors$K.popoutOptions).attributes.href.value
      ) {
        t.preventDefault();
        let e = "";
        t.currentTarget.getAttribute(selectors$K.dataValue) &&
          (e = t.currentTarget.getAttribute(selectors$K.dataValue)),
          (this.popoutInput.value = e),
          this.popoutPrevent
            ? ((s = t.currentTarget.parentElement),
              (i = this.popoutList.querySelector("." + classes$C.active)),
              (o = this.popoutList.querySelector(
                `[${selectors$K.ariaCurrent}]`
              )),
              this.popoutInput.dispatchEvent(new Event("change")),
              i &&
                (i.classList.remove(classes$C.active),
                s.classList.add(classes$C.active)),
              this.popoutInput.hasAttribute(selectors$K.popoutQuantity) &&
                !s.nextSibling &&
                this.container.classList.add(classes$C.active),
              o &&
                o.hasAttribute("" + selectors$K.ariaCurrent) &&
                (o.removeAttribute("" + selectors$K.ariaCurrent),
                t.currentTarget.setAttribute(
                  "" + selectors$K.ariaCurrent,
                  "true"
                )),
              "" !== e &&
                ((this.popoutToggleText.textContent = e),
                this.popoutToggleText.hasAttribute(
                  selectors$K.popoutToggleTextValue
                )) &&
                "" !==
                  this.popoutToggleText.getAttribute(
                    selectors$K.popoutToggleTextValue
                  ) &&
                this.popoutToggleText.setAttribute(
                  selectors$K.popoutToggleTextValue,
                  e
                ),
              this.popupToggleFocusout(t),
              this.popupListFocusout(t))
            : this._submitForm(e);
      }
    }
    containerKeyup(e) {
      e.code === window.theme.keyboardKeys.ESCAPE &&
        (this._hideList(), this.popoutToggle.focus());
    }
    bodyClick(e) {
      e = this.container.contains(e.target);
      this.popoutList.classList.contains(classes$C.listVisible) &&
        !e &&
        this._hideList();
    }
    unload() {
      document.body.removeEventListener("click", this.bodyClickEvent);
    }
    _connectToggle() {
      this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((e) => {
          e.addEventListener("click", (e) => this.popupOptionsClick(e));
        });
    }
    _onFocusOut() {
      this.popoutToggle.addEventListener(
        "focusout",
        this.popupToggleFocusoutEvent
      ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusoutEvent
        ),
        this.container.addEventListener("keyup", this.containerKeyupEvent),
        document.body.addEventListener("click", this.bodyClickEvent);
    }
    _submitForm() {
      var e = this.container.closest("form");
      e && e.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(classes$C.listVisible),
        this.popoutToggle.setAttribute(selectors$K.ariaExpanded, !1),
        this.toggleListPosition();
    }
  }
  const popoutSection = {
      onLoad() {
        (sections$m[this.id] = []),
          this.container
            .querySelectorAll(selectors$K.popoutWrapper)
            .forEach((e) => {
              sections$m[this.id].push(new Popout(e));
            });
      },
      onUnload() {
        sections$m[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    selectors$J = {
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    scrollTo = (e) => {
      var t =
        document.querySelector(selectors$J.headerSticky) &&
        document.querySelector(selectors$J.headerHeight)
          ? document
              .querySelector(selectors$J.headerHeight)
              .getBoundingClientRect().height
          : 0;
      window.scrollTo({
        top: e + window.scrollY - t,
        left: 0,
        behavior: "smooth",
      });
    };
  class PopupCookie {
    constructor(e, t, s) {
      (this.configuration = {
        expires: s,
        path: "/",
        domain: window.location.hostname,
      }),
        (this.name = e),
        (this.value = t);
    }
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((e) => e.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie =
          `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=` +
          this.configuration.domain);
    }
    read() {
      return (
        !(
          -1 === document.cookie.indexOf("; ") ||
          !document.cookie.split("; ").find((e) => e.startsWith(this.name))
        ) &&
        document.cookie
          .split("; ")
          .find((e) => e.startsWith(this.name))
          .split("=")[1]
      );
    }
    destroy() {
      document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
        (document.cookie =
          `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=` +
          this.configuration.domain);
    }
  }
  const selectors$I = {
      newsletterForm: "[data-newsletter-form]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterPopup: "[data-newsletter]",
    },
    classes$B = { success: "has-success", error: "not-success", hide: "hide" },
    attributes$b = { cookieNameAttribute: "data-cookie-name" },
    sections$l = {};
  class NewsletterCheckForResult {
    constructor(e) {
      (this.sessionStorage = window.sessionStorage),
        (this.newsletter = e),
        (this.popup = this.newsletter.closest(selectors$I.newsletterPopup)),
        this.popup &&
          (this.cookie = new PopupCookie(
            this.popup.getAttribute(attributes$b.cookieNameAttribute),
            "user_has_closed",
            null
          )),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(e) {
      this.stopSubmit &&
        (e.preventDefault(),
        e.stopImmediatePropagation(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage = "/challenge" === window.location.pathname;
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }
    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const i = document.getElementById(this.formID);
        var e = i.parentElement.querySelector(selectors$I.newsletterHeading),
          t = -1 !== window.location.search.indexOf("?customer_posted=true"),
          s = -1 !== window.location.search.indexOf("accepts_marketing");
        t
          ? (i.classList.remove(classes$B.error),
            i.classList.add(classes$B.success),
            e &&
              (e.classList.add(classes$B.hide),
              i.classList.remove(classes$B.hide)),
            this.popup && this.cookie.write())
          : s &&
            (i.classList.remove(classes$B.success),
            i.classList.add(classes$B.error),
            e) &&
            (e.classList.add(classes$B.hide),
            i.classList.remove(classes$B.hide)),
          (t || s) &&
            window.addEventListener("load", () => {
              this.scrollToForm(i);
            });
      }
    }
    scrollToForm(e) {
      var t = e.getBoundingClientRect();
      (0 <= t.top &&
        0 <= t.left &&
        t.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        t.right <=
          (window.innerWidth || document.documentElement.clientWidth)) ||
        setTimeout(() => {
          scrollTo(e.getBoundingClientRect().top);
        }, 500);
    }
    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  const newsletterCheckForResultSection = {
    onLoad() {
      (sections$l[this.id] = []),
        this.container
          .querySelectorAll(selectors$I.newsletterForm)
          .forEach((e) => {
            sections$l[this.id].push(new NewsletterCheckForResult(e));
          });
    },
    onUnload() {
      sections$l[this.id].forEach((e) => {
        "function" == typeof e.unload && e.unload();
      });
    },
  };
  function Listeners() {
    this.entries = [];
  }

  function getVariantFromSerializedArray(e, t) {
    return (
      _validateProductStructure(e),
      getVariantFromOptionArray(e, _createOptionArrayFromOptionCollection(e, t))
   

    );
  }
  function getVariantFromOptionArray(e, t) {
    console.log("This" , e,t)
    return (
      _validateProductStructure(e),
      _validateOptionsArray(t),
      e.variants.filter(function (s) {
        return t.every(function (e, t) {
          return s.options[t] === e;
        });
      })[0] || null

    );
  }
  function updateQuantityBlocks(){

      let url = window.location.href;
      let section_id =  document.querySelector('.template-product-page').dataset.sectionId;
      let newURL = url + "&section_id=" + section_id;
      console.log(newURL)
      fetch(newURL)
          .then((response) => response.text())
          .then((responseText) => {
          const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
          ); 
          if(html.querySelector('.quantity-blocks__wrapper') && html.querySelector('.quantity-blocks__wrapper') != undefined ){
              document.querySelector('.quantity-blocks__wrapper').innerHTML = html.querySelector('.quantity-blocks__wrapper').innerHTML;
              var customEvent = new CustomEvent('refreshQuantityBlockReference', {
              });                
              document.dispatchEvent(customEvent);
          }
          }) 

  
  }
  function _createOptionArrayFromOptionCollection(s, e) {
    _validateProductStructure(s), _validateSerializedArray(e);
    var i = [];
    return (
      e.forEach(function (e) {
        for (var t = 0; t < s.options.length; t++)
          if (
            (s.options[t].name || s.options[t]).toLowerCase() ===
            e.name.toLowerCase()
          ) {
            i[t] = e.value;
            break;
          }
      }),
      i
    );
  }
  function _validateProductStructure(e) {
    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
    if (0 === Object.keys(e).length && e.constructor === Object)
      throw new Error(e + " is empty.");
  }
  function _validateSerializedArray(e) {
    if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
    if (0 === e.length) throw new Error(e + " is empty.");
    if (!e[0].hasOwnProperty("name"))
      throw new Error(e[0] + "does not contain name key.");
    if ("string" != typeof e[0].name)
      throw new TypeError(
        "Invalid value type passed for name of option " +
          e[0].name +
          ". Value should be string."
      );
  }
  function _validateOptionsArray(e) {
    if (Array.isArray(e) && "object" == typeof e[0])
      throw new Error(e + "is not a valid array of options.");
  }
  register("footer", [
    popoutSection,
    parallaxHero,
    newsletterCheckForResultSection,
  ]),
    (Listeners.prototype.add = function (e, t, s) {
      this.entries.push({ element: e, event: t, fn: s }),
        e.addEventListener(t, s);
    }),
    (Listeners.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (e) {
        return e.element.removeEventListener(e.event, e.fn), !1;
      });
    });
  var selectors$H = {
    idInput: '[name="id"]',
    planInput: '[name="selling_plan"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]',
  };
  function getUrlWithVariant(e, t) {
    return /variant=/.test(e)
      ? e.replace(/(variant=)[^&]+/, "$1" + t)
      : (/\?/.test(e) ? e.concat("&variant=") : e.concat("?variant=")).concat(
          t
        );
  }
  class ProductForm {
    constructor(e, t, s) {
      (this.element = e),
        (this.product = this._validateProductObject(t)),
        (this.variantElement = this.element.querySelector(selectors$H.idInput)),
        (s = s || {}),
        (this._listeners = new Listeners()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, s)
        ),
        (this.optionInputs = this._initInputs(
          selectors$H.optionInput,
          s.onOptionChange
        )),
        (this.planInputs = this._initInputs(
          selectors$H.planInput,
          s.onPlanChange
        )),
        (this.quantityInputs = this._initInputs(
          selectors$H.quantityInput,
          s.onQuantityChange
        )),
        (this.propertyInputs = this._initInputs(
          selectors$H.propertyInput,
          s.onPropertyChange
        ));

        window.addEventListener('optionsChange', (e) =>{
          console.log("Options Changes");
          console.log(e.detail)
          this.variant = getVariantFromSerializedArray(this.product, e.detail)
          
          this._setIdInputValue(this.variant);
          let atc_btn_price = document.querySelector('.btn__price');
          if(atc_btn_price != undefined){
            atc_btn_price.innerHTML = themeCurrency.formatMoney(
              this.variant.price,
              theme.moneyFormat
            )
          }
          if(document.querySelector('.quantity-blocks__wrapper') != null){
            let section_id = document.querySelector('.template-product-page').dataset.sectionId;
            let url = window.location.origin + window.location.pathname + '?variant=' + this.variant.id + '&section_id=' + section_id;
            fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              document.querySelector('.quantity-blocks__wrapper').innerHTML = html.querySelector('.quantity-blocks__wrapper').innerHTML;
              var quantity_blocks = document.querySelectorAll('.single-quantity');
              quantity_blocks.forEach(block => {
              block.addEventListener('click', (e) => {
                quantity_blocks.forEach(block => {
                  block.classList.remove('selected');
                  block.querySelector('input[data-recharge-id]').setAttribute('disabled', true);
                  block.querySelector('input[name="quantity"]').setAttribute('disabled', true)
              })
              let quantity_wrapper = event.target.closest('.single-quantity')
              quantity_wrapper.classList.add('selected');
              quantity_wrapper.querySelector('input[name="quantity"]').removeAttribute('disabled')
              quantity_wrapper.querySelector('input[data-recharge-id]').removeAttribute('disabled');

              let QTYprice = quantity_wrapper.querySelector('.quantity__price').dataset.price;
              // check for bundle price if selected//
              
              let price = parseFloat(QTYprice.replace(/[^\d.]/g, ''));
              if(QTYprice != undefined){
                  let final_price = price + window.bundlePrice;
                  document.querySelector('.btn__price').innerHTML =  themeVendor.themeCurrency.formatMoney(
                      final_price,
                      theme.moneyFormat
                    )
              }
              })
              })
            })
          }  
          // if(document.querySelector('.single-quantity.selected') != undefined ||  document.querySelector('.single-quantity.selected') != null ){
          //   document.querySelector('.single-quantity.selected').click()
          // }
        })
    }
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (e) {
        return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
      });
    }
    variant() {
      var e = this.options();
      return e.length
        ? getVariantFromSerializedArray(this.product, e)
        : this.product.variants[0];
    }
    plan(e) {
      let t = { allocation: null, group: null, detail: null };
      var s = this.element.querySelector(selectors$H.planInput + ":checked");
      if (!s) return null;
      s = s.value;
      const i = s && "" !== s ? s : null;
      return (
        i &&
          e &&
          (t.allocation = e.selling_plan_allocations.find(function (e) {
            return e.selling_plan_id.toString() === i.toString();
          })),
        t.allocation &&
          (t.group = this.product.selling_plan_groups.find(function (e) {
            return (
              e.id.toString() === t.allocation.selling_plan_group_id.toString()
            );
          })),
        t.group &&
          (t.detail = t.group.selling_plans.find(function (e) {
            return e.id.toString() === i.toString();
          })),
        t && t.allocation && t.detail && t.allocation ? t : null
      );
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (e) {
        return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      var e = this.variant();
      return {
        options: this.options(),
        variant: e,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(e),
      };
    }
    _setIdInputValue(e) {
      e && e.id
        ? (this.variantElement.value = e.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(e, t) {
      (t.dataset = this.getFormState()), e.onFormSubmit && e.onFormSubmit(t);
    }
    _onOptionChange(e) {
      this._setIdInputValue(e.dataset.variant);
    }
    _onFormEvent(t) {
      //console.log('onform')
      return void 0 === t
        ? Function.prototype.bind()
        : function (e) {
            (e.dataset = this.getFormState()),
              this._setIdInputValue(e.dataset.variant),
              t(e);
          }.bind(this);
    }
    _initInputs(e, t) {
      return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
        function (e) {
          return this._listeners.add(e, "change", this._onFormEvent(t)), e;
        }.bind(this)
      );
    }
    _serializeInputValues(e, s) {
      return e.reduce(function (e, t) {
        return (
          (t.checked || ("radio" !== t.type && "checkbox" !== t.type)) &&
            e.push(s({ name: t.name, value: t.value })),
          e
        );
      }, []);
    }
    _validateProductObject(e) {
      if ("object" != typeof e) throw new TypeError(e + " is not an object.");
      if (void 0 === e.variants[0].options)
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return e;
    }
  }
  function fetchProduct(e) {
    e = window.theme.routes.root + `products/${e}.js`;
    return window
      .fetch(e)
      .then((e) => e.json())
      .catch((e) => {
        console.error(e);
      });
  }
  function getScript(e, t, s) {
    var i = document.getElementsByTagName("head")[0];
    let o = !1;
    var r = document.createElement("script");
    (r.src = e),
      (r.onload = r.onreadystatechange =
        function () {
          (o ||
            (this.readyState &&
              "loaded" != this.readyState &&
              "complete" != this.readyState)
            ? s
            : ((o = !0), t))();
        }),
      i.appendChild(r);
  }
  const loaders = {};
  function loadScript(t = {}) {
    var e;
    return (
      t.type || (t.type = "json"),
      t.url
        ? loaders[t.url] || getScriptWithPromise(t.url, t.type)
        : t.json
        ? loaders[t.json]
          ? Promise.resolve(loaders[t.json])
          : window
              .fetch(t.json)
              .then((e) => e.json())
              .then((e) => (loaders[t.json] = e))
        : t.name
        ? ((e = "".concat(t.name, t.version)),
          loaders[e] || loadShopifyWithPromise(t))
        : Promise.reject()
    );
  }
  function getScriptWithPromise(e, i) {
    var t = new Promise((t, s) => {
      "text" === i
        ? fetch(e)
            .then((e) => e.text())
            .then((e) => {
              t(e);
            })
            .catch((e) => {
              s(e);
            })
        : getScript(
            e,
            function () {
              t();
            },
            function () {
              s();
            }
          );
    });
    return (loaders[e] = t);
  }
  function loadShopifyWithPromise(e) {
    var t = "".concat(e.name, e.version),
      s = new Promise((t, s) => {
        try {
          window.Shopify.loadFeatures([
            {
              name: e.name,
              version: e.version,
              onLoad: (e) => {
                onLoadFromShopify(t, s, e);
              },
            },
          ]);
        } catch (e) {
          s(e);
        }
      });
    return (loaders[t] = s);
  }
  function onLoadFromShopify(e, t, s) {
    s ? t(s) : e();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const selectors$G = {
      scrollbarAttribute: "data-scrollbar",
      scrollbar: "data-scrollbar-slider",
      scrollbarSlideFullWidth: "data-scrollbar-slide-fullwidth",
      scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
      scrollbarArrowNext: "[data-scrollbar-arrow-next]",
    },
    classes$A = { hide: "is-hidden" },
    settings$2 = { delay: 200 };
  class NativeScrollbar {
    constructor(e) {
      (this.scrollbar = e),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(
          selectors$G.scrollbarArrowNext
        )),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(
          selectors$G.scrollbarArrowPrev
        )),
        this.scrollbar.hasAttribute(selectors$G.scrollbarAttribute) &&
          (this.init(), this.resize()),
        this.scrollbar.hasAttribute(selectors$G.scrollbar) &&
          this.scrollToVisibleElement();
    }
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    resize() {
      document.addEventListener("theme:resize", () => {
        this.toggleNextArrow();
      });
    }
    events() {
      this.arrowNext.addEventListener("click", (e) => {
        e.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (e) => {
          e.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      var e =
        (this.scrollbar.hasAttribute(selectors$G.scrollbarSlideFullWidth)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(e),
        this.arrowPrev.classList.remove(classes$A.hide),
        this.toggleNextArrow();
    }
    goToPrev() {
      var e = this.scrollbar.hasAttribute(selectors$G.scrollbarSlideFullWidth)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - e;
      this.move(e),
        this.arrowNext.classList.remove(classes$A.hide),
        this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        this.arrowNext.classList.toggle(
          classes$A.hide,
          Math.round(
            this.scrollbar.scrollLeft +
              this.scrollbar.getBoundingClientRect().width +
              1
          ) >= this.scrollbar.scrollWidth
        );
      }, settings$2.delay);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(
          classes$A.hide,
          this.scrollbar.scrollLeft <= 0
        );
      }, settings$2.delay);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(e) {
      this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
    }
  }
  const defaults = { color: "ash" },
    selectors$F = {
      gridSwatchForm: "[data-grid-swatch-form]",
      swatch: "data-swatch",
      outerGrid: "[data-product-grid-item]",
      slide: "[data-product-image]",
      image: "data-swatch-image",
      sectionId: "[data-section-id]",
      productInfo: "[data-product-information]",
      variant: "data-swatch-variant",
      variantName: "data-swatch-variant-name",
      button: "[data-swatch-button]",
      link: "[data-product-link]",
      wrapper: "[data-grid-swatches]",
      template: "[data-swatch-template]",
      handle: "data-swatch-handle",
      label: "data-swatch-label",
      input: "[data-swatch-input]",
      text: "[data-swatch-text]",
      tooltip: "data-tooltip",
      swatchCount: "data-swatch-count",
      scrollbar: "data-scrollbar",
      dataVariantTitle: "data-variant-title",
    },
    classes$z = { visible: "is-visible", stopEvents: "no-events" };
  class ColorMatch {
    constructor(e = {}) {
      (this.settings = { ...defaults, ...e }), (this.match = this.init());
    }
    getColor() {
      return this.match;
    }
    init() {
      return loadScript({ json: window.theme.assets.swatches })
        .then((e) => this.matchColors(e, this.settings.color))
        .catch((e) => {
          console.log("failed to load swatch colors script"), console.log(e);
        });
    }
    matchColors(e, t) {
      let i = "#E5E5E5",
        o = null;
      var r = window.theme.assets.base || "/";
      const a = t.toLowerCase().replace(/\s/g, "");
      t = e.colors;
      if (t) {
        let s = null;
        t.filter((e, t) => {
          if (Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === a)
            return (s = t), e;
        }).length &&
          null !== s &&
          ((e = Object.values(t[s])[0]),
          (i = e).includes(".jpg") ||
            e.includes(".jpeg") ||
            e.includes(".png") ||
            e.includes(".svg")) &&
          ((o = "" + r + e), (i = "#888888"));
      }
      return { color: this.settings.color, path: o, hex: i };
    }
  }
  class Swatch {
    constructor(e) {
      (this.element = e),
        (this.colorString = e.getAttribute(selectors$F.swatch)),
        (this.image = e.getAttribute(selectors$F.image)),
        (this.variant = e.getAttribute(selectors$F.variant)),
        (this.variantName = e.getAttribute(selectors$F.variantName)),
        (this.tooltip = this.element.closest(`[${selectors$F.tooltip}]`)),
        new ColorMatch({ color: this.colorString }).getColor().then((e) => {
          (this.colorMatch = e), this.init();
        });
    }
    init() {
      this.setStyles(),
        this.variant && this.handleEvents(),
        this.tooltip && new Tooltip(this.tooltip);
    }
    setStyles() {
      this.colorMatch.hex &&
        this.element.style.setProperty("--swatch", "" + this.colorMatch.hex),
        this.colorMatch.path &&
          (this.element.style.setProperty(
            "background-image",
            `url(${this.colorMatch.path})`
          ),
          this.element.style.setProperty("background-size", "cover"),
          this.element.style.setProperty(
            "background-position",
            "center center"
          ));
    }
    handleEvents() {
      (this.outer = this.element.closest(selectors$F.outerGrid)),
        this.outer &&
          ((this.slide = this.outer.querySelector(selectors$F.slide)),
          (this.linkElement = this.outer.querySelector(selectors$F.link)),
          (this.linkElementAll = this.outer.querySelectorAll(selectors$F.link)),
          (this.linkDestination = getUrlWithVariant(
            this.linkElement.getAttribute("href"),
            this.variant
          )),
          (this.button = this.element.closest(selectors$F.button)),
          (this.imagesHidden = this.outer.querySelectorAll(
            `[${selectors$F.dataVariantTitle}][style*="display: none;"]`
          )),
          (this.outerHoverEvent = () => this.showHoverImages()),
          this.button.closest(selectors$F.gridSwatchForm) &&
            this.button.addEventListener(
              "mouseenter",
              function () {
                this.changeImage();
              }.bind(this)
            ),
          this.button.closest(selectors$F.gridSwatchForm) ||
            this.button.addEventListener(
              "click",
              function () {
                this.changeImage();
              }.bind(this)
            ),
          this.imagesHidden.length) &&
          this.outer.addEventListener("mouseenter", this.outerHoverEvent);
    }
    showHoverImages() {
      this.imagesHidden.forEach((e) => {
        e.style.removeProperty("display");
      }),
        this.outer.removeEventListener("mouseenter", this.outerHoverEvent);
    }
    changeImage() {
      var e, t;
      this.linkElementAll.forEach((e) => {
        e.setAttribute("href", this.linkDestination);
      }),
        this.slide.setAttribute("src", this.linkDestination),
        this.image &&
          ((e = this.variantName.replaceAll('"', "'")),
          (e = this.slide.querySelector(
            `[${selectors$F.dataVariantTitle}="${e}"]`
          ))) &&
          ((t = this.slide.querySelector(
            `[${selectors$F.dataVariantTitle}].` + classes$z.visible
          )) && t.classList.remove(classes$z.visible),
          e.classList.add(classes$z.visible));
    }
  }
  class GridSwatch {
    constructor(e, t) {
      (this.container = t),
        (this.wrap = e),
        (this.outerGrid = e.closest(selectors$F.outerGrid)),
        (this.productLink = e.closest(selectors$F.link)),
        (this.productInfo = e.closest(selectors$F.productInfo)),
        (this.template = document.querySelector(
          selectors$F.template
        ).innerHTML),
        (this.handle = e.getAttribute(selectors$F.handle)),
        (this.sectionId = this.wrap.closest(
          selectors$F.sectionId
        ).dataset.sectionId);
      const s = e.getAttribute(selectors$F.label).trim().toLowerCase();
      fetchProduct(this.handle).then((e) => {
        (this.product = e),
          (this.colorOption = e.options.find(function (e) {
            return e.name.toLowerCase() === s || null;
          })),
          this.colorOption &&
            ((this.swatches = this.colorOption.values), this.init());
      });
    }
    init() {
      (this.wrap.innerHTML = ""),
        (this.count = 0),
        this.swatches.forEach((e) => {
          let t = null,
            s = !1,
            i = "";
          for (const h of this.product.variants) {
            var o = h.options.includes(e);
            if ((!t && o && (t = h), o && h.featured_media)) {
              (i = h.featured_media.preview_image.src), (t = h);
              break;
            }
          }
          for (const u of this.product.variants)
            if (u.options.includes(e) && u.available) {
              s = !0;
              break;
            }
          var r, a, n, l, c, d;
          t &&
            (((r = document.createElement("div")).innerHTML = this.template),
            (a = `${this.sectionId}-${this.product.id}-` + t.id),
            (n = r.querySelector(selectors$F.button)),
            (l = r.querySelector(selectors$F.input)),
            (c = r.querySelector(`[${selectors$F.label}]`)),
            (d = r.querySelector(selectors$F.text)),
            (n.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
            (n.dataset.tooltip = e),
            (l.value = e),
            (l.id = a),
            (l.dataset.variant = t.id),
            (l.disabled = !s),
            (c.htmlFor = a),
            (c.dataset.swatch = e),
            (c.dataset.variant = t),
            (c.dataset.variantName = t.title.replaceAll('"', "'")),
            (c.dataset.image = i),
            (d.innerText = e),
            (this.wrap.innerHTML += r.innerHTML),
            this.count++);
        }),
        (this.swatchCount = this.productLink.querySelector(
          `[${selectors$F.swatchCount}]`
        )),
        (this.swatchElements = this.wrap.querySelectorAll(
          `[${selectors$F.swatch}]`
        )),
        (this.swatchForm = this.productLink.querySelector(
          selectors$F.gridSwatchForm
        )),
        (this.hideSwatchesTimer = 0),
        this.swatchCount.hasAttribute(selectors$F.swatchCount) &&
          ((this.swatchCount.innerText =
            this.count +
            " " +
            (1 < this.count
              ? theme.strings.otherColor
              : theme.strings.oneColor)),
          this.swatchCount.addEventListener("mouseenter", () => {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
              this.productLink.classList.add(classes$z.stopEvents),
              this.swatchForm.classList.add(classes$z.visible);
          }),
          this.productInfo.addEventListener("mouseleave", () => {
            this.hideSwatchesTimer = setTimeout(() => {
              this.productLink.classList.remove(classes$z.stopEvents),
                this.swatchForm.classList.remove(classes$z.visible);
            }, 100);
          })),
        this.wrap.hasAttribute(selectors$F.scrollbar) &&
          new NativeScrollbar(this.wrap),
        this.swatchElements.forEach((e) => {
          new Swatch(e);
        });
    }
  }
  const makeGridSwatches = (e) => {
      e.container.querySelectorAll(selectors$F.wrapper).forEach((e) => {
        new GridSwatch(e, void 0);
      });
    },
    swatchSection = {
      onLoad() {
        (this.swatches = []),
          this.container
            .querySelectorAll(`[${selectors$F.swatch}]`)
            .forEach((e) => {
              this.swatches.push(new Swatch(e));
            });
      },
    },
    swatchGridSection = {
      onLoad() {
        makeGridSwatches(this);
      },
    },
    selectors$E = {
      dataEnableSound: "data-enable-sound",
      dataEnableBackground: "data-enable-background",
      dataEnableAutoplay: "data-enable-autoplay",
      dataEnableLoop: "data-enable-loop",
      dataVideoId: "data-video-id",
      dataVideoType: "data-video-type",
      videoIframe: "[data-video-id]",
    },
    classes$y = { loaded: "loaded" };
  class LoadVideoVimeo {
    constructor(e) {
      (this.container = e),
        (this.player = this.container.querySelector(selectors$E.videoIframe)),
        this.player &&
          ((this.videoID = this.player.getAttribute(selectors$E.dataVideoId)),
          (this.videoType = this.player.getAttribute(
            selectors$E.dataVideoType
          )),
          (this.enableBackground =
            "true" ===
            this.player.getAttribute(selectors$E.dataEnableBackground)),
          (this.disableSound =
            "false" === this.player.getAttribute(selectors$E.dataEnableSound)),
          (this.enableAutoplay =
            "false" !==
            this.player.getAttribute(selectors$E.dataEnableAutoplay)),
          (this.enableLoop =
            "false" !== this.player.getAttribute(selectors$E.dataEnableLoop)),
          "vimeo" == this.videoType) &&
          this.init();
    }
    init() {
      this.loadVimeoPlayer();
    }
    loadVimeoPlayer() {
      var e = "https://vimeo.com/" + this.videoID;
      let t = "";
      const s = this.player;
      var i,
        o = {
          url: e,
          background: this.enableBackground,
          muted: this.disableSound,
          autoplay: this.enableAutoplay,
          loop: this.enableLoop,
        };
      for (i in o)
        t += encodeURIComponent(i) + "=" + encodeURIComponent(o[i]) + "&";
      fetch("https://vimeo.com/api/oembed.json?" + t)
        .then((e) => e.json())
        .then(function (e) {
          (s.innerHTML = e.html),
            setTimeout(function () {
              s.parentElement.classList.add(classes$y.loaded);
            }, 1e3);
        })
        .catch(function (e) {
          console.log(e);
        });
    }
  }
  const selectors$D = {
      dataSectionId: "data-section-id",
      dataEnableSound: "data-enable-sound",
      dataHideOptions: "data-hide-options",
      dataCheckPlayerVisibility: "data-check-player-visibility",
      dataVideoId: "data-video-id",
      dataVideoType: "data-video-type",
      videoIframe: "[data-video-id]",
      videoWrapper: ".video-wrapper",
      youtubeWrapper: "[data-youtube-wrapper]",
    },
    classes$x = { loaded: "loaded" },
    players = [];
  class LoadVideoYT {
    constructor(e) {
      (this.container = e),
        (this.player = this.container.querySelector(selectors$D.videoIframe)),
        this.player &&
          ((this.videoOptionsVars = {}),
          (this.videoID = this.player.getAttribute(selectors$D.dataVideoId)),
          (this.videoType = this.player.getAttribute(
            selectors$D.dataVideoType
          )),
          "youtube" == this.videoType) &&
          ((this.checkPlayerVisibilityFlag =
            "true" ===
            this.player.getAttribute(selectors$D.dataCheckPlayerVisibility)),
          (this.playerID = (
            this.player.querySelector(selectors$D.youtubeWrapper)
              ? this.player.querySelector(selectors$D.youtubeWrapper)
              : this.player
          ).id),
          this.player.hasAttribute(selectors$D.dataHideOptions) &&
            (this.videoOptionsVars = {
              cc_load_policy: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              autohide: 0,
              controls: 0,
              branding: 0,
              showinfo: 0,
              rel: 0,
              fs: 0,
              wmode: "opaque",
            }),
          this.init(),
          this.container.addEventListener(
            "touchstart",
            function (e) {
              (e.target.matches(selectors$D.videoWrapper) ||
                e.target.closest(selectors$D.videoWrapper)) &&
                ((e = e.target.querySelector(selectors$D.videoIframe).id),
                players[e].playVideo());
            },
            { passive: !0 }
          ));
    }
    init() {
      window.isYoutubeAPILoaded
        ? this.loadYoutubePlayer()
        : loadScript({ url: "https://www.youtube.com/iframe_api" }).then(() =>
            this.loadYoutubePlayer()
          );
    }
    loadYoutubePlayer() {
      const e = {
        ...{
          height: "720",
          width: "1280",
          playerVars: this.videoOptionsVars,
          events: {
            onReady: (e) => {
              var t = e.target.getIframe();
              const s = t.id;
              var i =
                "true" ===
                document
                  .querySelector("#" + s)
                  .getAttribute(selectors$D.dataEnableSound);
              t.setAttribute("tabindex", "-1"),
                i ? e.target.unMute() : e.target.mute(),
                e.target.playVideo(),
                this.checkPlayerVisibilityFlag &&
                  (this.checkPlayerVisibility(s),
                  window.addEventListener(
                    "scroll",
                    throttle(() => {
                      this.checkPlayerVisibility(s);
                    }, 150)
                  ));
            },
            onStateChange: (e) => {
              0 == e.data && e.target.playVideo(),
                1 == e.data &&
                  e.target
                    .getIframe()
                    .parentElement.classList.add(classes$x.loaded);
            },
          },
        },
      };
      (e.videoId = this.videoID),
        this.videoID.length &&
          YT.ready(() => {
            players[this.playerID] = new YT.Player(this.playerID, e);
          }),
        (window.isYoutubeAPILoaded = !0);
    }
    checkPlayerVisibility(t) {
      let s;
      if ("string" == typeof t) s = t;
      else {
        if (null == t.data) return;
        s = t.data.id;
      }
      t = document.getElementById(s + "-container");
      if (t) {
        var i = players[s],
          o = t.getBoundingClientRect();
        let e =
          visibilityHelper.isElementPartiallyVisible(t) ||
          visibilityHelper.isElementTotallyVisible(t);
        (e = o.top < 0 && 0 <= t.clientHeight + o.top ? !0 : e) &&
        i &&
        "function" == typeof i.playVideo
          ? i.playVideo()
          : !e && i && "function" == typeof i.pauseVideo && i.pauseVideo();
      }
    }
    onUnload() {
      var e =
        "youtube-" + this.container.getAttribute(selectors$D.dataSectionId);
      players[e] && players[e].destroy();
    }
  }
  const selectors$C = {
      popupContainer: ".pswp",
      popupCloseBtn: ".pswp__custom-close",
      popupIframe: "iframe, video",
      popupCustomIframe: ".pswp__custom-iframe",
      popupThumbs: ".pswp__thumbs",
      popupButtons: ".pswp__button, .pswp__caption-close",
    },
    classes$w = {
      current: "is-current",
      customLoader: "pswp--custom-loader",
      customOpen: "pswp--custom-opening",
      loader: "pswp__loader",
      popupCloseButton: "pswp__button--close",
    },
    attributes$a = {
      dataOptionClasses: "data-pswp-option-classes",
      dataVideoType: "data-video-type",
      ariaCurrent: "aria-current",
    },
    loaderHTML = `<div class="${classes$w.loader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  class LoadPhotoswipe {
    constructor(e, t = "") {
      (this.items = e),
        (this.pswpElement = document.querySelectorAll(
          selectors$C.popupContainer
        )[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.isVideo = !1),
        (this.popupThumbsContainer = this.pswpElement.querySelector(
          selectors$C.popupThumbs
        )),
        (this.closeBtn = this.pswpElement.querySelector(
          selectors$C.popupCloseBtn
        )),
        (this.keyupCloseEvent = (e) => this.keyupClose(e)),
        (this.a11y = a11y);
      (this.options = "" !== t ? t : { history: !1, focus: !1, mainClass: "" }),
        this.init();
    }
    init() {
      this.pswpElement.classList.add(classes$w.customOpen),
        this.initLoader(),
        loadScript({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((e) => console.error(e));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(classes$w.customLoader) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(
          attributes$a.dataOptionClasses,
          this.options.mainClass
        );
        let e = document.createElement("div");
        (e.innerHTML = loaderHTML),
          (e = e.firstChild),
          this.pswpElement.appendChild(e);
      } else this.pswpElement.setAttribute(attributes$a.dataOptionClasses, "");
    }
    loadPopup() {
      var e = window.themePhotoswipe.PhotoSwipe.default,
        t = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(classes$w.customLoader) &&
        this.pswpElement.classList.remove(classes$w.customLoader),
        this.pswpElement.classList.remove(classes$w.customOpen),
        (this.popup = new e(this.pswpElement, t, this.items, this.options)),
        this.popup.init(),
        this.initVideo(),
        this.thumbsActions(),
        this.isVideo && this.hideUnusedButtons(),
        setTimeout(() => {
          this.a11y.trapFocus(this.pswpElement, {
            elementToFocus: this.closeBtn,
          });
        }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((e) => {
            e = this.pswpElement.querySelector(".pswp__" + e);
            e && e.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    initVideo() {
      var e,
        t = this.pswpElement.querySelector(selectors$C.popupCustomIframe);
      t &&
        ((e = t.getAttribute(attributes$a.dataVideoType)),
        (this.isVideo = !0),
        "youtube" == e
          ? new LoadVideoYT(t.parentElement)
          : "vimeo" == e && new LoadVideoVimeo(t.parentElement));
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.firstChild &&
        (this.popupThumbsContainer.addEventListener("wheel", (e) =>
          this.stopDisabledScroll(e)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (e) =>
          this.stopDisabledScroll(e)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (e) =>
          this.stopDisabledScroll(e)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(
          selectors$C.popupThumbs + " > *"
        )),
        this.popupThumbs.forEach((t, s) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            e = t.parentElement.querySelector("." + classes$w.current);
            e.classList.remove(classes$w.current),
              e.setAttribute(attributes$a.ariaCurrent, !1),
              t.classList.add(classes$w.current),
              t.setAttribute(attributes$a.ariaCurrent, !0),
              this.popup.goTo(s);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    hideUnusedButtons() {
      var e = this.pswpElement.querySelectorAll(selectors$C.popupButtons);
      e.length &&
        e.forEach((e) => {
          e.classList.contains(classes$w.popupCloseButton) ||
            (e.style.display = "none");
        });
    }
    stopDisabledScroll(e) {
      e.stopPropagation();
    }
    keyupClose(e) {
      e.code === window.theme.keyboardKeys.ENTER && this.popup.close();
    }
    onClose() {
      var e = this.pswpElement.querySelector(selectors$C.popupIframe);
      if (
        (e && e.parentNode.removeChild(e),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(attributes$a.dataOptionClasses, "");
      e = this.pswpElement.querySelector("." + classes$w.loader);
      e && this.pswpElement.removeChild(e),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((e) => {
            e = this.pswpElement.querySelector(".pswp__" + e);
            e && e.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        window.accessibility.lastElement &&
          setTimeout(() => {
            window.accessibility.lastElement.focus();
          }, 200);
    }
    setCurrentThumb() {
      var e = this.pswpElement.querySelector(
        selectors$C.popupThumbs + " > ." + classes$w.current
      );
      e &&
        (e.classList.remove(classes$w.current),
        e.setAttribute(attributes$a.ariaCurrent, !1)),
        this.popupThumbs &&
          ((e = this.popupThumbs[this.popup.getCurrentIndex()]).classList.add(
            classes$w.current
          ),
          e.setAttribute(attributes$a.ariaCurrent, !0),
          this.scrollThumbs(e));
    }
    scrollThumbs(e) {
      var t =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = e.offsetLeft;
      (t <= s + e.offsetWidth || s < t) &&
        ((t = parseInt(window.getComputedStyle(e).marginLeft)),
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - t,
          behavior: "smooth",
        }));
    }
  }
  const selectors$B = {
      zoomWrapper: "[data-zoom-wrapper]",
      dataImageSrc: "data-image-src",
      dataImageWidth: "data-image-width",
      dataImageHeight: "data-image-height",
      dataImageAlt: "data-image-alt",
      dataImageZoomEnable: "data-image-zoom-enable",
      thumbs: ".pswp__thumbs",
      caption: "[data-zoom-caption]",
    },
    classes$v = {
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailable",
      popupThumb: "pswp__thumb",
      popupClass: "pswp-zoom-gallery",
      popupClassNoThumbs: "pswp-zoom-gallery--single",
      popupTitle: "product__title",
      popupTitleNew: "product__title pswp__title",
    };
  class Zoom {
    constructor(e) {
      (this.container = e.container),
        (this.zoomWrappers = this.container.querySelectorAll(
          selectors$B.zoomWrapper
        )),
        (this.thumbsContainer = document.querySelector(selectors$B.thumbs)),
        (this.zoomCaptionElem = this.container.querySelector(
          selectors$B.caption
        )),
        (this.zoomEnable =
          "true" ===
          this.container.getAttribute(selectors$B.dataImageZoomEnable)),
        this.zoomEnable && this.init();
    }
    init() {
      this.zoomWrappers.length &&
        this.zoomWrappers.forEach((t, s) => {
          t.addEventListener("click", (e) => {
            e.preventDefault(),
              this.createZoom(s),
              (window.accessibility.lastElement = t);
          }),
            t.addEventListener("keyup", (e) => {
              e.code === window.theme.keyboardKeys.ENTER &&
                (e.preventDefault(),
                this.createZoom(s),
                (window.accessibility.lastElement = t));
            });
        });
    }
    createZoom(i) {
      let o = [],
        r = 0,
        a = "";
      this.zoomWrappers.forEach((e) => {
        var t = e.getAttribute(selectors$B.dataImageSrc),
          s = e.hasAttribute(selectors$B.dataImageAlt)
            ? e.getAttribute(selectors$B.dataImageAlt)
            : "";
        (r += 1),
          o.push({
            src: t,
            w: parseInt(e.getAttribute(selectors$B.dataImageWidth)),
            h: parseInt(e.getAttribute(selectors$B.dataImageHeight)),
            msrc: t,
          }),
          (a += `<a href="#" class="${classes$v.popupThumb}" style="background-image: url('${t}')" aria-label="${s}" aria-current="false"></a>`),
          this.zoomWrappers.length === r &&
            ((e = {
              history: !1,
              focus: !1,
              index: i,
              mainClass:
                1 === r
                  ? classes$v.popupClass + " " + classes$v.popupClassNoThumbs
                  : "" + classes$v.popupClass,
              showHideOpacity: !0,
              howAnimationDuration: 150,
              hideAnimationDuration: 250,
              closeOnScroll: !1,
              closeOnVerticalDrag: !1,
              captionEl: !0,
              closeEl: !0,
              closeElClasses: ["caption-close", "title"],
              tapToClose: !1,
              clickToCloseNonZoomable: !1,
              maxSpreadZoom: 2,
              loop: !0,
              spacing: 0,
              allowPanToNext: !0,
              pinchToClose: !1,
              addCaptionHTMLFn: (e, t, s) => {
                this.zoomCaption(e, t, s);
              },
              getThumbBoundsFn: () => {
                var e = this.zoomWrappers[i],
                  t = window.pageYOffset || document.documentElement.scrollTop,
                  e = e.getBoundingClientRect();
                return { x: e.left, y: e.top + t, w: e.width };
              },
            }),
            new LoadPhotoswipe(o, e),
            this.thumbsContainer) &&
            "" !== a &&
            (this.thumbsContainer.innerHTML = a);
      });
    }
    zoomCaption(e, t) {
      let s = "";
      t = t.children[0];
      return (
        this.zoomCaptionElem &&
          ((s = this.zoomCaptionElem.innerHTML),
          this.zoomCaptionElem.closest("." + classes$v.variantSoldOut)
            ? t.classList.add(classes$v.variantSoldOut)
            : t.classList.remove(classes$v.variantSoldOut),
          this.zoomCaptionElem.closest("." + classes$v.variantUnavailable)
            ? t.classList.add(classes$v.variantUnavailable)
            : t.classList.remove(classes$v.variantUnavailable)),
        (s = s.replaceAll(classes$v.popupTitle, classes$v.popupTitleNew)),
        (t.innerHTML = s),
        !1
      );
    }
  }
  const hosts = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
    selectors$A = {
      deferredMedia: "[data-deferred-media]",
      deferredMediaButton: "[data-deferred-media-button]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaSlider: "[data-product-single-media-slider]",
      mediaContainer: "[data-video]",
      mediaId: "data-media-id",
      dataTallLayout: "data-tall-layout",
    },
    classes$u = { mediaHidden: "media--hidden" };
  theme.mediaInstances = {};
  class Video {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.id = e.id),
        (this.tallLayout =
          "true" === this.container.getAttribute(selectors$A.dataTallLayout)),
        (this.players = {}),
        this.init();
    }
    init() {
      this.container
        .querySelectorAll(selectors$A.mediaContainer)
        .forEach((e) => {
          var t = e.querySelector(selectors$A.deferredMediaButton);
          t && t.addEventListener("click", this.loadContent.bind(this, e));
        });
    }
    loadContent(e) {
      if (!e.querySelector(selectors$A.deferredMedia).getAttribute("loaded")) {
        var t = document.createElement("div");
        t.appendChild(
          e.querySelector("template").content.firstElementChild.cloneNode(!0)
        );
        const o = e.dataset.mediaId;
        var t = t.querySelector("video, iframe"),
          s = this.hostFromVideoElement(t),
          i = e.querySelector(selectors$A.deferredMedia);
        i.appendChild(t).focus(),
          i.setAttribute("loaded", !0),
          (this.players[o] = {
            mediaId: o,
            sectionId: this.id,
            container: e,
            element: t,
            host: s,
            ready: () => this.createPlayer(o),
          });
        const r = this.players[o];
        switch (r.host) {
          case hosts.html5:
            this.loadVideo(r, hosts.html5);
            break;
          case hosts.vimeo:
            window.isVimeoAPILoaded
              ? this.loadVideo(r, hosts.vimeo)
              : loadScript({
                  url: "https://player.vimeo.com/api/player.js",
                }).then(() => this.loadVideo(r, hosts.vimeo));
            break;
          case hosts.youtube:
            window.isYoutubeAPILoaded
              ? this.loadVideo(r, hosts.youtube)
              : loadScript({ url: "https://www.youtube.com/iframe_api" }).then(
                  () => this.loadVideo(r, hosts.youtube)
                );
        }
      }
    }
    hostFromVideoElement(e) {
      if ("VIDEO" === e.tagName) return hosts.html5;
      if ("IFRAME" === e.tagName) {
        if (
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            e.src
          )
        )
          return hosts.youtube;
        if (e.src.includes("vimeo.com")) return hosts.vimeo;
      }
      return null;
    }
    loadVideo(e, t) {
      e.host === t && e.ready();
    }
    createPlayer(t) {
      const s = this.players[t];
      switch (s.host) {
        case hosts.html5:
          s.element.play(),
            s.element.addEventListener("play", () => this.pauseOtherMedia(t)),
            s.element.play(),
            s.container.addEventListener("theme:media:hidden", (e) =>
              this.onHidden(e)
            ),
            s.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
            s.container.addEventListener("theme:media:visible", (e) =>
              this.onVisible(e)
            ),
            this.tallLayout && this.observeVideo(s, t);
          break;
        case hosts.vimeo:
          (this.players[t].player = new Vimeo.Player(s.element)),
            this.players[t].player.play(),
            (window.isVimeoAPILoaded = !0),
            s.container.addEventListener("theme:media:hidden", (e) =>
              this.onHidden(e)
            ),
            s.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
            s.container.addEventListener("theme:media:visible", (e) =>
              this.onVisible(e)
            ),
            this.tallLayout && this.observeVideo(s, t);
          break;
        case hosts.youtube:
          (s.host == hosts.youtube && s.player) ||
            YT.ready(() => {
              var e = s.container.dataset.videoId;
              (this.players[t].player = new YT.Player(s.element, {
                videoId: e,
                events: { onReady: (e) => e.target.playVideo() },
              })),
                (window.isYoutubeAPILoaded = !0),
                s.container.addEventListener("theme:media:hidden", (e) =>
                  this.onHidden(e)
                ),
                s.container.addEventListener("xrLaunch", (e) =>
                  this.onHidden(e)
                ),
                s.container.addEventListener("theme:media:visible", (e) =>
                  this.onVisible(e)
                ),
                this.tallLayout && this.observeVideo(s, t);
            });
      }
    }
    observeVideo(s, i) {
      new IntersectionObserver(
        (e, t) => {
          e.forEach((e) => {
            1 != e.intersectionRatio
              ? this.pauseVideo(s)
              : (this.playVideo(s), this.pauseOtherMedia(i));
          });
        },
        { threshold: 1 }
      ).observe(s.element);
    }
    playVideo(e) {
      e.player && e.player.playVideo
        ? e.player.playVideo()
        : e.element && e.element.play
        ? e.element.play()
        : e.player && e.player.play && e.player.play();
    }
    pauseVideo(e) {
      e.player && e.player.pauseVideo
        ? e.player.pauseVideo()
        : e.element && e.element.pause
        ? e.element.pause()
        : e.player && e.player.pause && e.player.pause();
    }
    onHidden(e) {
      void 0 !== e.target.dataset.mediaId &&
        this.pauseVideo(this.players[e.target.dataset.mediaId]);
    }
    onVisible(e) {
      void 0 !== e.target.dataset.mediaId &&
        this.playVideo(this.players[e.target.dataset.mediaId]);
    }
    pauseOtherMedia(e) {
      var e = `[${selectors$A.mediaId}="${e}"]`,
        t = document.querySelectorAll(
          selectors$A.productMediaWrapper + `:not(${e})`
        );
      document
        .querySelector(selectors$A.productMediaWrapper + e)
        .classList.remove(classes$u.mediaHidden),
        t.length &&
          t.forEach((e) => {
            e.dispatchEvent(new CustomEvent("theme:media:hidden")),
              e.classList.add(classes$u.mediaHidden);
          });
    }
  }
  theme.mediaInstances = {};
  const selectors$z = {
      videoPlayer: "[data-video]",
      modelViewer: "[data-model]",
      sliderEnabled: "flickity-enabled",
    },
    classes$t = { mediaHidden: "media--hidden" };
  class Media {
    constructor(e) {
      (this.section = e), (this.id = e.id), (this.container = e.container);
    }
    init() {
      this.detect3d(),
        this.launch3d(),
        new Video(this.section),
        new Zoom(this.section);
    }
    detect3d() {
      var e = this.container.querySelectorAll(selectors$z.modelViewer);
      e.length &&
        e.forEach((e) => {
          theme.ProductModel.init(e, this.id);
        });
    }
    launch3d() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(
            `${selectors$z.modelViewer}:not(.${classes$t.mediaHidden})`
          )
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
  }
  const selectors$y = {
      productSlideshow: "[data-product-slideshow]",
      mobileSliderDisabled: "data-slideshow-disabled-mobile",
      productThumbs: "[data-product-thumbs]",
      sliderThumb: "[data-thumb-item]",
      dataTallLayout: "data-tall-layout",
      mediaType: "data-type",
      dataMediaId: "data-media-id",
      dataThumb: "data-thumb",
      dataThumbIndex: "data-thumb-index",
      deferredMediaButton: "[data-deferred-media-button]",
      ariaLabel: "aria-label",
      dataThumbnail: "[data-thumbnail]",
      productSlideThumb: ".js-product-slide-thumb",
      classSelected: ".is-active",
      thumbsSlider: "[data-thumbs-slider]",
      quickAddModal: "[data-quick-add-modal]",
      focusedElement: "[data-focus-element]",
      zoomElement: "[data-zoom-wrapper]",
    },
    classes$s = {
      active: "is-active",
      focused: "is-focused",
      dragging: "is-dragging",
      selected: "is-selected",
      sliderEnabled: "flickity-enabled",
      mediaHidden: "media--hidden",
    },
    attributes$9 = {
      ariaCurrent: "aria-current",
      sliderOptions: "data-options",
    },
    thumbIcons = {
      model:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
      video:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
    };
  let sections$k = {};
  class InitSlider {
    constructor(e, t = null) {
      (this.container = t || e.container),
        (this.tallLayout =
          "true" === this.container.getAttribute(selectors$y.dataTallLayout)),
        (this.slideshow = this.container.querySelector(
          selectors$y.productSlideshow
        )),
        (this.thumbs = this.container.querySelector(selectors$y.productThumbs)),
        (this.mobileSliderDisabled =
          "true" ===
          this.container.getAttribute(selectors$y.mobileSliderDisabled)),
        (this.initSliderMobileEvent = () => this.initSliderMobile()),
        (this.initSliderDesktopEvent = () => this.initSliderDesktop()),
        this.slideshow &&
          this.slideshow.hasAttribute(attributes$9.sliderOptions) &&
          (this.customOptions = JSON.parse(
            decodeURIComponent(
              this.slideshow.getAttribute(attributes$9.sliderOptions)
            )
          )),
        (this.flkty = null),
        this.init();
    }
    init() {
      this.slideshow &&
        (this.tallLayout
          ? this.mobileSliderDisabled ||
            (this.initSliderMobile(),
            document.addEventListener(
              "theme:resize:width",
              this.initSliderMobileEvent
            ))
          : this.mobileSliderDisabled
          ? (this.initSliderDesktop(),
            document.addEventListener(
              "theme:resize:width",
              this.initSliderDesktopEvent
            ))
          : this.createSlider());
    }
    initSliderMobile() {
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < theme.sizes.small
        ? this.createSlider()
        : this.destroySlider();
    }
    initSliderDesktop() {
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < theme.sizes.small
        ? this.destroySlider()
        : this.createSlider();
    }
    destroySlider() {
      this.slideshow.classList.contains(classes$s.sliderEnabled) &&
        this.flkty.destroy(),
        this.thumbs && (this.thumbs.innerHTML = "");
    }
    createSlider() {
      var e =
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < theme.sizes.small;
      if (!(!this.slideshow || (this.mobileSliderDisabled && e))) {
        e = {
          autoPlay: !1,
          pageDots: !1,
          wrapAround: !0,
          ...this.customOptions,
        };
        const o = this;
        var t = this.slideshow.querySelectorAll(
            `[${selectors$y.mediaType}]`
          )[0],
          e = {
            ...e,
            on: {
              ready: function () {
                const t = this.element;
                t.addEventListener("keyup", (e) => {
                  e.code === window.theme.keyboardKeys.ENTER &&
                    (e = t.querySelector(
                      `.${classes$s.selected} ` + selectors$y.zoomElement
                    )) &&
                    (e.dispatchEvent(new Event("click", { bubbles: !1 })),
                    (window.accessibility.lastElement = t));
                }),
                  o.sliderThumbs(this),
                  o.accessibilityActions(this);
              },
            },
          };
        (this.flkty = new FlickityFade(this.slideshow, e)),
          this.flkty.resize(),
          !t ||
            ("model" !== (e = t.getAttribute(selectors$y.mediaType)) &&
              "video" !== e &&
              "external_video" !== e) ||
            ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()),
          this.flkty.on("change", function (e) {
            let t = e;
            o.thumbs &&
              ((s = o.thumbs.querySelector(selectors$y.classSelected)),
              (e = o.thumbs.querySelector(
                `${selectors$y.sliderThumb} [${selectors$y.dataThumbIndex}="${e}"]`
              )),
              s &&
                ((i = s.querySelector(`[${selectors$y.dataThumbIndex}]`)),
                (t = Array.from(s.parentElement.children).indexOf(s)),
                s.classList.remove(classes$s.active),
                i) &&
                i.setAttribute(attributes$9.ariaCurrent, !1),
              e &&
                (e.parentElement.classList.add(classes$s.active),
                e.setAttribute(attributes$9.ariaCurrent, !0)),
              o.scrollToThumb());
            var s = this.cells[t].element,
              i = this.selectedElement;
            s.dispatchEvent(new CustomEvent("theme:media:hidden")),
              i.classList.remove(classes$s.mediaHidden);
          }),
          this.flkty.on("settle", function () {
            const t = this.selectedElement;
            var e = Array.prototype.filter.call(
                t.parentNode.children,
                function (e) {
                  return e !== t;
                }
              ),
              s = t.getAttribute(selectors$y.mediaType),
              i = document.body.classList.contains(classes$s.focused),
              s =
                ((o.flkty.options.draggable =
                  "model" !== s && "video" !== s && "external_video" !== s),
                o.flkty.updateDraggable(),
                i && t.dispatchEvent(new Event("focus")),
                e.length &&
                  e.forEach((e) => {
                    e.classList.add(classes$s.mediaHidden);
                  }),
                t.dispatchEvent(new CustomEvent("theme:media:visible")),
                t.querySelector("deferred-media"));
            s &&
              !0 !== s.getAttribute("loaded") &&
              t
                .querySelector(selectors$y.deferredMediaButton)
                .dispatchEvent(new Event("click", { bubbles: !1 })),
              o.accessibilityActions(this);
          }),
          this.flkty.on("dragStart", (e, t) => {
            e.target.classList.add(classes$s.dragging);
          }),
          this.flkty.on("dragEnd", (e, t) => {
            var s = this.flkty.element.querySelector("." + classes$s.dragging);
            s && s.classList.remove(classes$s.dragging);
          }),
          this.container.addEventListener("click", (e) => {
            var t = e.target;
            (t.matches(selectors$y.productSlideThumb) ||
              t.closest(selectors$y.productSlideThumb)) &&
              (e.preventDefault(),
              (t = (e = t.matches(selectors$y.productSlideThumb)
                ? t
                : t.closest(selectors$y.productSlideThumb)).hasAttribute(
                selectors$y.dataThumbIndex
              )
                ? parseInt(e.getAttribute(selectors$y.dataThumbIndex))
                : 0),
              this.flkty.select(t));
          });
      }
    }
    accessibilityActions(e) {
      e = e.slides;
      e.length &&
        e.forEach((e) => {
          const t = e.cells[0].element;
          e = t.querySelectorAll(
            "model-viewer, video, iframe, button, [href], input, " +
              selectors$y.focusedElement
          );
          t.classList.contains(classes$s.selected)
            ? t.removeAttribute("tabindex")
            : t.setAttribute("tabindex", "-1"),
            e.length &&
              e.forEach((e) => {
                t.classList.contains(classes$s.selected)
                  ? e.removeAttribute("tabindex")
                  : e.setAttribute("tabindex", "-1");
              });
        });
    }
    scrollToThumb() {
      var s = this.container.querySelector(selectors$y.thumbsSlider);
      if (s) {
        var i = s.querySelector(selectors$y.classSelected);
        if (i) {
          var o = s.scrollTop,
            r = s.scrollLeft,
            a = s.offsetWidth,
            n = s.offsetHeight,
            l = i.offsetTop,
            c = i.offsetLeft,
            d = i.offsetWidth,
            i = i.offsetHeight,
            h = l < o,
            u = c < r,
            r = r + a < c + d;
          if (o + n < l + i || h || r || u) {
            o =
              (window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth) < theme.sizes.small;
            let e = l - n + i,
              t = c - a + d;
            h && (e = l),
              r &&
                o &&
                (t += parseInt(window.getComputedStyle(s).paddingRight)),
              u &&
                ((t = c), o) &&
                (t -= parseInt(window.getComputedStyle(s).paddingLeft)),
              s.scrollTo({ top: e, left: t, behavior: "smooth" });
          }
        }
      }
    }
    sliderThumbs(t) {
      var e = t.slides;
      if (this.thumbs && e.length) {
        let c = "";
        e.forEach((e, t) => {
          var e = e.cells[0].element,
            s = e.getAttribute(selectors$y.mediaType),
            i = e.getAttribute(selectors$y.dataMediaId),
            o = e.getAttribute(selectors$y.dataThumb);
          let r = "";
          var a = thumbIcons[s] || "";
          let n = "",
            l = !1;
          "" ===
            (r = e.querySelector(`[${selectors$y.ariaLabel}]`)
              ? e
                  .querySelector(`[${selectors$y.ariaLabel}]`)
                  .getAttribute(selectors$y.ariaLabel)
              : r) &&
            e.hasAttribute(selectors$y.ariaLabel) &&
            (r = e.getAttribute(selectors$y.ariaLabel)),
            (!e.classList.contains(classes$s.active) && 0 !== t) ||
              ((n = classes$s.active), (l = !0)),
            (c += `<div class="product__thumb ${n}" data-thumb-item><a href="${o}" class="product__thumb__link product__thumb__link--${s} js-product-slide-thumb" data-thumb-index="${t}" data-thumbnail data-media-id="${i}" aria-label="${r}" aria-current="${l}"><img class="product__thumb__link__image" loading="lazy" is="lazy-img" src="${o}" sizes="75px" alt="${r}">${a}</a></div>`);
        }),
          "" !== c &&
            ((c = `<div class="product__thumbs__holder" data-thumbs-slider>${c}</div>`),
            (this.thumbs.innerHTML = c));
      }
      e = this.container.querySelectorAll(selectors$y.dataThumbnail);
      e.length &&
        e.forEach((e) => {
          e.addEventListener("click", function (e) {
            e.preventDefault();
          }),
            e.addEventListener("keyup", function (e) {
              e.code === window.theme.keyboardKeys.ENTER &&
                ((e = this.getAttribute(selectors$y.dataMediaId)),
                (e = t.element
                  .querySelector(`[${selectors$y.dataMediaId}="${e}"]`)
                  .querySelectorAll(
                    'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                  )[0])) &&
                (e.dispatchEvent(new Event("focus")),
                e.dispatchEvent(new Event("select")));
            });
        });
    }
    onUnload() {
      this.tallLayout
        ? this.mobileSliderDisabled ||
          document.removeEventListener(
            "theme:resize:width",
            this.initSliderMobileEvent
          )
        : this.mobileSliderDisabled &&
          document.removeEventListener(
            "theme:resize:width",
            this.initSliderDesktopEvent
          );
    }
  }
  const initSlider = {
      onLoad() {
        sections$k[this.id] = new InitSlider(this);
      },
      onUnload(e) {
        sections$k[this.id].onUnload(e);
      },
    },
    selectors$x = {
      optionPosition: "data-option-position",
      optionInput: '[name^="options"], [data-popout-option]',
      optionInputCurrent:
        '[name^="options"]:checked, [name^="options"][type="hidden"]',
      selectOptionValue: "data-value",
      popout: "[data-popout]",
    },
    classes$r = { soldOut: "sold-out", unavailable: "unavailable" };
  class SelloutVariants {
    constructor(e, t) {
      (this.container = e),
        (this.productJSON = t),
        (this.optionElements = this.container.querySelectorAll(
          selectors$x.optionInput
        )),
        this.productJSON && this.optionElements.length && this.init();
    }
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((e) => {
          var t = e.closest(`[${selectors$x.optionPosition}]`);
          if (t) {
            var s = e.value || e.getAttribute(selectors$x.selectOptionValue),
              t = t.getAttribute(selectors$x.optionPosition),
              t = parseInt(t, 10) - 1,
              o = e.closest(selectors$x.popout);
            let i = [...this.selections];
            i[t] = s;
            t = this.productJSON.variants.find((t) => {
              let s = !0;
              for (let e = 0; e < i.length; e++)
                t.options[e] !== i[e] && (s = !1);
              return s;
            });
            e.classList.remove(classes$r.soldOut, classes$r.unavailable),
              o && o.classList.remove(classes$r.soldOut, classes$r.unavailable),
              void 0 === t
                ? (e.classList.add(classes$r.unavailable),
                  o && o.classList.add(classes$r.unavailable))
                : t &&
                  !1 === t.available &&
                  (e.classList.add(classes$r.soldOut), o) &&
                  o.classList.add(classes$r.soldOut);
          }
        });
    }
    getCurrentState() {
      this.selections = [];
      var e = this.container.querySelectorAll(selectors$x.optionInputCurrent);
      e.length &&
        e.forEach((e) => {
          e = e.value;
          e && "" !== e && this.selections.push(e);
        });
    }
  }
  const selectors$w = {
      product: "[data-product]",
      productForm: "[data-product-form]",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      comparePrice: "[data-compare-price]",
      comparePriceText: "[data-compare-text]",
      formWrapper: "[data-form-wrapper]",
      originalSelectorId: "[data-product-select]",
      priceWrapper: "[data-price-wrapper]",
      productSlideshow: "[data-product-slideshow]",
      productImage: "[data-product-image]",
      productJson: "[data-product-json]",
      productPrice: "[data-product-price]",
      unitPrice: "[data-product-unit-price]",
      unitBase: "[data-product-base]",
      unitWrapper: "[data-product-unit]",
      isPreOrder: "[data-product-preorder]",
      sliderEnabled: "flickity-enabled",
      productSlide: ".product__slide",
      dataTallLayout: "data-tall-layout",
      dataEnableHistoryState: "data-enable-history-state",
      subPrices: "[data-subscription-watch-price]",
      subSelectors: "[data-subscription-selectors]",
      subsToggle: "[data-toggles-group]",
      subsChild: "data-group-toggle",
      subDescription: "[data-plan-description]",
      priceOffWrap: "[data-price-off]",
      priceOffType: "[data-price-off-type]",
      priceOffAmount: "[data-price-off-amount]",
      dataImageId: "data-image-id",
      remainingCount: "[data-remaining-count]",
      remainingMax: "[data-remaining-max]",
      remainingMaxAttr: "data-remaining-max",
      remainingWrapper: "[data-remaining-wrapper]",
      remainingJSON: "[data-product-remaining-json]",
      optionValue: "[data-option-value]",
      optionPosition: "data-option-position",
    },
    classes$q = {
      hide: "hide",
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailable",
      productPriceSale: "product__price--sale",
      remainingLow: "count-is-low",
      remainingIn: "count-is-in",
      remainingOut: "count-is-out",
      remainingUnavailable: "count-is-unavailable",
    };
  class ProductAddForm {
    constructor(e, t = null) {
      if (
        ((this.section = e),
        (this.container = t || e.container),
        (this.tallLayout =
          "true" === this.container.getAttribute(selectors$w.dataTallLayout)),
        (this.product = this.container.querySelector(selectors$w.product)),
        (this.productForm = this.container.querySelector(
          selectors$w.productForm
        )),
        (this.sellout = null),
        (this.priceOffWrap = this.container.querySelector(
          selectors$w.priceOffWrap
        )),
        (this.priceOffAmount = this.container.querySelector(
          selectors$w.priceOffAmount
        )),
        (this.priceOffType = this.container.querySelector(
          selectors$w.priceOffType
        )),
        (this.planDecription = this.container.querySelector(
          selectors$w.subDescription
        )),
        (this.remainingWrapper = this.container.querySelector(
          selectors$w.remainingWrapper
        )),
        this.remainingWrapper)
      ) {
        t = this.container.querySelector(selectors$w.remainingMax);
        if (!t) return;
        (this.remainingMaxInt = parseInt(
          t.getAttribute(selectors$w.remainingMaxAttr),
          10
        )),
          (this.remainingCount = this.container.querySelector(
            selectors$w.remainingCount
          )),
          (this.remainingJSONWrapper = this.container.querySelector(
            selectors$w.remainingJSON
          )),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON");
      }
      (this.enableHistoryState =
        "true" ===
        this.container.getAttribute(selectors$w.dataEnableHistoryState)),
        (this.hasUnitPricing = this.container.querySelector(
          selectors$w.unitWrapper
        )),
        (this.subSelectors = this.container.querySelector(
          selectors$w.subSelectors
        )),
        (this.subPrices = this.container.querySelector(selectors$w.subPrices)),
        (this.isPreOrder = this.container.querySelector(
          selectors$w.isPreOrder
        )),
        new QuantityCounter(this.container).init(),
        this.init();
    }
    init() {
      let e = null;
      var t = this.container.querySelector(selectors$w.productJson);
      (e = t ? t.innerHTML : e)
        ? ((this.productJSON = JSON.parse(e)),
          this.linkForm(),
          (this.sellout = new SelloutVariants(
            this.container,
            this.productJSON
          )))
        : console.error("Missing product JSON");
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      //console.log('link')
      (this.productForm = new ProductForm(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState()),
        this.subsToggleListeners();
    }
    onOptionChange(e) {
      //console.log('topion')
      this.pushState(e.dataset), this.updateProductImage(e);
    }
    onPlanChange(e) {
      this.subPrices && this.pushState(e.dataset);
    }
    pushState(e) {
      (this.productState = this.setProductState(e)),
        this.updateAddToCartState(e),
        this.updateProductPrices(e),
        this.updateSaleText(e),
        this.updateSubscriptionText(e),
        this.updateRemaining(e),
        this.fireHookEvent(e),
        this.updateLegend(e),
        this.sellout?.update(e),
        this.enableHistoryState && this.updateHistoryState(e);
    }
    updateAddToCartState(e) {
      const s = e.variant;
      let t = theme.strings.addToCart;
      var e = this.container.querySelectorAll(selectors$w.priceWrapper),
        i = this.container.querySelectorAll(selectors$w.addToCart),
        o = this.container.querySelectorAll(selectors$w.addToCartText),
        r = this.container.querySelectorAll(selectors$w.formWrapper);
      this.isPreOrder && (t = theme.strings.preOrder),
        e.length &&
          s &&
          e.forEach((e) => {
            e.classList.remove(classes$q.hide);
          }),
        i.length &&
          i.forEach((e) => {
            s && s.available ? (e.disabled = !1) : (e.disabled = !0);
          }),
        o.length &&
          o.forEach((e) => {
            s
              ? s.available
                ? (e.innerHTML = t)
                : (e.innerHTML = theme.strings.soldOut)
              : (e.innerHTML = theme.strings.unavailable);
          }),
        r.length &&
          r.forEach((e) => {
            var t;
            s
              ? (s.available
                  ? e.classList.remove(
                      classes$q.variantSoldOut,
                      classes$q.variantUnavailable
                    )
                  : (e.classList.add(classes$q.variantSoldOut),
                    e.classList.remove(classes$q.variantUnavailable)),
                (t = e.querySelector(selectors$w.originalSelectorId)) &&
                  (t.value = s.id))
              : (e.classList.add(classes$q.variantUnavailable),
                e.classList.remove(classes$q.variantSoldOut));
          });
    }
    updateHistoryState(e) {
      var t,
        s = e.variant,
        e = e.plan,
        i = window.location.href;
      s &&
        i.includes("/product") &&
        ((t = (i = new window.URL(i)).searchParams).set("variant", s.id),
        e && e.detail && e.detail.id && this.productState.hasPlan
          ? t.set("selling_plan", e.detail.id)
          : t.delete("selling_plan"),
        (i.search = t.toString()),
        (s = i.toString()),
        window.history.replaceState({ path: s }, "", s));
    }
    updateRemaining(e) {
      var e = e.variant;
      e && this.remainingWrapper && this.remainingJSON && this.remainingCount
        ? (e = this.remainingJSON[e.id]) && e <= this.remainingMaxInt && 0 < e
          ? (this.remainingWrapper.classList.remove(
              classes$q.remainingIn,
              classes$q.remainingOut,
              classes$q.remainingUnavailable
            ),
            this.remainingWrapper.classList.add(classes$q.remainingLow),
            (this.remainingCount.innerHTML = e))
          : this.productState.soldOut
          ? (this.remainingWrapper.classList.remove(
              classes$q.remainingLow,
              classes$q.remainingIn,
              classes$q.remainingUnavailable
            ),
            this.remainingWrapper.classList.add(classes$q.remainingOut))
          : this.productState.available &&
            (this.remainingWrapper.classList.remove(
              classes$q.remainingLow,
              classes$q.remainingOut,
              classes$q.remainingUnavailable
            ),
            this.remainingWrapper.classList.add(classes$q.remainingIn))
        : this.remainingWrapper &&
          (this.remainingWrapper.classList.remove(
            classes$q.remainingIn,
            classes$q.remainingOut,
            classes$q.remainingLow
          ),
          this.remainingWrapper.classList.add(classes$q.remainingUnavailable));
    }
    getBaseUnit(e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(selectors$w.subsToggle).forEach((e) => {
        e.addEventListener(
          "change",
          function (e) {
            e = e.target.value.toString();
            const t = this.container.querySelector(
              `[${selectors$w.subsChild}="${e}"]`
            );
            var s,
              e = this.container.querySelectorAll(`[${selectors$w.subsChild}]`);
            t &&
              (t.classList.remove(classes$q.hide),
              ((s = t.querySelector('[name="selling_plan"]')).checked = !0),
              s.dispatchEvent(new Event("change"))),
              e.forEach((e) => {
                e !== t &&
                  (e.classList.add(classes$q.hide),
                  e.querySelectorAll('[name="selling_plan"]').forEach((e) => {
                    (e.checked = !1), e.dispatchEvent(new Event("change"));
                  }));
              });
          }.bind(this)
        );
      });
    }
    updateSaleText(e) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(e)
        : this.productState.onSale
        ? this.updateSaleTextStandard(e)
        : this.priceOffWrap && this.priceOffWrap.classList.add(classes$q.hide);
    }
    updateSaleTextStandard(e) {
      this.priceOffType &&
        (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount &&
          this.priceOffWrap &&
          ((e =
            ((e = e.variant).compare_at_price - e.price) / e.compare_at_price),
          (e = Math.floor(100 * e)),
          (this.priceOffAmount.innerHTML = e + "%"),
          this.priceOffWrap.classList.remove(classes$q.hide));
    }
    updateSubscriptionText(e) {
      e.plan && this.planDecription
        ? ((this.planDecription.innerHTML = e.plan.detail.description),
          this.planDecription.classList.remove(classes$q.hide))
        : this.planDecription &&
          this.planDecription.classList.add(classes$q.hide);
    }
    updateSaleTextSubscription(e) {
      var t;
      this.priceOffType &&
        (this.priceOffType.innerHTML =
          window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount &&
          this.priceOffWrap &&
          ((t = (e = e.plan.detail.price_adjustments[0]).value),
          e && "percentage" === e.value_type
            ? (this.priceOffAmount.innerHTML = t + "%")
            : (this.priceOffAmount.innerHTML = themeCurrency.formatMoney(
                t,
                theme.moneyFormat
              )),
          this.priceOffWrap.classList.remove(classes$q.hide));
    }
    updateProductPrices(e) {
      const r = e.variant,
        a = e.plan;
      this.container.querySelectorAll(selectors$w.priceWrapper).forEach((e) => {
        var t = e.querySelector(selectors$w.comparePrice),
          s = e.querySelector(selectors$w.productPrice),
          e = e.querySelector(selectors$w.comparePriceText);
        let i = "",
          o = "";
        this.productState.available &&
          ((i = r.compare_at_price), (o = r.price)),
          this.productState.hasPlan && (o = a.allocation.price),
          this.productState.planSale &&
            ((i = a.allocation.compare_at_price), (o = a.allocation.price)),
          t &&
            (this.productState.onSale || this.productState.planSale
              ? (t.classList.remove(classes$q.hide),
                e.classList.remove(classes$q.hide),
                s.classList.add(classes$q.productPriceSale))
              : (t.classList.add(classes$q.hide),
                e.classList.add(classes$q.hide),
                s.classList.remove(classes$q.productPriceSale)),
            (t.innerHTML = themeCurrency.formatMoney(i, theme.moneyFormat))),
          (s.innerHTML =
            0 === o
              ? window.theme.strings.free
              : themeCurrency.formatMoney(o, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(e);
    }
    updateProductUnits(e) {
      var t = e.variant,
        e = e.plan;
      let s = null;
      t && t.unit_price && (s = t.unit_price),
        ((s =
          e && e.allocation && e.allocation.unit_price
            ? e.allocation.unit_price
            : s)
          ? ((e = this.getBaseUnit(t)),
            (t = themeCurrency.formatMoney(s, theme.moneyFormat)),
            (this.container.querySelector(selectors$w.unitPrice).innerHTML = t),
            (this.container.querySelector(selectors$w.unitBase).innerHTML = e),
            showElement)
          : hideElement)(this.container.querySelector(selectors$w.unitWrapper));
    }
    fireHookEvent(e) {
      e = e.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(e) {
      var t = e.variant,
        e = e.plan,
        s = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !t || (t.requires_selling_plan && !e)
          ? (s.available = !1)
          : (t.available || (s.soldOut = !0),
            t.compare_at_price > t.price && (s.onSale = !0),
            t.unit_price && (s.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (s.requiresPlan = !0),
            e &&
              this.subPrices &&
              ((s.hasPlan = !0),
              e.allocation.per_delivery_price !== e.allocation.price &&
                (s.planPerDelivery = !0),
              t.price > e.allocation.price) &&
              (s.planSale = !0)),
        s
      );
    }
    updateProductImage(e) {
      var t,
        s,
        i,
        o,
        e = e.dataset.variant;
      e &&
        e.featured_media &&
        (t = (e = this.container.querySelector(
          `${selectors$w.productImage}[${selectors$w.dataImageId}="${e.featured_media.id}"]`
        ))?.closest(selectors$w.productSlide)) &&
        ((s =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) >= window.theme.sizes.small),
        (i = Array.from(t.parentElement.children).indexOf(t)),
        (o = this.container.querySelector(selectors$w.productSlideshow)) &&
        o.classList.contains(selectors$w.sliderEnabled)
          ? FlickityFade.data(o).select(i)
          : o &&
            !s &&
            o.scrollTo({ top: 0, left: t.offsetLeft, behavior: "smooth" }),
        s) &&
        this.tallLayout &&
        ((o = e.getBoundingClientRect().top),
        (0 === i && o + window.scrollY > window.pageYOffset) ||
          (document.dispatchEvent(
            new CustomEvent("theme:tooltip:close", {
              bubbles: !1,
              detail: { hideTransition: !1 },
            })
          ),
          scrollTo(o)));
    }
    updateLegend(e) {
      const s = e.variant;
      s &&
        (e = this.container.querySelectorAll(selectors$w.optionValue)).length &&
        e.forEach((e) => {
          var t = e.closest(`[${selectors$w.optionPosition}]`);
          t &&
            ((t = t.getAttribute(selectors$w.optionPosition)),
            (t = parseInt(t, 10) - 1),
            (t = s.options[t]),
            (e.innerHTML = t));
        });
    }
  }
  const productFormSection = {
      onLoad() {
        this.section = new ProductAddForm(this);
      },
    },
    classes$p = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      hide: "is-hidden",
      hiding: "is-hiding",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "siblings__link--current",
      focused: "is-focused",
    },
    settings$1 = { errorDelay: 3e3, animationDelay: 500 },
    selectors$v = {
      addButtonWrapper: "[data-add-action-wrapper]",
      animation: "[data-animation]",
      apiContent: "[data-api-content]",
      buttonQuickAdd: "[data-quick-add-btn]",
      buttonQuickAddText: "[data-quick-add-btn-text]",
      buttonQuickAddMobile: "[data-quick-add-btn-mobile]",
      cartDrawer: "[data-cart-drawer]",
      cartLineItems: "[data-line-items]",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
      media: "[data-media-slide]",
      messageError: "[data-message-error]",
      modalContainer: "[data-product-upsell-container]",
      modalContent: "[data-product-upsell-ajax]",
      productGridItem: "data-product-grid-item",
      productInformationHolder: "[data-product-information]",
      popoutWrapper: "[data-popout]",
      quickAddHolder: "data-quick-add-holder",
      quickAddModal: "[data-quick-add-modal]",
      quickAddModalTemplate: "[data-quick-add-modal-template]",
      quickAddVariant: "data-quick-add-variant",
      quickAddProp: "data-quick-add-props",
      siblingSwapper: "data-sibling-swapper",
      swatch: "[data-swatch]",
      tooltip: "[data-tooltip]",
    };
  class QuickAddProduct extends HTMLElement {
    constructor() {
      var e, t;
      super(),
        ((this.container = this).quickAddHolder = this.container.querySelector(
          `[${selectors$v.quickAddHolder}]`
        )),
        this.quickAddHolder &&
          ((this.html = document.documentElement),
          (this.isCartItem = Boolean(
            this.quickAddHolder.closest(selectors$v.cartLineItems)
          )),
          (this.modalTemplate = this.quickAddHolder.querySelector(
            selectors$v.quickAddModalTemplate
          )),
          (this.modal = document.querySelector(selectors$v.quickAddModal)),
          (this.modalID = this.quickAddHolder.getAttribute(
            selectors$v.quickAddHolder
          )),
          (this.modalButton = this.quickAddHolder.querySelector(
            `[data-popup-${this.modalID}]`
          )),
          (this.handle = this.modalButton
            ? this.modalButton.getAttribute("data-popup-" + this.modalID)
            : null),
          (this.cartDrawer = document.querySelector(selectors$v.cartDrawer)),
          (this.buttonQuickAdd = this.quickAddHolder.querySelector(
            selectors$v.buttonQuickAdd
          )),
          (this.button = this.modalButton || this.buttonQuickAdd),
          (this.buttonQuickAddMobile = this.quickAddHolder.querySelector(
            selectors$v.buttonQuickAddMobile
          )),
          (this.closeTooltipEvent = () => throttle(this.closeTooltip(), 50)),
          (this.oldModalID = null),
          (this.modalContainer = null),
          (this.modalContent = null),
          !this.modal &&
            this.modalTemplate &&
            ((t = this.modalTemplate.innerHTML),
            ((e = document.createElement("div")).innerHTML = t),
            (t = e.querySelector(selectors$v.quickAddModal)),
            document.body.appendChild(t),
            (this.modal = document.querySelector(selectors$v.quickAddModal))),
          this.init());
          
    
    }
    init() {
      var e;
      this.modalButton &&
        this.modalTemplate &&
        this.modalButton.addEventListener("click", (e) => {
          e.preventDefault();
          var e = this.modalButton.hasAttribute(selectors$v.siblingSwapper),
            t = this.modalButton.classList.contains(
              classes$p.siblingLinkCurrent
            );
          t ||
            (this.modalButton.classList.add(classes$p.loading),
            (this.modalButton.disabled = !0),
            this.closeTooltip(),
            e &&
              !t &&
              ((this.modalContainer = document.querySelector(
                selectors$v.modalContainer
              )),
              this.modalContainer.classList.add(classes$p.loading),
              this.hideAnimatedItems()),
            this.modal &&
              ((this.oldModalID = this.modal.id), this.modalID) &&
              (this.modal.id = this.modalID),
            this.getProductHTML());
        }),
        this.buttonQuickAdd &&
          ((e = this.buttonQuickAdd.querySelector(
            selectors$v.buttonQuickAddText
          )) &&
            0 ===
              parseInt(
                getComputedStyle(this.buttonQuickAdd).getPropertyValue(
                  "--btn-text-width"
                )
              ) &&
            this.buttonQuickAdd.style.setProperty(
              "--btn-text-width",
              e.clientWidth + "px"
            ),
          this.buttonQuickAdd.hasAttribute(selectors$v.quickAddVariant)) &&
          (this.buttonQuickAdd.addEventListener("click", (e) => {
            //atc button on upsells
            console.log(e);
            e.preventDefault();
            var t,
              e = this.buttonQuickAdd.getAttribute(selectors$v.quickAddVariant);
            e &&
              ((t = this.buttonQuickAdd.hasAttribute(selectors$v.quickAddProp)
                ? JSON.parse(
                    this.buttonQuickAdd
                      .getAttribute(selectors$v.quickAddProp)
                      .replaceAll("'", '"')
                  )
                : null),
              console.log(e),  
              this.addToCart(e, t));
          }),
          theme.settings.enableQuickAdd) &&
          this.buttonQuickAdd.closest(`[${selectors$v.quickAddHolder}]`) &&
          this.errorHandler(),
        this.buttonQuickAddMobile &&
          this.buttonQuickAddMobile.addEventListener("click", () => {
            this.buttonQuickAddMobile.classList.add(classes$p.loading),
              this.button.dispatchEvent(new Event("click"));
          }),
        this.quickAddHolder &&
          this.quickAddHolder.addEventListener("animationend", () => {
            this.quickAddHolder.classList.contains(classes$p.disabled) &&
              this.quickAddHolder.classList.remove(classes$p.disabled);
          }),
        document.addEventListener("theme:product:added", () => {
          this.resetQuickAddButtons(),
            this.modal &&
              this.modal.classList.contains(classes$p.open) &&
              MicroModal.close(this.modalID);
        });
    }
    addToCart(e, t = null) {
      var s = this.buttonQuickAdd.closest(selectors$v.quickAddHolder)
        ? this.buttonQuickAdd
        : null;
      let i = { id: e, quantity: 1 };
      t && ((e = { properties: t }), (i = { ...i, ...e })),
        document.dispatchEvent(
          new CustomEvent("theme:cart:add", {
            bubbles: !0,
            detail: {
              element: this.quickAddHolder,
              label: s,
              button: this.buttonQuickAdd,
              data: i,
            },
          })
        );
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (e) => {
        var t = e.detail.holder,
          s = t.closest(`[${selectors$v.productGridItem}]`);
        if (s) {
          var i = t.querySelector(selectors$v.messageError);
          const o = s.classList.contains(classes$p.overlayText),
            r = s.querySelector(selectors$v.productInformationHolder);
          (s = t.querySelector(selectors$v.buttonQuickAdd)),
            (t = t.querySelector(selectors$v.buttonQuickAddMobile));
          s &&
            (s.classList.remove(classes$p.added, classes$p.loading),
            s.classList.add(classes$p.error)),
            t &&
              (t.classList.remove(classes$p.added, classes$p.loading),
              t.classList.add(classes$p.error)),
            i && (i.innerText = e.detail.description),
            o && r.classList.add(classes$p.hide),
            setTimeout(() => {
              this.resetQuickAddButtons(),
                o && r.classList.remove(classes$p.hide);
            }, settings$1.errorDelay);
        }
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(classes$p.visible),
        this.button &&
          (this.buttonQuickAdd.classList.remove(
            classes$p.added,
            classes$p.error
          ),
          (this.buttonQuickAdd.disabled = !1)),
        this.buttonQuickAddMobile &&
          (this.buttonQuickAddMobile.classList.remove(
            classes$p.added,
            classes$p.error
          ),
          (this.buttonQuickAddMobile.disabled = !1));
    }
    getProductHTML() {
      this.modalContent && this.oldModalID === this.modalID
        ? this.modalCreate()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((e) => e.text())
            .then((e) => {
              var t = document.createElement("div");
              (t.innerHTML = e),
                (this.modalContent = document.querySelector(
                  selectors$v.modalContent
                )),
                (this.modalContent.innerHTML = t.querySelector(
                  selectors$v.apiContent
                ).innerHTML),
                this.initFormFunctionalities(),
                this.modalCreate();
            });
     
    }
    initFormFunctionalities() {
      new ProductAddForm(null, this.modal), new InitSlider(null, this.modal);
      var e = this.modalContent.querySelectorAll(selectors$v.swatch),
        e =
          (e.length &&
            e.forEach((e) => {
              new Swatch(e);
            }),
          this.modalContent.querySelectorAll(selectors$v.popoutWrapper)),
        e =
          (e.length &&
            e.forEach((e) => {
              new Popout(e);
            }),
          this.modalContent.querySelectorAll(selectors$v.tooltip));
      e.length &&
        e.forEach((e) => {
          new Tooltip(e);
        }),
        wrapElements(this.modalContent);
    }
    modalCreate() {
      (this.modalContainer = document.querySelector(
        selectors$v.modalContainer
      )),
        MicroModal.show(this.modalID, {
          onShow: (e, t, s) => {
            const i = e.querySelector(selectors$v.focusable);
            var o = { container: e, id: this.modalID };
            (theme.mediaInstances[this.id] = new Media(o)),
              theme.mediaInstances[this.id].init(),
              this.quickAddHolder.classList.add(classes$p.disabled),
              this.modalButton &&
                (this.modalButton.classList.remove(classes$p.loading),
                (this.modalButton.disabled = !1)),
              this.buttonQuickAddMobile &&
                (this.buttonQuickAddMobile.classList.remove(classes$p.loading),
                (this.buttonQuickAddMobile.disabled = !1)),
              requestAnimationFrame(() => {
                this.modalContainer
                  .querySelectorAll(selectors$v.animation)
                  .forEach((e) => {
                    e.classList.add(classes$p.animated);
                  }),
                  setTimeout(() => {
                    this.modalContainer.classList.remove(classes$p.loading);
                  }, settings$1.animationDelay);
              }),
              setTimeout(() => {
                trapFocus(e, { elementToFocus: i });
              }, settings$1.animationDelay),
              document.dispatchEvent(
                new CustomEvent("theme:quick-add:open", { bubbles: !0 })
              ),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: this.modalContainer,
                })
              ),
              this.modalContainer.addEventListener(
                "scroll",
                this.closeTooltipEvent
              );
              let popoutOptions = this.modalContent.querySelectorAll('.select-popout__item');
              popoutOptions.forEach(option => {
                option.addEventListener('click', (e) => {
                  e.preventDefault();
                  let variantId = option.dataset.variantId;
                  console.log("Quick Cart Variant",variantId)
                  this.modalContent.querySelector('[data-quick-cart-selected-variant]').value = variantId;
                  let option_name = this.modalContent.querySelector('.radio__legend__option-name')
                  let option_value = this.modalContent.querySelector('[data-option-value]').textContent.trim();
                  let productData = JSON.parse(this.modalContent.querySelector('[data-product-json]').innerHTML);
                  let variant = productData.variants.filter(variant => {
                    return variant.title.includes(option_value)
                  })
                  
                  this.modalContent.querySelector('.btn__price span').innerHTML = themeCurrency.formatMoney(variant[0].price, theme.moneyFormat);
                });
              });
          },
          onClose: (e, t, s) => {
            s && s.preventDefault(),
              e.querySelectorAll(selectors$v.media).forEach((e) => {
                e.dispatchEvent(new CustomEvent("pause"));
              }),
              this.modalButton && (this.modalButton.disabled = !1),
              this.buttonQuickAddMobile &&
                (this.buttonQuickAddMobile.disabled = !1),
              this.quickAddHolder &&
                this.quickAddHolder.classList.contains(classes$p.disabled) &&
                this.quickAddHolder.classList.remove(classes$p.disabled),
              removeTrapFocus(),
              document.body.classList.contains(classes$p.focused) &&
                this.buttonQuickAdd &&
                (this.buttonQuickAdd.classList.add(classes$p.visible),
                setTimeout(() => {
                  this.buttonQuickAdd.focus(),
                    this.buttonQuickAdd.classList.remove(classes$p.visible);
                }, 50)),
              this.resetAnimatedItems(),
              (this.cartDrawer &&
                this.cartDrawer.classList.contains(classes$p.open)) ||
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                ),
              this.modalContainer.removeEventListener(
                "scroll",
                this.closeTooltipEvent
              );
          },
        });
    }
    closeTooltip() {
      document.dispatchEvent(
        new CustomEvent("theme:tooltip:close", {
          bubbles: !1,
          detail: { hideTransition: !0 },
        })
      );
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new FetchError({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
    hideAnimatedItems() {
      this.modalContainer &&
        this.modalContainer
          .querySelectorAll(selectors$v.animation)
          .forEach((e) => {
            e.classList.add(classes$p.hiding);
          });
    }
    resetAnimatedItems() {
      this.modalContainer &&
        this.modalContainer
          .querySelectorAll(selectors$v.animation)
          .forEach((e) => {
            e.classList.remove(classes$p.animated);
          });
    }
  }
  const selectors$u = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-product-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingHolder: "[data-sibling-holder]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
    },
    classes$o = {
      visible: "is-visible",
      fade: "is-fade",
      stopEvents: "no-events",
      active: "is-active",
    },
    attributes$8 = {
      siblingAddedImage: "data-sibling-added-image",
      siblingCutline: "data-sibling-cutline",
      siblingImage: "data-sibling-image",
      siblingLink: "data-sibling-link",
      siblingPrice: "data-sibling-price",
      productLink: "data-product-link",
    };
  class SiblingSwatches {
    constructor(e, t) {
      (this.swatches = e),
        (this.product = t),
        (this.productLinks = this.product.querySelectorAll(
          selectors$u.productLink
        )),
        (this.productCutline = this.product.querySelector(
          selectors$u.productCutline
        )),
        (this.productPrice = this.product.querySelector(
          selectors$u.productPrice
        )),
        (this.productImage = this.product.querySelector(
          selectors$u.productImage
        )),
        (this.productImageSibling = this.product.querySelector(
          selectors$u.productImageSibling
        )),
        this.init();
    }
    init() {
      this.cacheDefaultValues(),
        this.product.addEventListener("mouseleave", () =>
          this.resetProductValues()
        ),
        this.swatches.forEach((e) => {
          e.addEventListener("mouseenter", (e) => this.showSibling(e));
        }),
        this.productLinks.length &&
          this.swatches.forEach((e) => {
            e.addEventListener("click", () => {
              this.productLinks[0].click();
            });
          });
    }
    cacheDefaultValues() {
      (this.productLinkValue = this.productLinks[0].hasAttribute(
        attributes$8.productLink
      )
        ? this.productLinks[0].getAttribute(attributes$8.productLink)
        : ""),
        (this.productPriceValue = this.productPrice.innerHTML),
        this.productCutline &&
          (this.productCutlineValue = this.productCutline.innerHTML);
    }
    resetProductValues() {
      this.product.classList.remove(classes$o.active),
        this.productLinkValue &&
          this.productLinks.forEach((e) => {
            e.href = this.productLinkValue;
          }),
        this.productPrice &&
          (this.productPrice.innerHTML = this.productPriceValue),
        this.productCutline &&
          this.productCutline &&
          (this.productCutline.innerHTML = this.productCutlineValue),
        this.hideSiblingImage();
    }
    showSibling(e) {
      e = e.target;
      const t = e.hasAttribute(attributes$8.siblingLink)
        ? e.getAttribute(attributes$8.siblingLink)
        : "";
      var s = e.hasAttribute(attributes$8.siblingPrice)
          ? e.getAttribute(attributes$8.siblingPrice)
          : "",
        i = e.hasAttribute(attributes$8.siblingCutline)
          ? e.getAttribute(attributes$8.siblingCutline)
          : "",
        e = e.hasAttribute(attributes$8.siblingImage)
          ? e.getAttribute(attributes$8.siblingImage)
          : "";
      t &&
        this.productLinks.forEach((e) => {
          e.href = t;
        }),
        s && (this.productPrice.innerHTML = s),
        (this.productCutline.innerHTML = i || ""),
        e && this.showSiblingImage(e);
    }
    showSiblingImage(e) {
      if (this.productImageSibling) {
        var t = window.devicePixelRatio || 1,
          t = this.productImage.offsetWidth * t,
          t = 180 * Math.ceil(t / 180);
        const s = themeImages.getSizedImageUrl(e, t + "x");
        e = this.productImageSibling.querySelector(`[src="${s}"]`);
        const i = () => {
            this.productImageSibling.classList.add(classes$o.visible),
              this.productImageSibling
                .querySelector(`[src="${s}"]`)
                .classList.add(classes$o.fade);
          },
          o = () => {
            this.productImageSibling.querySelectorAll("img").forEach((e) => {
              e.classList.remove(classes$o.fade);
            }),
              requestAnimationFrame(i);
          };
        if (e) o();
        else {
          const r = document.createElement("img");
          (r.src = s),
            this.productCutline && (r.alt = this.productCutline.innerText),
            r.addEventListener("load", () => {
              this.productImageSibling.append(r), o();
            });
        }
      }
    }
    hideSiblingImage() {
      this.productImageSibling &&
        (this.productImageSibling.classList.remove(classes$o.visible),
        this.productImageSibling.querySelectorAll("img").forEach((e) => {
          e.classList.remove(classes$o.fade);
        }));
    }
  }
  class Sibling {
    constructor(e, t) {
      (this.holder = e),
        (this.product = t),
        (this.siblingScrollbar = this.holder.querySelector(
          selectors$u.siblingsInnerHolder
        )),
        (this.siblingCount = this.holder.querySelector(
          selectors$u.siblingCount
        )),
        (this.siblingFieldset = this.holder.querySelector(
          selectors$u.siblingFieldset
        )),
        (this.siblingLinks = this.holder.querySelectorAll(
          selectors$u.siblingLink
        )),
        (this.productInfo = this.holder.closest(selectors$u.productInfo)),
        (this.productLink = this.holder.closest(selectors$u.link)),
        (this.hideSwatchesTimer = 0),
        this.init();
    }
    init() {
      this.initScrollbar(),
        this.siblingCount &&
          this.siblingFieldset &&
          this.productInfo &&
          (this.siblingCount.addEventListener("mouseenter", () =>
            this.showSiblings()
          ),
          this.productInfo.addEventListener("mouseleave", () =>
            this.hideSiblings()
          )),
        this.siblingLinks.length &&
          new SiblingSwatches(this.siblingLinks, this.product);
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink &&
          this.productLink.classList.add(classes$o.stopEvents),
        this.siblingFieldset.classList.add(classes$o.visible);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink &&
          this.productLink.classList.remove(classes$o.stopEvents),
          this.siblingFieldset.classList.remove(classes$o.visible);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new NativeScrollbar(this.siblingScrollbar);
    }
  }
  class Siblings {
    constructor(e) {
      (this.container = e.container),
        (this.siblingHolders = this.container.querySelectorAll(
          selectors$u.productGridItem + " " + selectors$u.siblingHolder
        )),
        this.siblingHolders.length &&
          this.siblingHolders.forEach((e) => {
            new Sibling(e, e.closest(selectors$u.productGridItem));
          });
    }
  }
  const siblings = {
      onLoad() {
        new Siblings(this);
      },
    },
    selectors$t = {
      rangeSlider: "[data-range-slider]",
      rangeDotLeft: "[data-range-left]",
      rangeDotRight: "[data-range-right]",
      rangeLine: "[data-range-line]",
      rangeHolder: "[data-range-holder]",
      dataMin: "data-se-min",
      dataMax: "data-se-max",
      dataMinValue: "data-se-min-value",
      dataMaxValue: "data-se-max-value",
      dataStep: "data-se-step",
      dataFilterUpdate: "data-range-filter-update",
      priceMin: "[data-field-price-min]",
      priceMax: "[data-field-price-max]",
    },
    classes$n = { initialized: "is-initialized" };
  class RangeSlider {
    constructor(e) {
      (this.container = e.container),
        (this.slider = e.querySelector(selectors$t.rangeSlider)),
        (this.resizeFilters = () => this.init()),
        this.slider &&
          ((this.onMoveEvent = (e) => this.onMove(e)),
          (this.onStopEvent = (e) => this.onStop(e)),
          (this.onStartEvent = (e) => this.onStart(e)),
          (this.startX = 0),
          (this.x = 0),
          (this.touchLeft = this.slider.querySelector(
            selectors$t.rangeDotLeft
          )),
          (this.touchRight = this.slider.querySelector(
            selectors$t.rangeDotRight
          )),
          (this.lineSpan = this.slider.querySelector(selectors$t.rangeLine)),
          (this.min = parseFloat(
            this.slider.getAttribute(selectors$t.dataMin)
          )),
          (this.max = parseFloat(
            this.slider.getAttribute(selectors$t.dataMax)
          )),
          (this.step = 0),
          (this.normalizeFact = 26),
          this.init());
    }
    init() {
      let e = this.min,
        t =
          (this.slider.hasAttribute(selectors$t.dataMinValue) &&
            (e = parseFloat(
              this.slider.getAttribute(selectors$t.dataMinValue)
            )),
          this.max);
      this.slider.hasAttribute(selectors$t.dataMaxValue) &&
        (t = parseFloat(this.slider.getAttribute(selectors$t.dataMaxValue))),
        e < this.min && (e = this.min),
        t > this.max && (t = this.max),
        e > t && (e = t),
        this.slider.getAttribute(selectors$t.dataStep) &&
          (this.step = Math.abs(
            parseFloat(this.slider.getAttribute(selectors$t.dataStep))
          )),
        this.reset(),
        document.addEventListener("theme:resize", this.resizeFilters),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(e),
        this.setMaxValue(t),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.slider.classList.add(classes$n.initialized);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(e) {
      var t = (e - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(selectors$t.dataMinValue, e);
    }
    setMaxValue(e) {
      var t = (e - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(selectors$t.dataMaxValue, e);
    }
    onStart(e) {
      let t = e;
      e.touches && (t = e.touches[0]),
        e.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : e.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = t.pageX - this.x),
        (this.selectedTouch = e.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(e) {
      let t = e;
      e.touches && (t = e.touches[0]),
        (this.x = t.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change") &&
          new Function("min, max", this.slider.getAttribute("on-change"))(
            this.slider.getAttribute(selectors$t.dataMinValue),
            this.slider.getAttribute(selectors$t.dataMaxValue)
          ),
        this.onChange(
          this.slider.getAttribute(selectors$t.dataMinValue),
          this.slider.getAttribute(selectors$t.dataMaxValue)
        );
    }
    onStop() {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(selectors$t.dataMinValue),
          this.slider.getAttribute(selectors$t.dataMaxValue)
        );
    }
    onChange(e, t) {
      var s,
        i = this.slider.closest(selectors$t.rangeHolder);
      i &&
        ((s = i.querySelector(selectors$t.priceMin)),
        (i = i.querySelector(selectors$t.priceMax)),
        s) &&
        i &&
        ((s.value = e), (i.value = t));
    }
    onChanged(e, t) {
      this.slider.hasAttribute(selectors$t.dataFilterUpdate) &&
        this.slider.dispatchEvent(
          new CustomEvent("theme:range:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      var e =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let t = this.lineSpan.offsetLeft / this.initialValue,
        s = t + e;
      (t = t * (this.max - this.min) + this.min),
        (s = s * (this.max - this.min) + this.min),
        0 !== this.step &&
          ((e = Math.floor(t / this.step)),
          (t = this.step * e),
          (e = Math.floor(s / this.step)),
          (s = this.step * e)),
        this.selectedTouch === this.touchLeft &&
          this.slider.setAttribute(selectors$t.dataMinValue, t),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(selectors$t.dataMaxValue, s);
    }
    onUnload() {
      this.resizeFilters &&
        document.removeEventListener("theme:resize", this.resizeFilters);
    }
  }
  const selectors$s = {
      collectionSidebar: "[data-collection-sidebar]",
      form: "[data-collection-filters-form]",
      input: "input",
      select: "select",
      label: "label",
      textarea: "textarea",
      priceMin: "[data-field-price-min]",
      priceMax: "[data-field-price-max]",
      priceMinValue: "data-field-price-min",
      priceMaxValue: "data-field-price-max",
      rangeMin: "[data-se-min-value]",
      rangeMax: "[data-se-max-value]",
      rangeMinValue: "data-se-min-value",
      rangeMaxValue: "data-se-max-value",
      rangeMinDefault: "data-se-min",
      rangeMaxDefault: "data-se-max",
      productsContainer: "[data-products-grid]",
      product: "[data-product-grid-item]",
      filterUpdateUrlButton: "[data-filter-update-url]",
      activeFilters: "[data-active-filters]",
      activeFiltersCount: "data-active-filters-count",
      sort: "data-sort-enabled",
      collectionNav: "[data-collection-nav]",
    },
    classes$m = { hidden: "hidden", loading: "is-loading" };
  let sections$j = {};
  class FiltersForm {
    constructor(e) {
      (this.section = e),
        (this.container = this.section.container),
        (this.sidebar = this.container.querySelector(
          selectors$s.collectionSidebar
        )),
        (this.form = this.container.querySelector(selectors$s.form)),
        (this.sort = this.container.querySelector(`[${selectors$s.sort}]`)),
        (this.productsContainer = this.container.querySelector(
          selectors$s.productsContainer
        )),
        (this.collectionNav = this.container.querySelector(
          selectors$s.collectionNav
        )),
        this.init();
    }
    init() {
      this.form &&
        (this.initRangeSlider(),
        this.sidebar.addEventListener(
          "input",
          debounce((e) => {
            var t,
              s = e.type,
              i = e.target;
            (s !== selectors$s.input &&
              s !== selectors$s.select &&
              s !== selectors$s.label &&
              s !== selectors$s.textarea) ||
              (this.form &&
                "function" == typeof this.form.submit &&
                ((s = this.form.querySelector(selectors$s.priceMin)),
                (t = this.form.querySelector(selectors$s.priceMax)),
                s &&
                  t &&
                  (i.hasAttribute(selectors$s.priceMinValue) && !t.value
                    ? (t.value = t.placeholder)
                    : i.hasAttribute(selectors$s.priceMaxValue) &&
                      !s.value &&
                      (s.value = s.placeholder)),
                this.submitForm(e)));
          }, 500)
        ),
        this.sidebar.addEventListener("theme:range:update", (e) =>
          this.updateRange(e)
        )),
        this.sidebar &&
          this.sidebar.addEventListener("click", (e) =>
            this.filterUpdateFromUrl(e)
          ),
        this.productsContainer &&
          this.productsContainer.addEventListener("click", (e) =>
            this.filterUpdateFromUrl(e)
          ),
        this.sort &&
          this.container.addEventListener("theme:filter:update", (e) =>
            this.submitForm(e)
          ),
        (this.sidebar || this.sort) &&
          window.addEventListener("popstate", (e) => this.submitForm(e));
    }
    initRangeSlider() {
      new RangeSlider(this.form);
    }
    filterUpdateFromUrl(e) {
      var t = e.target;
      (t.matches(selectors$s.filterUpdateUrlButton) ||
        (t.closest(selectors$s.filterUpdateUrlButton) && t)) &&
        (e.preventDefault(),
        (t = t.matches(selectors$s.filterUpdateUrlButton)
          ? t
          : t.closest(selectors$s.filterUpdateUrlButton)),
        this.submitForm(e, t.getAttribute("href")));
    }
    submitForm(e, t = "") {
      this.sort = this.container.querySelector(`[${selectors$s.sort}]`);
      var s = this.sort ? this.sort.getAttribute(selectors$s.sort) : "";
      if (e && "popstate" === e.type)
        this.sort &&
          this.sort.dispatchEvent(
            new CustomEvent("theme:filter:sort", { bubbles: !1 })
          );
      else if ("" === t) {
        var i = new window.URL(window.location.href).searchParams,
          o = Object.fromEntries(i),
          r = i.toString();
        if (r.includes("filter.") || r.includes("page="))
          for (const h in o)
            (!h.includes("filter.") && "page" !== h) || i.delete(h);
        if (this.form) {
          var a,
            n,
            r = new FormData(this.form),
            o = new URLSearchParams(r),
            r = this.form.querySelector(selectors$s.rangeMin),
            l = this.form.querySelector(selectors$s.rangeMax),
            c =
              r && r.hasAttribute(selectors$s.rangeMinDefault)
                ? r.getAttribute(selectors$s.rangeMinDefault)
                : "",
            d =
              l && l.hasAttribute(selectors$s.rangeMaxDefault)
                ? l.getAttribute(selectors$s.rangeMaxDefault)
                : "";
          let e = 0;
          for ([a, n] of o.entries())
            a.includes("filter.") &&
              n &&
              (i.append(a, n),
              (n === c && "filter.v.price.gte" === a) ||
                (n === d && "filter.v.price.lte" === a)) &&
              (e += 1);
          2 === e &&
            (i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"));
        }
        (s || (e && e.detail && e.detail.href)) &&
          ((r = s || e.detail.href), i.set("sort_by", r));
        (l = i.toString()), (o = l ? "?" + l : location.pathname);
        window.history.pushState(null, "", o);
      } else window.history.pushState(null, "", t);
      this.productsContainer &&
        (this.productsContainer.classList.add(classes$m.loading),
        fetch("" + window.location.pathname + window.location.search)
          .then((e) => e.text())
          .then((e) => {
            if (
              ((this.productsContainer.innerHTML = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(selectors$s.productsContainer).innerHTML),
              this.sidebar)
            ) {
              this.sidebar.innerHTML = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(selectors$s.collectionSidebar).innerHTML;
              var e = this.sidebar.querySelector(
                  `[${selectors$s.activeFiltersCount}]`
                ),
                t = this.container.querySelectorAll(selectors$s.activeFilters);
              if (e && t.length) {
                const s = parseInt(
                  e.getAttribute(selectors$s.activeFiltersCount)
                );
                t.forEach((e) => {
                  (e.textContent = s),
                    e.classList.toggle(classes$m.hidden, s < 1);
                });
              }
            }
            this.form &&
              ((this.form = this.container.querySelector(selectors$s.form)),
              this.initRangeSlider()),
              new Collection(this.section).onUnload(!1),
              makeGridSwatches(this.section),
              new Siblings(this.section),
              document.dispatchEvent(
                new CustomEvent("theme:tooltip:close", {
                  bubbles: !1,
                  detail: { hideTransition: !1 },
                })
              ),
              this.collectionNav &&
                scrollTo(this.collectionNav.getBoundingClientRect().top),
              setTimeout(() => {
                this.productsContainer.classList.remove(classes$m.loading);
              }, 500);
          })
          .catch((e) => {
            console.log(e);
          }));
    }
    updateRange(e) {
      var t, s, i, o, r, a;
      this.form &&
        "function" == typeof this.form.submit &&
        ((r = this.form.querySelector(selectors$s.rangeMin)),
        (a = this.form.querySelector(selectors$s.rangeMax)),
        (t = this.form.querySelector(selectors$s.priceMin)),
        (s = this.form.querySelector(selectors$s.priceMax)),
        r) &&
        a &&
        t &&
        s &&
        r.hasAttribute(selectors$s.rangeMinValue) &&
        a.hasAttribute(selectors$s.rangeMaxValue) &&
        ((i = parseInt(t.placeholder)),
        (o = parseInt(s.placeholder)),
        (r = parseInt(r.getAttribute(selectors$s.rangeMinValue))),
        (a = parseInt(a.getAttribute(selectors$s.rangeMaxValue))),
        (i === r && o === a) ||
          ((t.value = r), (s.value = a), this.submitForm(e)));
    }
  }
  const collectionFiltersForm = {
      onLoad() {
        sections$j[this.id] = new FiltersForm(this);
      },
    },
    selectors$r = {
      dataSort: "data-sort-enabled",
      sortLinks: "[data-sort-link]",
      sortValue: "data-value",
      sortButton: "[data-popout-toggle]",
      sortButtonText: "[data-sort-button-text]",
      collectionSidebarHeading: "[data-collection-sidebar-heading]",
      collectionSidebar: "[data-collection-sidebar]",
      collectionSidebarSlider: "[data-collection-sidebar-slider]",
      collectionSidebarSlideOut: "[data-collection-sidebar-slide-out]",
      collectionSidebarCloseButton: "[data-collection-sidebar-close]",
      showMoreOptions: "[data-show-more]",
      groupTagsButton: "[data-aria-toggle]",
      collectionNav: "[data-collection-nav]",
      linkHidden: "[data-link-hidden]",
      underlay: "[data-drawer-underlay]",
      swatch: "data-swatch",
      animation: "[data-animation]",
    },
    classes$l = {
      animated: "drawer--animated",
      hiding: "is-hiding",
      expanded: "expanded",
      noMobileAnimation: "no-mobile-animation",
      hidden: "is-hidden",
      active: "is-active",
      focused: "is-focused",
    };
  let sections$i = {};
  class Collection {
    constructor(e) {
      (this.container = e.container),
        (this.sort = this.container.querySelector(`[${selectors$r.dataSort}]`)),
        (this.sortButton = this.container.querySelector(
          selectors$r.sortButton
        )),
        (this.sortLinks = this.container.querySelectorAll(
          selectors$r.sortLinks
        )),
        (this.collectionSidebar = this.container.querySelector(
          selectors$r.collectionSidebar
        )),
        (this.collectionSidebarCloseButtons = this.container.querySelectorAll(
          selectors$r.collectionSidebarCloseButton
        )),
        (this.groupTagsButton = this.container.querySelector(
          selectors$r.groupTagsButton
        )),
        (this.collectionNav = this.container.querySelector(
          selectors$r.collectionNav
        )),
        (this.showMoreOptions = this.container.querySelectorAll(
          selectors$r.showMoreOptions
        )),
        (this.collectionSidebarHeading = this.container.querySelectorAll(
          selectors$r.collectionSidebarHeading
        )),
        (this.underlay = this.container.querySelector(selectors$r.underlay)),
        (this.swatches = this.container.querySelectorAll(
          `[${selectors$r.swatch}]`
        )),
        (this.accessibility = a11y),
        (this.groupTagsButtonClickEvent = (e) => this.groupTagsButtonClick(e)),
        (this.collectionSidebarCloseEvent = (e) =>
          this.collectionSidebarClose(e)),
        (this.collectionSidebarScrollEvent = () =>
          this.collectionSidebarScroll()),
        (this.onSortButtonClickEvent = (e) => this.onSortButtonClick(e)),
        (this.onSortCheckEvent = (e) => this.onSortCheck(e)),
        (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
        this.init();
    }
    init() {
      this.sort && this.initSort(),
        null !== this.groupTagsButton &&
          (document.addEventListener("theme:resize", this.sidebarResizeEvent),
          this.groupTagsButton.addEventListener(
            "click",
            this.groupTagsButtonClickEvent
          ),
          this.collectionSidebar &&
            setTimeout(() => {
              this.collectionSidebar.classList.remove(
                classes$l.noMobileAnimation
              );
            }, 1e3),
          new MutationObserver((e) => {
            for (const t of e)
              "attributes" === t.type &&
                "true" == t.target.ariaExpanded &&
                this.showSidebarCallback();
          }).observe(this.groupTagsButton, {
            attributes: !0,
            childList: !1,
            subtree: !1,
          })),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((e) => {
            e.addEventListener("click", this.collectionSidebarCloseEvent);
          }),
        this.container.addEventListener(
          "keyup",
          function (e) {
            e.code === window.theme.keyboardKeys.ESCAPE && this.hideSidebar();
          }.bind(this)
        ),
        this.underlay &&
          this.underlay.addEventListener(
            "click",
            this.collectionSidebarCloseEvent
          ),
        this.showMoreOptions &&
          this.showMoreOptions.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault(),
                t.parentElement.classList.add(classes$l.hidden),
                t.parentElement.previousElementSibling
                  .querySelectorAll(selectors$r.linkHidden)
                  .forEach((e, t) => {
                    e.classList.remove(classes$l.hidden),
                      0 === t && (window.accessibility.lastFocused = e);
                  }),
                this.container.querySelector(
                  selectors$r.collectionSidebarSlideOut
                ) &&
                  (this.accessibility.removeTrapFocus(),
                  this.accessibility.trapFocus(this.collectionSidebar, {
                    elementToFocus: window.accessibility.lastFocused,
                  }));
            });
          }),
        this.collectionSidebarHeading &&
          this.collectionSidebarHeading.forEach((e) => {
            e.addEventListener("click", (e) => this.collectionAccordion(e)),
              e.addEventListener("keyup", (e) => {
                (e.code !== window.theme.keyboardKeys.SPACE &&
                  e.code !== window.theme.keyboardKeys.ENTER) ||
                  !document.body.classList.contains(classes$l.focused) ||
                  ((window.accessibility.lastFocused = e.currentTarget),
                  this.collectionAccordion(e));
              });
          }),
        this.swatches &&
          this.swatches.forEach((e) => {
            new Swatch(e);
          }),
        this.collectionSidebar &&
          (this.collectionSidebar.addEventListener("transitionend", () => {
            this.collectionSidebar.classList.contains(classes$l.expanded) ||
              this.collectionSidebar.classList.remove(classes$l.animated);
          }),
          this.toggleSidebarSlider());
    }
    collectionAccordion(e) {
      e.preventDefault();
      e = e.currentTarget;
      e.classList.toggle(classes$l.active),
        slideToggle(e.nextElementSibling, 500),
        e.nextElementSibling.nextElementSibling &&
          slideToggle(e.nextElementSibling.nextElementSibling, 500);
      const t = this.container.querySelector(
        selectors$r.collectionSidebarSlideOut
      );
      if (t) {
        const s = () => {
          this.accessibility.removeTrapFocus(),
            this.accessibility.trapFocus(this.collectionSidebar),
            this.accessibility.trapFocus(this.collectionSidebar, {
              elementToFocus: window.accessibility.lastFocused,
            }),
            t.removeEventListener("transitionend", s);
        };
        t.addEventListener("transitionend", s);
      }
    }
    collectionSidebarScroll() {
      document.dispatchEvent(
        new CustomEvent("theme:tooltip:close", {
          bubbles: !1,
          detail: { hideTransition: !1 },
        })
      );
    }
    sortActions(e, t = !0) {
      var s,
        i = e ? e.getAttribute(selectors$r.sortValue) : "",
        o =
          (this.sort.setAttribute(selectors$r.dataSort, i),
          this.sort.querySelector(selectors$r.sortButtonText)),
        r = this.sort.querySelector("." + classes$l.active);
      o && ((s = e ? e.textContent.trim() : ""), (o.textContent = s)),
        r && r.classList.remove(classes$l.active),
        this.sort.classList.toggle(classes$l.active, e),
        e &&
          (e.parentElement.classList.add(classes$l.active), t) &&
          e.dispatchEvent(
            new CustomEvent("theme:filter:update", {
              bubbles: !0,
              detail: { href: i },
            })
          );
    }
    onSortButtonClick(e) {
      e.preventDefault(),
        this.sortButton && this.sortButton.dispatchEvent(new Event("click")),
        this.sortActions(e.currentTarget);
    }
    onSortCheck(e) {
      let t = null;
      var s, i;
      if (window.location.search.includes("sort_by"))
        for ([s, i] of new window.URL(
          window.location.href
        ).searchParams.entries()) {
          var o = this.sort.querySelector(`[${selectors$r.sortValue}="${i}"]`);
          if (s.includes("sort_by") && o) {
            t = o;
            break;
          }
        }
      this.sortActions(t, !1);
    }
    initSort() {
      this.sortLinks.forEach((e) => {
        e.addEventListener("click", this.onSortButtonClickEvent);
      }),
        this.sort.addEventListener("theme:filter:sort", this.onSortCheckEvent),
        this.sortButton &&
          this.sortButton.addEventListener("click", () => {
            var e =
                (window.innerWidth ||
                  document.documentElement.clientWidth ||
                  document.body.clientWidth) < theme.sizes.small,
              t = this.collectionSidebar.classList.contains(classes$l.expanded);
            e && t && this.hideSidebar();
          });
    }
    showSidebarCallback() {
      var e =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        t = this.container.querySelector(selectors$r.collectionSidebarSlider),
        s = this.container.querySelector(selectors$r.collectionSidebarSlideOut),
        t = t || s,
        i = document.documentElement.hasAttribute("data-scroll-locked");
      this.collectionSidebar.classList.add(classes$l.animated),
        null === s &&
          e > theme.sizes.small &&
          i &&
          (this.accessibility.removeTrapFocus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          )),
        (e < theme.sizes.small || null !== s) &&
          (s &&
            this.accessibility.trapFocus(this.collectionSidebar, {
              elementToFocus: this.collectionSidebar.querySelector(
                selectors$r.collectionSidebarCloseButton
              ),
            }),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t })
          )),
        t && t.addEventListener("scroll", this.collectionSidebarScrollEvent);
    }
    hideSidebar() {
      var e = this.container.querySelector(selectors$r.collectionSidebarSlider),
        t = this.container.querySelector(selectors$r.collectionSidebarSlideOut),
        e = e || t,
        s = document.documentElement.hasAttribute("data-scroll-locked");
      this.groupTagsButton.setAttribute("aria-expanded", "false"),
        this.collectionSidebar.classList.remove(classes$l.expanded),
        e && e.removeEventListener("scroll", this.collectionSidebarScrollEvent),
        t && this.accessibility.removeTrapFocus(),
        s &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    toggleSidebarSlider() {
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < theme.sizes.small
        ? this.hideSidebar()
        : this.collectionSidebar.classList.contains(classes$l.expanded) &&
          this.showSidebarCallback();
    }
    collectionSidebarClose(e) {
      e.preventDefault(),
        this.hideSidebar(),
        document.body.classList.contains(classes$l.focused) &&
          this.groupTagsButton &&
          this.groupTagsButton.focus();
    }
    groupTagsButtonClick() {
      document.documentElement.hasAttribute("data-scroll-locked") &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    onUnload(e = !0) {
      null !== this.groupTagsButton &&
        (document.removeEventListener("theme:resize", this.sidebarResizeEvent),
        this.groupTagsButton.removeEventListener(
          "click",
          this.groupTagsButtonClickEvent
        )),
        this.collectionSidebarCloseButtons.length &&
          e &&
          this.collectionSidebarCloseButtons.forEach((e) => {
            e.removeEventListener("click", this.collectionSidebarCloseEvent);
          }),
        this.collectionSidebarScrollable & e &&
          this.collectionSidebarScrollable.removeEventListener(
            "scroll",
            this.collectionSidebarScrollEvent
          ),
        this.underlay &&
          this.underlay.removeEventListener(
            "click",
            this.collectionSidebarCloseEvent
          ),
        this.sort &&
          (this.sortLinks.forEach((e) => {
            e.removeEventListener("click", this.onClickEvent);
          }),
          this.sort.removeEventListener(
            "theme:filter:sort",
            this.onSortCheckEvent
          ));
    }
  }
  const collectionSection = {
      onLoad() {
        sections$i[this.id] = new Collection(this);
      },
      onUnload() {
        sections$i[this.id].onUnload();
      },
    },
    selectors$q =
      (register("collection", [
        slider,
        parallaxHero,
        collectionSection,
        popoutSection,
        swatchGridSection,
        collectionFiltersForm,
        tooltipSection,
        siblings,
      ]),
      customElements.get("quick-add-product") ||
        customElements.define("quick-add-product", QuickAddProduct),
      {
        frame: "[data-ticker-frame]",
        scale: "[data-ticker-scale]",
        text: "[data-ticker-text]",
        clone: "data-clone",
      }),
    attributes$7 = { speed: "data-marquee-speed" },
    classes$k = {
      animation: "ticker--animated",
      unloaded: "ticker--unloaded",
      comparitor: "ticker__comparitor",
    },
    settings = { textAnimationTime: 1.63, space: 100 };
  class Ticker {
    constructor(e, t = !1) {
      (this.frame = e),
        (this.stopClone = t),
        (this.scale = this.frame.querySelector(selectors$q.scale)),
        (this.text = this.frame.querySelector(selectors$q.text)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(classes$k.comparitor),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(classes$k.unloaded),
        (this.resizeEvent = debounce(() => this.checkWidth(), 100)),
        this.listen();
    }
    unload() {
      document.removeEventListener("theme:resize", this.resizeEvent);
    }
    listen() {
      document.addEventListener("theme:resize", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      var e =
          2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", ""),
        t = this.frame.getAttribute(attributes$7.speed)
          ? this.frame.getAttribute(attributes$7.speed)
          : settings.textAnimationTime;
      if (
        this.frame.clientWidth - e < this.comparitor.clientWidth ||
        this.stopClone
      ) {
        if (
          (this.text.classList.add(classes$k.animation),
          1 === this.scale.childElementCount)
        ) {
          if (
            ((this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(selectors$q.clone, ""),
            this.scale.appendChild(this.clone),
            this.stopClone)
          )
            for (let e = 0; e < 10; e++) {
              var s = this.text.cloneNode(!0);
              s.setAttribute(selectors$q.clone, ""), this.scale.appendChild(s);
            }
          e = ((this.text.clientWidth / settings.space) * Number(t)).toFixed(2);
          this.scale.style.setProperty("--animation-time", e + "s");
        }
      } else {
        this.text.classList.add(classes$k.animation);
        t = this.scale.querySelector(`[${selectors$q.clone}]`);
        t && this.scale.removeChild(t),
          this.text.classList.remove(classes$k.animation);
      }
    }
  }
  const selectors$p = {
      bar: "[data-bar]",
      barSlide: "[data-slide]",
      frame: "[data-ticker-frame]",
      header: "[data-header-wrapper]",
      slider: "[data-slider]",
      marquee: "[data-marquee]",
      tickerScale: "[data-ticker-scale]",
      tickerText: "[data-ticker-text]",
    },
    classes$j = { tickerAnimated: "ticker--animated" },
    attributes$6 = {
      slide: "data-slide",
      stop: "data-stop",
      style: "style",
      targetReferrer: "data-target-referrer",
    },
    sections$h = {};
  class Bar {
    constructor(e) {
      (this.barHolder = e),
        (this.locationPath = location.href),
        (this.slides = this.barHolder.querySelectorAll(selectors$p.barSlide)),
        (this.slider = this.barHolder.querySelector(selectors$p.slider)),
        (this.marquee = this.barHolder.querySelector(selectors$p.marquee)),
        this.init();
    }
    init() {
      this.removeAnnouncement(),
        this.slider && this.initSliders(),
        this.marquee && this.initTickers(!0),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    removeAnnouncement() {
      for (let e = 0; e < this.slides.length; e++) {
        var t = this.slides[e];
        !t.hasAttribute(attributes$6.targetReferrer) ||
          -1 !==
            this.locationPath.indexOf(
              t.getAttribute(attributes$6.targetReferrer)
            ) ||
          window.Shopify.designMode ||
          t.parentNode.removeChild(t);
      }
    }
    initSliders() {
      (this.slider = new Slider(this.barHolder)),
        this.slider.flkty
          ? (this.slider.flkty.reposition(),
            this.barHolder.addEventListener("theme:slider:loaded", () => {
              this.initTickers();
            }))
          : this.initTickers();
    }
    initTickers(t = !1) {
      this.barHolder.querySelectorAll(selectors$p.frame).forEach((e) => {
        new Ticker(e, t);
      });
    }
    toggleTicker(e, t) {
      var s = document.querySelector(selectors$p.tickerScale);
      const i = document.querySelector(
        `[${attributes$6.slide}="${e.detail.blockId}"]`
      );
      t &&
        i &&
        (s.setAttribute(attributes$6.stop, ""),
        s.querySelectorAll(selectors$p.tickerText).forEach((e) => {
          e.classList.remove(classes$j.tickerAnimated),
            (e.style.transform = `translate3d(${-(
              i.offsetLeft - i.clientWidth
            )}px, 0, 0)`);
        })),
        !t &&
          i &&
          (s.querySelectorAll(selectors$p.tickerText).forEach((e) => {
            e.classList.add(classes$j.tickerAnimated),
              e.removeAttribute(attributes$6.style);
          }),
          s.removeAttribute(attributes$6.stop));
    }
    onBlockSelect(e) {
      this.slider ? this.slider.onBlockSelect(e) : this.toggleTicker(e, !0);
    }
    onBlockDeselect(e) {
      this.slider ? this.slider.onBlockDeselect(e) : this.toggleTicker(e, !1);
    }
  }
  const bar = {
      onLoad() {
        sections$h[this.id] = [];
        var e = this.container.querySelector(selectors$p.bar);
        e && sections$h[this.id].push(new Bar(e));
      },
      onBlockSelect(t) {
        sections$h[this.id].length &&
          sections$h[this.id].forEach((e) => {
            "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
          });
      },
      onBlockDeselect(t) {
        sections$h[this.id].length &&
          sections$h[this.id].forEach((e) => {
            "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
          });
      },
    },
    selectors$o =
      (register("announcement", [bar]),
      {
        body: "body",
        drawerWrappper: "[data-drawer]",
        drawerContent: "[data-drawer-content]",
        underlay: "[data-drawer-underlay]",
        stagger: "[data-stagger-animation]",
        wrapper: "[data-header-transparent]",
        transparent: "data-header-transparent",
        drawerToggle: "data-drawer-toggle",
        scrollableElements: "[data-sliderule-pane], [data-sliderule]",
        focusable:
          'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
      }),
    classes$i = {
      animated: "drawer--animated",
      visible: "drawer--visible",
      isFocused: "is-focused",
      headerStuck: "js__header__stuck",
    };
  let sections$g = {};
  class Drawer {
    constructor(e) {
      (this.drawer = e),
        (this.drawerWrapper = this.drawer.closest(selectors$o.drawerWrappper)),
        (this.drawerContent = this.drawer.querySelector(
          selectors$o.drawerContent
        )),
        (this.scrollableElements = this.drawer.querySelectorAll(
          selectors$o.scrollableElements
        )),
        (this.underlay = this.drawer.querySelector(selectors$o.underlay)),
        (this.wrapper = this.drawer.closest(selectors$o.wrapper)),
        (this.key = this.drawer.dataset.drawer),
        (this.btnSelector = `[${selectors$o.drawerToggle}='${this.key}']`),
        (this.buttons = document.querySelectorAll(this.btnSelector)),
        (this.staggers = this.drawer.querySelectorAll(selectors$o.stagger)),
        (this.body = document.querySelector(selectors$o.body)),
        (this.accessibility = a11y),
        (this.initWatchFocus = (e) => this.watchFocus(e)),
        (this.showDrawer = this.showDrawer.bind(this)),
        (this.hideDrawer = this.hideDrawer.bind(this)),
        this.connectToggle(),
        this.connectDrawer(),
        this.closers();
    }
    connectToggle() {
      this.buttons.forEach((e) => {
        e.addEventListener("click", () => {
          this.drawer.dispatchEvent(
            new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
          );
        });
      });
    }
    connectDrawer() {
      this.drawer.addEventListener("theme:drawer:toggle", () => {
        this.drawer.classList.contains(classes$i.visible)
          ? this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:close", { bubbles: !0 })
            )
          : this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:open", { bubbles: !0 })
            );
      }),
        this.drawerContent &&
          this.drawerContent.addEventListener("transitionend", () => {
            this.drawer.classList.contains(classes$i.visible) ||
              (this.drawer.classList.remove(classes$i.animated),
              document.dispatchEvent(
                new CustomEvent("theme:sliderule:close", { bubbles: !1 })
              ));
          }),
        document.addEventListener("theme:cart:open", this.hideDrawer),
        document.addEventListener("theme:drawer:close", this.hideDrawer),
        document.addEventListener("theme:drawer:open", this.showDrawer);
    }
    watchFocus(e) {
      !this.wrapper.contains(e.target) &&
        this.body.classList.contains(classes$i.isFocused) &&
        this.hideDrawer();
    }
    closers() {
      this.wrapper.addEventListener(
        "keyup",
        function (e) {
          e.code === window.theme.keyboardKeys.ESCAPE &&
            (this.hideDrawer(), this.buttons[0].focus());
        }.bind(this)
      ),
        this.underlay.addEventListener("click", () => {
          this.hideDrawer();
        });
    }
    showDrawer() {
      var e;
      this.drawerContent &&
        this.drawerContent.querySelector(this.btnSelector) &&
        (this.accessibility.removeTrapFocus(),
        (e =
          1e3 *
          parseFloat(
            window.getComputedStyle(this.drawerContent).transitionDuration
          )),
        setTimeout(() => {
          this.accessibility.trapFocus(this.drawerContent, {
            elementToFocus: this.drawerContent.querySelector(this.btnSelector),
          });
        }, e)),
        document.dispatchEvent(
          new CustomEvent("theme:drawer:close", { bubbles: !1 })
        ),
        this.buttons.forEach((e) => {
          e.setAttribute("aria-expanded", !0);
        }),
        this.drawer.classList.add(classes$i.visible),
        this.drawer.classList.add(classes$i.animated),
        this.drawer.querySelector(selectors$o.focusable).focus(),
        this.wrapper.setAttribute(selectors$o.transparent, !1),
        document.addEventListener("focusin", this.initWatchFocus),
        this.scrollableElements.length &&
          this.scrollableElements.forEach((e) => {
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: e })
            );
          });
    }
    hideDrawer() {
      this.drawer.classList.contains(classes$i.visible) &&
        (this.accessibility.removeTrapFocus(),
        this.body.classList.contains(classes$i.isFocused) &&
          this.buttons.length &&
          this.buttons[0].focus(),
        this.buttons.forEach((e) => {
          e.setAttribute("aria-expanded", !1);
        }),
        this.drawer.classList.remove(classes$i.visible),
        document.removeEventListener("focusin", this.initWatchFocus),
        this.wrapper.classList.contains(classes$i.headerStuck) ||
          this.wrapper.setAttribute(
            selectors$o.transparent,
            theme.settings.transparentHeader
          ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ));
    }
    onUnload() {
      document.removeEventListener("theme:cart:open", this.hideDrawer),
        document.removeEventListener("theme:drawer:close", this.hideDrawer),
        document.removeEventListener("theme:drawer:open", this.showDrawer);
    }
  }
  const drawer = {
      onLoad() {
        (sections$g[this.id] = []),
          this.container
            .querySelectorAll(selectors$o.drawerWrappper)
            .forEach((e) => {
              sections$g[this.id].push(new Drawer(e));
            });
      },
      onUnload() {
        sections$g[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
    },
    selectors$n = {
      announcement: "[data-announcement-wrapper]",
      headerWrapper: "[data-header-wrapper]",
      header: "[data-header-wrapper] header",
    },
    classes$h = {
      stuck: "js__header__stuck",
      stuckAnimated: "js__header__stuck--animated",
      triggerAnimation: "js__header__stuck--trigger-animation",
      stuckBackdrop: "js__header__stuck__backdrop",
      headerIsNotVisible: "is-not-visible",
      hasStickyHeader: "has-sticky-header",
    },
    attributes$5 = {
      transparent: "data-header-transparent",
      stickyHeader: "data-header-sticky",
      scrollLock: "data-scroll-locked",
    };
  let sections$f = {};
  class Sticky {
    constructor(e) {
      (this.wrapper = e),
        (this.type = this.wrapper.dataset.headerSticky),
        (this.sticks = !1),
        (this.static = !0),
        this.wrapper.hasAttribute(attributes$5.stickyHeader) &&
          ((this.sticks = !0), (this.static = !1)),
        (this.win = window),
        (this.animated = "directional" === this.type),
        (this.currentlyStuck = !1),
        (this.cls = this.wrapper.classList);
      (e = document.querySelector(selectors$n.announcement)),
        (e = e ? e.clientHeight : 0);
      (this.headerHeight = document.querySelector(
        selectors$n.header
      ).clientHeight),
        (this.blur = this.headerHeight + e),
        (this.stickDown = this.headerHeight + e),
        (this.stickUp = e),
        (this.scrollEventStatic = () => this.checkIsVisible()),
        (this.scrollEventListen = (e) => this.listenScroll(e)),
        (this.scrollEventUpListen = () => this.scrollUpDirectional()),
        (this.scrollEventDownListen = () => this.scrollDownDirectional()),
        "false" !== this.wrapper.getAttribute(attributes$5.transparent) &&
          (this.blur = e),
        this.sticks &&
          ((this.stickDown = e),
          this.scrollDownInit(),
          document.body.classList.add(classes$h.hasStickyHeader)),
        this.static &&
          document.addEventListener("theme:scroll", this.scrollEventStatic),
        this.listen();
    }
    unload() {
      (this.sticks || this.animated) &&
        document.removeEventListener("theme:scroll", this.scrollEventListen),
        this.animated &&
          (document.removeEventListener(
            "theme:scroll:up",
            this.scrollEventUpListen
          ),
          document.removeEventListener(
            "theme:scroll:down",
            this.scrollEventDownListen
          )),
        this.static &&
          document.removeEventListener("theme:scroll", this.scrollEventStatic);
    }
    listen() {
      (this.sticks || this.animated) &&
        document.addEventListener("theme:scroll", this.scrollEventListen),
        this.animated &&
          (document.addEventListener(
            "theme:scroll:up",
            this.scrollEventUpListen
          ),
          document.addEventListener(
            "theme:scroll:down",
            this.scrollEventDownListen
          ));
    }
    listenScroll(e) {
      e.detail.down
        ? (!this.currentlyStuck &&
            e.detail.position > this.stickDown &&
            this.stickSimple(),
          !this.currentlyBlurred &&
            e.detail.position > this.blur &&
            this.addBlur())
        : (e.detail.position <= this.stickUp && this.unstickSimple(),
          e.detail.position <= this.blur && this.removeBlur());
    }
    stickSimple() {
      this.animated && this.cls.add(classes$h.stuckAnimated),
        this.cls.add(classes$h.stuck),
        this.wrapper.setAttribute(attributes$5.transparent, !1),
        (this.currentlyStuck = !0);
    }
    unstickSimple() {
      document.documentElement.hasAttribute(attributes$5.scrollLock) ||
        (this.cls.remove(classes$h.stuck),
        this.wrapper.setAttribute(
          attributes$5.transparent,
          theme.settings.transparentHeader
        ),
        this.animated && this.cls.remove(classes$h.stuckAnimated),
        (this.currentlyStuck = !1));
    }
    scrollDownInit() {
      window.scrollY > this.stickDown && this.stickSimple(),
        window.scrollY > this.blur && this.addBlur();
    }
    stickDirectional() {
      this.cls.add(classes$h.triggerAnimation);
    }
    unstickDirectional() {
      this.cls.remove(classes$h.triggerAnimation);
    }
    scrollDownDirectional() {
      this.unstickDirectional();
    }
    scrollUpDirectional() {
      window.scrollY <= this.stickDown
        ? this.unstickDirectional()
        : this.stickDirectional();
    }
    addBlur() {
      this.cls.add(classes$h.stuckBackdrop), (this.currentlyBlurred = !0);
    }
    removeBlur() {
      this.cls.remove(classes$h.stuckBackdrop), (this.currentlyBlurred = !1);
    }
    checkIsVisible() {
      var e = document.querySelector(selectors$n.headerWrapper),
        t = e.getAttribute(attributes$5.stickyHeader),
        s = this.win.pageYOffset;
      t ||
        e.classList.toggle(
          classes$h.headerIsNotVisible,
          s >= this.headerHeight
        );
    }
  }
  const stickyHeader = {
      onLoad() {
        sections$f = new Sticky(this.container);
      },
      onUnload: function () {
        "function" == typeof sections$f.unload && sections$f.unload();
      },
    },
    selectors$m = {
      disclosureToggle: "data-hover-disclosure-toggle",
      disclosureWrappper: "[data-hover-disclosure]",
      link: "[data-top-link]",
      wrapper: "[data-header-wrapper]",
      stagger: "[data-stagger]",
      staggerPair: "[data-stagger-first]",
      staggerAfter: "[data-stagger-second]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    },
    classes$g = {
      isVisible: "is-visible",
      meganavVisible: "meganav--visible",
      meganavIsTransitioning: "meganav--is-transitioning",
    };
  let sections$e = {},
    disclosures = {};
  class HoverDisclosure {
    constructor(e) {
      (this.disclosure = e),
        (this.wrapper = e.closest(selectors$m.wrapper)),
        (this.key = this.disclosure.id),
        (this.trigger = document.querySelector(
          `[${selectors$m.disclosureToggle}='${this.key}']`
        )),
        (this.link = this.trigger.querySelector(selectors$m.link)),
        (this.grandparent = this.trigger.classList.contains("grandparent")),
        (this.transitionTimeout = 0),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.connectHoverToggle(),
        this.handleTablets(),
        this.staggerChildAnimations();
    }
    onBlockSelect(e) {
      this.disclosure.contains(e.target) && this.showDisclosure(e);
    }
    onBlockDeselect(e) {
      this.disclosure.contains(e.target) && this.hideDisclosure();
    }
    showDisclosure(e) {
      e &&
        e.type &&
        "mouseenter" === e.type &&
        this.wrapper.classList.add(classes$g.meganavIsTransitioning),
        this.grandparent
          ? this.wrapper.classList.add(classes$g.meganavVisible)
          : this.wrapper.classList.remove(classes$g.meganavVisible),
        this.trigger.setAttribute("aria-expanded", !0),
        this.trigger.classList.add(classes$g.isVisible),
        this.disclosure.classList.add(classes$g.isVisible),
        this.transitionTimeout && clearTimeout(this.transitionTimeout),
        (this.transitionTimeout = setTimeout(() => {
          this.wrapper.classList.remove(classes$g.meganavIsTransitioning);
        }, 200));
    }
    hideDisclosure() {
      this.disclosure.classList.remove(classes$g.isVisible),
        this.trigger.classList.remove(classes$g.isVisible),
        this.trigger.setAttribute("aria-expanded", !1),
        this.wrapper.classList.remove(
          classes$g.meganavVisible,
          classes$g.meganavIsTransitioning
        );
    }
    staggerChildAnimations() {
      this.disclosure.querySelectorAll(selectors$m.stagger).forEach((e, t) => {
        e.style.transitionDelay = 50 * t + 10 + "ms";
      }),
        this.disclosure
          .querySelectorAll(selectors$m.staggerPair)
          .forEach((e, t) => {
            const s = 100 * t;
            (e.style.transitionDelay = s + "ms"),
              e.parentElement
                .querySelectorAll(selectors$m.staggerAfter)
                .forEach((e, t) => {
                  t = 20 * (t + 1);
                  e.style.transitionDelay = s + t + "ms";
                });
          });
    }
    handleTablets() {
      this.trigger.addEventListener(
        "touchstart",
        function (e) {
          this.disclosure.classList.contains(classes$g.isVisible) ||
            (e.preventDefault(), this.showDisclosure(e));
        }.bind(this),
        { passive: !0 }
      );
    }
    connectHoverToggle() {
      this.trigger.addEventListener("mouseenter", (e) =>
        this.showDisclosure(e)
      ),
        this.link.addEventListener("focus", (e) => this.showDisclosure(e)),
        this.trigger.addEventListener("mouseleave", () =>
          this.hideDisclosure()
        ),
        this.trigger.addEventListener("focusout", (e) => {
          this.trigger.contains(e.relatedTarget) || this.hideDisclosure();
        }),
        this.disclosure.addEventListener("keyup", (e) => {
          e.code === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure();
        });
    }
  }
  const hoverDisclosure = {
      onLoad() {
        (sections$e[this.id] = []),
          (disclosures = this.container.querySelectorAll(
            selectors$m.disclosureWrappper
          )).forEach((e) => {
            sections$e[this.id].push(new HoverDisclosure(e));
          });
      },
      onBlockSelect(t) {
        sections$e[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        sections$e[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    selectors$l = { count: "data-cart-count" };
  class Totals {
    constructor(e) {
      (this.section = e),
        (this.counts = this.section.querySelectorAll(`[${selectors$l.count}]`)),
        (this.cart = null),
        this.listen();
    }
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), this.update();
        }.bind(this)
      );
    }
    update() {
      this.cart &&
        this.counts.forEach((e) => {
          e.setAttribute(selectors$l.count, this.cart.item_count),
            (e.innerHTML =
              this.cart.item_count < 10 ? "" + this.cart.item_count : "9+");
        });
    }
  }
  const headerTotals = {
      onLoad() {
        new Totals(this.container);
      },
    },
    selectors$k = {
      body: "body",
      popdownTrigger: "data-popdown-toggle",
      close: "[data-popdown-close]",
      input: "[data-predictive-search-input]",
    },
    classes$f = { isVisible: "is-visible", focused: "is-focused" };
  let sections$d = {};
  class SearchPopdownTriggers {
    constructor(e) {
      (this.trigger = e),
        (this.key = this.trigger.getAttribute(selectors$k.popdownTrigger));
      e = `[id='${this.key}']`;
      (this.document = document),
        (this.popdown = document.querySelector(e)),
        (this.input = this.popdown.querySelector(selectors$k.input)),
        (this.close = this.popdown.querySelector(selectors$k.close)),
        (this.body = document.querySelector(selectors$k.body)),
        (this.accessibility = a11y),
        this.initTriggerEvents(),
        this.initPopdownEvents();
    }
    initTriggerEvents() {
      this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.trigger.addEventListener("click", (e) => {
          e.preventDefault(),
            this.body.classList.contains(classes$f.focused) ||
              this.showPopdown();
        }),
        this.trigger.addEventListener("keyup", (e) => {
          (e.code !== window.theme.keyboardKeys.SPACE &&
            e.code !== window.theme.keyboardKeys.ENTER) ||
            !this.body.classList.contains(classes$f.focused) ||
            this.showPopdown();
        });
    }
    initPopdownEvents() {
      this.popdown.addEventListener(
        "keyup",
        function (e) {
          e.code === window.theme.keyboardKeys.ESCAPE && this.hidePopdown();
        }.bind(this)
      ),
        this.close.addEventListener(
          "click",
          function () {
            this.hidePopdown();
          }.bind(this)
        ),
        this.document.addEventListener("click", (e) => {
          var e = e.target,
            t = !(
              e.matches(`[${selectors$k.popdownTrigger}]`) ||
              e.closest(`[${selectors$k.popdownTrigger}]`)
            ),
            e = !(e.matches("#" + this.key) || e.closest("#" + this.key));
          t &&
            e &&
            this.popdown.classList.contains(classes$f.isVisible) &&
            this.hidePopdown();
        });
    }
    hidePopdown() {
      this.popdown.classList.remove(classes$f.isVisible),
        this.input.form.reset(),
        this.input.dispatchEvent(new CustomEvent("clear", { bubbles: !1 })),
        this.accessibility.removeTrapFocus(),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        this.body.classList.contains(classes$f.focused) &&
          setTimeout(() => {
            this.trigger.focus();
          }, 200);
    }
    showPopdown() {
      document.dispatchEvent(
        new CustomEvent("theme:drawer:close", { bubbles: !1 })
      ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popdown,
          })
        ),
        this.popdown.classList.add(classes$f.isVisible);
      var e =
          1e3 *
          parseFloat(
            window
              .getComputedStyle(this.popdown)
              .getPropertyValue("transition-duration")
          ),
        t = this.input.value;
      (this.input.value = ""),
        (this.input.value = t),
        setTimeout(() => {
          this.accessibility.trapFocus(this.popdown), this.input.focus();
        }, e);
    }
  }
  const searchPopdown = {
      onLoad() {
        (sections$d[this.id] = []),
          this.container
            .querySelectorAll(`[${selectors$k.popdownTrigger}]`)
            .forEach((e) => {
              sections$d[this.id].push(new SearchPopdownTriggers(e));
            });
      },
    },
    selectors$j = {
      apiSearchResults: "[data-api-search-results]",
      searchInput: 'input[type="search"]',
      searchType: 'input[name="type"]',
      searchPopdown: "[data-search-popdown]",
      searchResults: "[data-search-results]",
      searchResultsOuter: "[data-search-results-outer]",
    },
    classes$e = { searched: "is-searched", loading: "is-loading" };
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super(),
        (this.input = this.querySelector(selectors$j.searchInput)),
        (this.searchResults = this.querySelector(selectors$j.searchResults)),
        (this.searchResultsOuter = this.querySelector(
          selectors$j.searchResultsOuter
        )),
        (this.searchPopdown = this.querySelector(selectors$j.searchPopdown)),
        (this.searchType = this.querySelector(selectors$j.searchType).value),
        (this.a11y = a11y),
        this.input.addEventListener(
          "input",
          debounce((e) => {
            var t = e.target.value;
            t && 1 < t.length
              ? (this.searchResultsOuter.classList.add(classes$e.loading),
                this.onChange(e))
              : this.reset();
          }, 300).bind(this)
        ),
        this.input.addEventListener("clear", this.reset.bind(this));
    }
    onChange() {
      var e = this.input.value.trim();
      e.length && this.getSearchResults(e);
    }
    getSearchResults(e) {
      fetch(
        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
          e
        )}&${encodeURIComponent("resources[type]")}=${
          this.searchType
        }&${encodeURIComponent(
          "resources[limit]"
        )}=4&section_id=header-predictive-search`
      )
        .then((e) => {
          if (e.ok) return e.text();
          throw new Error(e.status);
        })
        .then((e) => {
          e = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(selectors$j.apiSearchResults).innerHTML;
          (this.searchResults.innerHTML = e),
            this.searchPopdown.classList.add(classes$e.searched),
            this.searchResultsOuter.classList.remove(classes$e.loading);
        })
        .catch((e) => {
          throw e;
        });
    }
    reset() {
      (this.searchResults.innerHTML = ""),
        this.searchPopdown.classList.remove(classes$e.searched),
        (this.input.val = ""),
        this.a11y.removeTrapFocus();
    }
  }
  const selectors$i = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children: `:scope > [data-animates],
             :scope > * > [data-animates],
             :scope > * > * >[data-animates],
             :scope > * > .sliderule-grid  > *`,
    },
    classes$d = {
      isVisible: "is-visible",
      isHiding: "is-hiding",
      isHidden: "is-hidden",
      scrolling: "is-scrolling",
    };
  let sections$c = {};
  class HeaderMobileSliderule {
    constructor(e) {
      (this.sliderule = e), (this.key = this.sliderule.id);
      e = `[${selectors$i.slideruleOpen}='${this.key}']`;
      (this.exitSelector = `[${selectors$i.slideruleClose}='${this.key}']`),
        (this.trigger = document.querySelector(e)),
        (this.exit = document.querySelectorAll(this.exitSelector)),
        (this.pane = document.querySelector(`[${selectors$i.sliderulePane}]`)),
        (this.children = this.sliderule.querySelectorAll(selectors$i.children)),
        (this.drawerContent = document.querySelector(
          selectors$i.drawerContent
        )),
        (this.cachedButton = null),
        (this.accessibility = a11y),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        (this.closeSliderule = this.closeSliderule.bind(this)),
        this.clickEvents(),
        this.keyboardEvents(),
        document.addEventListener("theme:sliderule:close", this.closeSliderule);
    }
    clickEvents() {
      this.trigger.addEventListener("click", () => {
        (this.cachedButton = this.trigger), this.showSliderule();
      }),
        this.exit.forEach((e) => {
          e.addEventListener("click", () => {
            this.hideSliderule();
          });
        });
    }
    keyboardEvents() {
      this.sliderule.addEventListener("keyup", (e) => {
        e.stopPropagation(),
          e.code === window.theme.keyboardKeys.ESCAPE && this.hideSliderule();
      });
    }
    trapFocusSliderule(e = !0) {
      e = e
        ? this.sliderule.querySelector(this.exitSelector)
        : this.cachedButton;
      this.accessibility.removeTrapFocus(),
        e &&
          this.drawerContent &&
          this.accessibility.trapFocus(this.drawerContent, {
            elementToFocus: e,
          });
    }
    hideSliderule(o = !1) {
      const r = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
      this.pane.setAttribute(selectors$i.sliderulePane, r),
        this.pane.classList.add(classes$d.isHiding),
        this.sliderule.classList.add(classes$d.isHiding);
      var e = o
          ? `[${selectors$i.dataAnimates}].` + classes$d.isHidden
          : `[${selectors$i.dataAnimates}="${r}"]`,
        e = this.pane.querySelectorAll(e);
      e.length &&
        e.forEach((e) => {
          e.classList.remove(classes$d.isHidden);
        });
      const a = o
        ? this.pane.querySelectorAll(
            `.${classes$d.isVisible}, .` + classes$d.isHiding
          )
        : this.children;
      a.forEach((e, t) => {
        const s = a.length - 1 == t,
          i =
            (e.classList.remove(classes$d.isVisible),
            o &&
              (e.classList.remove(classes$d.isHiding),
              this.pane.classList.remove(classes$d.isHiding)),
            () => {
              parseInt(this.pane.getAttribute(selectors$i.sliderulePane)) ===
                r && this.sliderule.classList.remove(classes$d.isVisible),
                this.sliderule.classList.remove(classes$d.isHiding),
                this.pane.classList.remove(classes$d.isHiding),
                s &&
                  (this.accessibility.removeTrapFocus(),
                  o || this.trapFocusSliderule(!1)),
                e.removeEventListener("animationend", i);
            });
        e.addEventListener("animationend", i);
      });
    }
    showSliderule() {
      let e = null;
      var t = this.sliderule.closest("." + classes$d.isVisible);
      let s = this.pane;
      (s = t ? t : s).scrollTo({ top: 0, left: 0, behavior: "smooth" }),
        s.classList.add(classes$d.scrolling);
      const i = () => {
          s.scrollTop <= 0
            ? (s.classList.remove(classes$d.scrolling),
              e && cancelAnimationFrame(e))
            : (e = requestAnimationFrame(i));
        },
        o =
          ((e = requestAnimationFrame(i)),
          this.sliderule.classList.add(classes$d.isVisible),
          parseInt(this.pane.dataset.sliderulePane, 10));
      t = o + 1;
      this.pane.setAttribute(selectors$i.sliderulePane, t);
      const r = this.pane.querySelectorAll(
        `[${selectors$i.dataAnimates}="${o}"]`
      );
      r.length &&
        r.forEach((e, t) => {
          const s = r.length - 1 == t,
            i =
              (e.classList.add(classes$d.isHiding),
              () => {
                e.classList.remove(classes$d.isHiding),
                  parseInt(
                    this.pane.getAttribute(selectors$i.sliderulePane)
                  ) !== o && e.classList.add(classes$d.isHidden),
                  s && this.trapFocusSliderule(),
                  e.removeEventListener("animationend", i);
              });
          e.addEventListener("animationend", i);
        });
    }
    closeSliderule() {
      this.pane &&
        this.pane.hasAttribute(selectors$i.sliderulePane) &&
        0 < parseInt(this.pane.getAttribute(selectors$i.sliderulePane)) &&
        (this.hideSliderule(!0),
        0 < parseInt(this.pane.getAttribute(selectors$i.sliderulePane))) &&
        this.pane.setAttribute(selectors$i.sliderulePane, 0);
    }
    onUnload() {
      document.removeEventListener(
        "theme:sliderule:close",
        this.closeSliderule
      );
    }
  }
  const headerMobileSliderule = {
      onLoad() {
        (sections$c[this.id] = []),
          this.container
            .querySelectorAll(selectors$i.slideruleWrappper)
            .forEach((e) => {
              sections$c[this.id].push(new HeaderMobileSliderule(e));
            });
      },
      onUnload() {
        sections$c[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
    },
    selectors$h = {
      wrapper: "[data-header-wrapper]",
      html: "html",
      style: "data-header-style",
      widthContentWrapper: "[data-takes-space-wrapper]",
      widthContent: "[data-child-takes-space]",
      desktop: "[data-header-desktop]",
      cloneClass: "js__header__clone",
      showMobileClass: "js__show__mobile",
      backfill: "[data-header-backfill]",
      transparent: "data-header-transparent",
      overrideBorder: "header-override-border",
      firstSectionHasImage:
        ".main-content > .shopify-section:first-child [data-overlay-header]",
      preventTransparentHeader:
        ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
      deadLink: '.navlink[href="#"]',
    };
  let sections$b = {};
  class Header {
    constructor(e) {
      (this.wrapper = e),
        (this.html = document.querySelector(selectors$h.html)),
        (this.style = this.wrapper.dataset.style),
        (this.desktop = this.wrapper.querySelector(selectors$h.desktop)),
        (this.isTransparentHeader =
          "false" !== this.wrapper.getAttribute(selectors$h.transparent)),
        (this.overlayedImages = document.querySelectorAll(
          selectors$h.firstSectionHasImage
        )),
        (this.deadLinks = document.querySelectorAll(selectors$h.deadLink)),
        (this.headerUpdateEvent = debounce(() => this.checkForImage(), 500)),
        (this.resizeEventWidth = () => this.checkWidth()),
        (this.resizeEventOverlay = () => this.subtractAnnouncementHeight()),
        this.killDeadLinks(),
        "drawer" !== this.style &&
          this.desktop &&
          ((this.minWidth = this.getMinWidth()), this.listenWidth()),
        this.checkForImage(),
        this.listenSectionEvents(),
        (this.screenOrientation = getScreenOrientation());
    }
    checkForImage() {
      this.overlayedImages = document.querySelectorAll(
        selectors$h.firstSectionHasImage
      );
      var e = document.querySelectorAll(
        selectors$h.preventTransparentHeader
      ).length;
      this.overlayedImages.length && !e && this.isTransparentHeader
        ? (this.listenOverlay(),
          this.wrapper.setAttribute(selectors$h.transparent, !0),
          (document.querySelector(selectors$h.backfill).style.display = "none"),
          (theme.settings.transparentHeader = !0))
        : (this.wrapper.setAttribute(selectors$h.transparent, !1),
          (document.querySelector(selectors$h.backfill).style.display =
            "block"),
          (theme.settings.transparentHeader = !1)),
        !this.overlayedImages.length ||
          e ||
          this.isTransparentHeader ||
          this.wrapper.classList.add(selectors$h.overrideBorder),
        this.subtractAnnouncementHeight();
    }
    listenOverlay() {
      document.addEventListener("theme:resize", this.resizeEventOverlay),
        this.subtractAnnouncementHeight();
    }
    listenWidth() {
      document.addEventListener("theme:resize", this.resizeEventWidth),
        this.checkWidth();
    }
    listenSectionEvents() {
      document.addEventListener("shopify:section:load", this.headerUpdateEvent),
        document.addEventListener(
          "shopify:section:unload",
          this.headerUpdateEvent
        ),
        document.addEventListener(
          "shopify:section:reorder",
          this.headerUpdateEvent
        );
    }
    killDeadLinks() {
      this.deadLinks.forEach((e) => {
        e.onclick = (e) => {
          e.preventDefault();
        };
      });
    }
    subtractAnnouncementHeight() {
      var e = getScreenOrientation();
      const { announcementHeight: t, headerHeight: s } = readHeights();
      let i = readHeights()["windowHeight"];
      this.screenOrientation === e && window.innerWidth < 768
        ? (i = window.initialWindowHeight)
        : (window.initialWindowHeight = i),
        this.overlayedImages.forEach((e) => {
          theme.settings.transparentHeader
            ? e.style.setProperty("--full-screen", i - t + "px")
            : e.style.setProperty("--full-screen", i - s + "px"),
            e.classList.add("has-overlay");
        }),
        this.screenOrientation !== e && (this.screenOrientation = e);
    }
    checkWidth() {
      document.body.clientWidth < this.minWidth
        ? this.wrapper.classList.add(selectors$h.showMobileClass)
        : this.wrapper.classList.remove(selectors$h.showMobileClass);
    }
    getMinWidth() {
      var e = this.wrapper.cloneNode(!0),
        t =
          (e.classList.add(selectors$h.cloneClass),
          document.body.appendChild(e),
          e.querySelectorAll(selectors$h.widthContentWrapper));
      let s = 0,
        i = 0;
      return (
        t.forEach((e) => {
          e = e.querySelectorAll(selectors$h.widthContent);
          let t = 0;
          (t = (3 === e.length ? _sumSplitWidths : _sumWidths)(e)) > s &&
            ((s = t), (i = 20 * e.length));
        }),
        document.body.removeChild(e),
        s + i
      );
    }
    unload() {
      document.removeEventListener("theme:resize", this.resizeEventWidth),
        document.removeEventListener("theme:resize", this.resizeEventOverlay),
        document.removeEventListener(
          "shopify:section:load",
          this.headerUpdateEvent
        ),
        document.removeEventListener(
          "shopify:section:unload",
          this.headerUpdateEvent
        ),
        document.removeEventListener(
          "shopify:section:reorder",
          this.headerUpdateEvent
        );
    }
  }
  function _sumSplitWidths(e) {
    let t = [];
    return (
      e.forEach((e) => {
        e.firstElementChild && t.push(e.firstElementChild.clientWidth);
      }),
      t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]),
      t.reduce((e, t) => e + t)
    );
  }
  function _sumWidths(e) {
    let t = 0;
    return (
      e.forEach((e) => {
        t += e.clientWidth;
      }),
      t
    );
  }
  const header = {
      onLoad() {
        (sections$b = new Header(this.container)), setVarsOnResize();
      },
      onUnload() {
        "function" == typeof sections$b.unload && sections$b.unload();
      },
    },
    selectors$g =
      (register("header", [
        header,
        drawer,
        popoutSection,
        headerMobileSliderule,
        stickyHeader,
        hoverDisclosure,
        headerTotals,
        searchPopdown,
      ]),
      customElements.get("predictive-search") ||
        customElements.define("predictive-search", PredictiveSearch),
      {
        scrollElement: "[data-block-scroll]",
        flickityEnabled: "flickity-enabled",
      }),
    sections$a = {};
  class BlockScroll {
    constructor(e) {
      this.container = e.container;
    }
    onBlockSelect(e) {
      var t = this.container.querySelector(selectors$g.scrollElement);
      t &&
        !t.classList.contains(selectors$g.flickityEnabled) &&
        (e = e.srcElement) &&
        t.scrollTo({ top: 0, left: e.offsetLeft, behavior: "smooth" });
    }
  }
  const blockScroll = {
      onLoad() {
        sections$a[this.id] = new BlockScroll(this);
      },
      onBlockSelect(e) {
        sections$a[this.id].onBlockSelect(e);
      },
    },
    selectors$f = {
      slider: "[data-slider-mobile]",
      slide: "[data-slide]",
      thumb: "[data-slider-thumb]",
      sliderContainer: "[data-slider-container]",
      popupContainer: "[data-popup-container]",
      popupContent: "[data-popup-content]",
      popupClose: "[data-popup-close]",
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    classes$c = {
      isAnimating: "is-animating",
      isSelected: "is-selected",
      isOpen: "is-open",
    },
    attributes$4 = { thumbValue: "data-slider-thumb" },
    sections$9 = {};
  class Look {
    constructor(e) {
      (this.container = e.container),
        (this.slider = this.container.querySelector(selectors$f.slider)),
        (this.slides = this.container.querySelectorAll(selectors$f.slide)),
        (this.thumbs = this.container.querySelectorAll(selectors$f.thumb)),
        (this.popupContainer = this.container.querySelector(
          selectors$f.popupContainer
        )),
        (this.popupContent = this.container.querySelector(
          selectors$f.popupContent
        )),
        (this.popupClose = this.container.querySelectorAll(
          selectors$f.popupClose
        )),
        this.init();
    }
    init() {
      this.slider &&
        this.slides.length &&
        this.thumbs.length &&
        (this.popupContainer.addEventListener("transitionend", () => {
          this.popupContainer.classList.remove(classes$c.isAnimating);
        }),
        this.popupContainer.addEventListener("transitionstart", () => {
          this.popupContainer.classList.add(classes$c.isAnimating);
        }),
        this.popupClose.forEach((e) => {
          e.addEventListener("click", () => {
            this.popupContainer.classList.remove(classes$c.isOpen),
              this.scrollUnlock();
          });
        }),
        this.thumbs.forEach((e, n) => {
          e.addEventListener("click", (t) => {
            t.preventDefault();
            var t =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth,
              s =
                e.hasAttribute(attributes$4.thumbValue) &&
                "" !== e.getAttribute(attributes$4.thumbValue)
                  ? parseInt(e.getAttribute(attributes$4.thumbValue))
                  : n,
              s = this.slides[s];
            if (t < theme.sizes.small) {
              var t = parseInt(
                  window.getComputedStyle(this.slider).paddingLeft
                ),
                i = s.offsetLeft;
              this.slider.scrollTo({ top: 0, left: i - t, behavior: "auto" }),
                this.scrollLock(),
                this.popupContainer.classList.add(
                  classes$c.isAnimating,
                  classes$c.isOpen
                );
            } else {
              var i =
                  document.querySelector(selectors$f.headerSticky) &&
                  document.querySelector(selectors$f.headerHeight)
                    ? document
                        .querySelector(selectors$f.headerHeight)
                        .getBoundingClientRect().height
                    : 0,
                t = s.getBoundingClientRect().top,
                s = s.offsetHeight / 2,
                o = window.innerHeight,
                r = o / 2,
                a = this.container.querySelector(selectors$f.sliderContainer);
              let e = t + s - r + window.scrollY;
              a &&
                ((s =
                  (t = a.getBoundingClientRect().top + window.scrollY) +
                  a.offsetHeight),
                e < t ? (e = t - i) : e + o > s && (e = s - o)),
                window.scrollTo({ top: e, left: 0, behavior: "smooth" });
            }
          });
        }));
    }
    scrollLock() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: this.slider,
        })
      ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupContent,
          })
        );
    }
    scrollUnlock() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
      );
    }
  }
  const lookSection = {
      onLoad() {
        sections$9[this.id] = new Look(this);
      },
    },
    selectors$e =
      (register("look", [
        lookSection,
        swatchGridSection,
        siblings,
        blockScroll,
      ]),
      customElements.get("quick-add-product") ||
        customElements.define("quick-add-product", QuickAddProduct),
      {
        body: "body",
        dataRelatedSectionElem: "[data-related-section]",
        dataTabsHolder: "[data-tabs-holder]",
        dataTab: "data-tab",
        dataTabIndex: "data-tab-index",
        dataTabStartIndex: "data-start-index",
        dataTabStartIndexMobile: "data-start-index-mobile",
        dataAos: "[data-aos]",
        blockId: "data-block-id",
        tabsLi: "[data-tab]",
        tabLink: ".tab-link",
        tabLinkRecent: ".tab-link__recent",
        tabContent: ".tab-content",
        scrollbarHolder: "[data-scrollbar]",
        scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
        scrollbarArrowNext: "[data-scrollbar-arrow-next]",
        productModal: "[data-product-modal]",
      }),
    classes$b = {
      current: "current",
      hide: "hide",
      alt: "alt",
      aosAnimate: "aos-animate",
      aosNoTransition: "aos-no-transition",
      focused: "is-focused",
    },
    sections$8 = {};
  class GlobalTabs {
    constructor(e) {
      (this.container = e),
        (this.body = document.querySelector(selectors$e.body)),
        (this.accessibility = window.accessibility),
        this.container &&
          ((this.scrollbarHolder = this.container.querySelectorAll(
            selectors$e.scrollbarHolder
          )),
          this.init(),
          this.initNativeScrollbar());
    }
    init() {
      var e =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const i = this.container;
      var t = i.querySelectorAll(selectors$e.tabsLi),
        s = i.hasAttribute(selectors$e.dataTabStartIndex)
          ? i.getAttribute(selectors$e.dataTabStartIndex)
          : 0;
      let o = i.querySelector(selectors$e.tabLink + "-" + s),
        r = i.querySelector(selectors$e.tabContent + "-" + s);
      e < theme.sizes.small &&
        ((e = i.hasAttribute(selectors$e.dataTabStartIndexMobile)
          ? i.getAttribute(selectors$e.dataTabStartIndexMobile)
          : s),
        (o = i.querySelector(selectors$e.tabLink + "-" + e)),
        (r = i.querySelector(selectors$e.tabContent + "-" + e))),
        r && r.classList.add(classes$b.current),
        o && o.classList.add(classes$b.current),
        this.checkVisibleTabLinks(),
        this.container.addEventListener("theme:tab:check", () =>
          this.checkRecentTab()
        ),
        this.container.addEventListener("theme:tab:hide", () =>
          this.hideRelatedTab()
        ),
        t.length &&
          t.forEach((t) => {
            var e = parseInt(t.getAttribute(selectors$e.dataTab));
            const s = i.querySelector(selectors$e.tabContent + "-" + e);
            t.addEventListener("click", () => {
              this.tabChange(t, s);
            }),
              t.addEventListener("keyup", (e) => {
                (e.code !== window.theme.keyboardKeys.SPACE &&
                  e.code !== window.theme.keyboardKeys.ENTER) ||
                  !this.body.classList.contains(classes$b.focused) ||
                  this.tabChange(t, s);
              });
          });
    }
    tabChange(e, t) {
      e.classList.contains(classes$b.current) ||
        (this.container
          .querySelector(selectors$e.tabsLi + "." + classes$b.current)
          .classList.remove(classes$b.current),
        this.container
          .querySelector(selectors$e.tabContent + "." + classes$b.current)
          .classList.remove(classes$b.current),
        e.classList.add(classes$b.current),
        t.classList.add(classes$b.current),
        e.classList.contains(classes$b.hide) && t.classList.add(classes$b.hide),
        this.checkVisibleTabLinks(),
        this.accessibility.a11y.removeTrapFocus(),
        this.container.dispatchEvent(
          new CustomEvent("theme:tab:change", { bubbles: !0 })
        ),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "tab" },
          })
        ),
        this.animateItems(t));
    }
    animateItems(e, t = !0) {
      e = e.querySelectorAll(selectors$e.dataAos);
      e.length &&
        e.forEach((e) => {
          e.classList.remove(classes$b.aosAnimate),
            t &&
              (e.classList.add(classes$b.aosNoTransition),
              setTimeout(() => {
                e.classList.remove(classes$b.aosNoTransition),
                  e.classList.add(classes$b.aosAnimate);
              }));
        });
    }
    initNativeScrollbar() {
      this.scrollbarHolder.length &&
        this.scrollbarHolder.forEach((e) => {
          new NativeScrollbar(e);
        });
    }
    checkVisibleTabLinks() {
      var e = this.container.querySelectorAll(selectors$e.tabsLi),
        t = this.container.querySelectorAll(
          selectors$e.tabLink + "." + classes$b.hide
        );
      e.length - t.length < 2
        ? this.container.classList.add(classes$b.alt)
        : this.container.classList.remove(classes$b.alt);
    }
    checkRecentTab() {
      var e = this.container.querySelector(selectors$e.tabLinkRecent);
      e &&
        (e.classList.remove(classes$b.hide),
        (e = parseInt(e.getAttribute(selectors$e.dataTab))),
        (e = this.container.querySelector(
          `${selectors$e.tabContent}[${selectors$e.dataTabIndex}="${e}"]`
        )) && (e.classList.remove(classes$b.hide), this.animateItems(e, !1)),
        this.checkVisibleTabLinks(),
        this.initNativeScrollbar());
    }
    hideRelatedTab() {
      var e,
        t,
        s = this.container.querySelector(selectors$e.dataRelatedSectionElem);
      s &&
        (s = s.closest(selectors$e.tabContent + "." + classes$b.current)) &&
        ((s = parseInt(s.getAttribute(selectors$e.dataTabIndex))),
        (e = this.container.querySelectorAll(selectors$e.tabsLi)).length > s) &&
        (t = e[s].nextSibling) &&
        (e[s].classList.add(classes$b.hide),
        t.dispatchEvent(new Event("click")),
        this.initNativeScrollbar());
    }
    onBlockSelect(e) {
      e = this.container.querySelector(
        `${selectors$e.tabLink}[${selectors$e.blockId}="${e.detail.blockId}"]`
      );
      e &&
        (e.dispatchEvent(new Event("click")),
        e.parentNode.scrollTo({
          top: 0,
          left: e.offsetLeft - e.clientWidth,
          behavior: "smooth",
        }));
    }
  }
  const tabs = {
      onLoad() {
        (sections$8[this.id] = []),
          this.container
            .querySelectorAll(selectors$e.dataTabsHolder)
            .forEach((e) => {
              sections$8[this.id].push(new GlobalTabs(e));
            });
      },
      onBlockSelect(t) {
        sections$8[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
    },
    tokensReducer =
      (register("product-grid", [slider, swatchGridSection, tabs, siblings]),
      customElements.get("quick-add-product") ||
        customElements.define("quick-add-product", QuickAddProduct),
      (e, t) => {
        var {
            el: s,
            elStyle: i,
            elHeight: o,
            rowsLimit: r,
            rowsWrapped: a,
            options: n,
          } = e,
          l = e.buffer;
        let c = l;
        if (a === r + 1) return { ...e };
        var d = l;
        let h = a,
          u = o;
        return (
          (s.innerHTML = c =
            l.length
              ? "" + l + n.delimiter + t + n.replaceStr
              : "" + t + n.replaceStr),
          parseFloat(i.height) > parseFloat(o) &&
          (h++, (u = i.height), h === r + 1)
            ? ((s.innerHTML = c =
                "." === d[d.length - 1] && "..." === n.replaceStr
                  ? d + ".."
                  : "" + d + n.replaceStr),
              { ...e, elHeight: u, rowsWrapped: h })
            : ((s.innerHTML = c = d.length ? "" + d + n.delimiter + t : "" + t),
              { ...e, buffer: c, elHeight: u, rowsWrapped: h })
        );
      }),
    ellipsis = (e = "", t = 1, s = {}) => {
      var i = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...s },
        o =
          e &&
          (e instanceof NodeList
            ? e
            : 1 === e.nodeType
            ? [e]
            : document.querySelectorAll(e));
      for (let e = 0; e < o.length; e++) {
        var r = o[e],
          a = r.innerHTML.replace(/<!--[\s\S]*?-->/g, "").split(i.delimiter),
          n = ((r.innerHTML = ""), window.getComputedStyle(r));
        a.reduce(tokensReducer, {
          el: r,
          buffer: r.innerHTML,
          elStyle: n,
          elHeight: 0,
          rowsLimit: t,
          rowsWrapped: 0,
          options: i,
        });
      }
    },
    fadeOut = (t, s = null) => {
      (t.style.opacity = 1),
        (function e() {
          (t.style.opacity -= 0.1) < 0
            ? (t.style.display = "none")
            : requestAnimationFrame(e),
            0 === parseFloat(t.style.opacity) && "function" == typeof s && s();
        })();
    },
    selectors$d = {
      pickupContainer: "data-store-availability-container",
      shopifySection: ".shopify-section",
      drawer: "[data-pickup-drawer]",
      drawerBody: "[data-pickup-drawer-body]",
      drawerOpen: "[data-pickup-drawer-open]",
      drawerClose: "[data-pickup-drawer-close]",
      body: "body",
    },
    classes$a = { isOpen: "is-open", isHidden: "hidden" };
  let sections$7 = {};
  class PickupAvailability {
    constructor(e) {
      (this.container = e.container),
        (this.drawer = null),
        (this.drawerBody = null),
        (this.buttonDrawerOpen = null),
        (this.buttonDrawerClose = null),
        (this.body = document.querySelector(selectors$d.body)),
        (this.a11y = a11y),
        this.container.addEventListener("theme:variant:change", (e) =>
          this.fetchPickupAvailability(e)
        ),
        this.closeEvent();
    }
    fetchPickupAvailability(e) {
      const t = this.container.querySelector(
        `[${selectors$d.pickupContainer}]`
      );
      t &&
        ((e && !e.detail.variant) ||
        (e && e.detail.variant && !e.detail.variant.available)
          ? t.classList.add(classes$a.isHidden)
          : ((e =
              e && e.detail.variant
                ? e.detail.variant.id
                : t.getAttribute(selectors$d.pickupContainer)),
            (this.drawer = this.body.querySelector(selectors$d.drawer)),
            this.drawer && this.body.removeChild(this.drawer),
            e &&
              fetch(
                window.theme.routes.root +
                  `variants/${e}/?section_id=api-pickup-availability`
              )
                .then(this.handleErrors)
                .then((e) => e.text())
                .then((e) => {
                  e = new DOMParser()
                    .parseFromString(e, "text/html")
                    .querySelector(selectors$d.shopifySection).innerHTML;
                  (t.innerHTML = e),
                    (this.drawer = this.container.querySelector(
                      selectors$d.drawer
                    )),
                    this.drawer
                      ? ((this.clone = this.drawer.cloneNode(!0)),
                        this.body.appendChild(this.clone),
                        t.classList.remove(classes$a.isHidden),
                        t.removeChild(this.drawer),
                        (this.drawer = this.body.querySelector(
                          selectors$d.drawer
                        )),
                        (this.drawerBody = this.body.querySelector(
                          selectors$d.drawerBody
                        )),
                        (this.buttonDrawerOpen = this.body.querySelector(
                          selectors$d.drawerOpen
                        )),
                        (this.buttonDrawerClose = this.body.querySelectorAll(
                          selectors$d.drawerClose
                        )),
                        this.buttonDrawerOpen &&
                          this.buttonDrawerOpen.addEventListener(
                            "click",
                            () => {
                              this.openDrawer(),
                                (window.accessibility.lastElement =
                                  this.buttonDrawerOpen);
                            }
                          ),
                        this.buttonDrawerClose.length &&
                          this.buttonDrawerClose.forEach((e) => {
                            e.addEventListener("click", () =>
                              this.closeDrawer()
                            );
                          }),
                        this.drawer.addEventListener("keyup", (e) => {
                          e.code === window.theme.keyboardKeys.ESCAPE &&
                            this.closeDrawer();
                        }))
                      : t.classList.add(classes$a.isHidden);
                })
                .catch((e) => {
                  console.error(e);
                })));
    }
    openDrawer() {
      this.drawer &&
        (this.drawer.classList.add(classes$a.isOpen),
        this.drawer.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.drawerBody,
          })
        ),
        setTimeout(() => {
          var e = this.drawer.querySelector(selectors$d.drawerClose);
          this.a11y.removeTrapFocus(),
            this.a11y.trapFocus(this.drawer, { elementToFocus: e });
        }, 200));
    }
    closeDrawer() {
      this.drawer &&
        (this.drawer.classList.remove(classes$a.isOpen),
        this.drawer.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", {
            bubbles: !0,
            detail: this.drawerBody,
          })
        ),
        this.a11y.removeTrapFocus(),
        window.accessibility.lastElement) &&
        setTimeout(() => {
          window.accessibility.lastElement.focus();
        }, 200);
    }
    closeEvent() {
      document.addEventListener("click", (e) => {
        e = e.target;
        e.matches(selectors$d.drawerOpen) ||
          e.closest(selectors$d.drawer) ||
          this.closeDrawer();
      });
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new FetchError({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
          });
    }
  }
  const pickupAvailability = {
      onLoad() {
        sections$7[this.id] = new PickupAvailability(this);
      },
    },
    selectors$c = {
      complementaryProducts: "complementary-products",
      quickAddProduct: "quick-add-product",
    },
    classes$9 = { loaded: "is-loaded" },
    attributes$3 = { url: "data-url" };
  class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this), this.hasAttribute(attributes$3.url)) &&
            "" !== this.getAttribute(attributes$3.url) &&
            fetch(this.getAttribute(attributes$3.url))
              .then((e) => e.text())
              .then((e) => {
                var t = document.createElement("div"),
                  e =
                    ((t.innerHTML = e),
                    t.querySelector(selectors$c.complementaryProducts));
                e &&
                  e.innerHTML.trim().length &&
                  (this.innerHTML = e.innerHTML),
                  t.querySelector(
                    selectors$c.complementaryProducts +
                      " " +
                      selectors$c.quickAddProduct
                  ) && this.classList.add(classes$9.loaded);
              })
              .catch((e) => {
                console.error(e);
              });
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
    }
  }
  const selectors$b = {
      slideshow: "[data-product-slideshow]",
      dataStickyEnabled: "data-sticky-enabled",
      productPage: ".product__page",
      formWrapper: "[data-form-wrapper]",
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    classes$8 = { sticky: "is-sticky" },
    sections$6 = ((window.theme.variables = { productPageSticky: !1 }), {});
  class ProductSticky {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.stickyEnabled =
          "true" ===
          this.container.getAttribute(selectors$b.dataStickyEnabled)),
        (this.formWrapper = this.container.querySelector(
          selectors$b.formWrapper
        )),
        (this.stickyScrollTop = 0),
        (this.scrollLastPosition = 0),
        (this.stickyDefaultTop = 0),
        (this.currentPoint = 0),
        (this.defaultTopBottomSpacings = 30),
        (this.scrollTop = window.scrollY),
        (this.scrollDirectionDown = !0),
        (this.requestAnimationSticky = null),
        (this.stickyFormLoad = !0),
        (this.stickyFormLastHeight = null),
        (this.onChangeCounter = 0),
        (this.scrollEvent = (e) => this.scrollEvents(e)),
        (this.resizeEvent = (e) => this.resizeEvents(e)),
        setTimeout(() => {
          this.init();
        }, 50);
    }
    init() {
      this.stickyEnabled &&
        (this.stickyScrollCheck(),
        document.addEventListener("theme:resize", this.resizeEvent)),
        this.initSticky();
    }
    initSticky() {
      theme.variables.productPageSticky &&
        ((this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition()
        )),
        this.formWrapper.addEventListener("theme:form:sticky", (e) => {
          this.removeAnimationFrame(),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(e)
            ));
        }),
        document.addEventListener("theme:scroll", this.scrollEvent));
    }
    scrollEvents(e) {
      (this.scrollTop = e.detail.position),
        (this.scrollDirectionDown = e.detail.down),
        this.requestAnimationSticky ||
          (this.requestAnimationSticky = requestAnimationFrame(() =>
            this.calculateStickyPosition()
          ));
    }
    resizeEvents(e) {
      this.stickyScrollCheck(),
        document.removeEventListener("theme:scroll", this.scrollEvent),
        this.initSticky();
    }
    stickyScrollCheck() {
      var e,
        t =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) >= window.theme.sizes.small,
        s = this.container.querySelector(
          selectors$b.productPage + " " + selectors$b.formWrapper
        );
      s &&
        (t
          ? ((t = this.container.querySelector(selectors$b.formWrapper)),
            (e = this.container.querySelector(selectors$b.slideshow)),
            t &&
              e &&
              (t.offsetHeight < e.offsetHeight
                ? ((theme.variables.productPageSticky = !0),
                  s.classList.add(classes$8.sticky))
                : ((theme.variables.productPageSticky = !1),
                  s.classList.remove(classes$8.sticky))))
          : ((theme.variables.productPageSticky = !1),
            s.classList.remove(classes$8.sticky)));
    }
    calculateStickyPosition(e = null) {
      var t, s, i, o;
      document.documentElement.hasAttribute("data-scroll-locked")
        ? this.removeAnimationFrame()
        : ((t = Boolean(e && e.detail)),
          (t = Boolean(
            t && e.detail.element && "accordion" === e.detail.element
          )),
          (s = this.formWrapper.offsetHeight),
          (i = window.innerHeight - s - this.defaultTopBottomSpacings),
          (o = Math.abs(this.scrollTop - this.scrollLastPosition)),
          this.scrollDirectionDown
            ? (this.stickyScrollTop -= o)
            : (this.stickyScrollTop += o),
          this.stickyFormLoad &&
            (document.querySelector(selectors$b.headerSticky) &&
            document.querySelector(selectors$b.headerHeight)
              ? (this.stickyDefaultTop = parseInt(
                  document
                    .querySelector(selectors$b.headerHeight)
                    .getBoundingClientRect().height
                ))
              : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
            (this.stickyScrollTop = this.stickyDefaultTop)),
          (this.stickyScrollTop = Math.min(
            Math.max(this.stickyScrollTop, i),
            this.stickyDefaultTop
          )),
          (o = this.stickyScrollTop - this.currentPoint),
          (this.currentPoint = this.stickyFormLoad
            ? this.stickyScrollTop
            : this.currentPoint + 0.5 * o),
          this.formWrapper.style.setProperty(
            "--sticky-top",
            this.currentPoint + "px"
          ),
          (this.scrollLastPosition = this.scrollTop),
          (this.stickyFormLoad = !1),
          (t && this.onChangeCounter <= 10) ||
          (t && this.stickyFormLastHeight !== s) ||
          (this.stickyScrollTop !== this.currentPoint &&
            this.requestAnimationSticky)
            ? (t && (this.onChangeCounter += 1),
              t &&
                this.stickyFormLastHeight !== s &&
                (this.onChangeCounter = 11),
              (this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition(e)
              )))
            : this.requestAnimationSticky && this.removeAnimationFrame(),
          (this.stickyFormLastHeight = s));
    }
    removeAnimationFrame() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null),
        (this.onChangeCounter = 0));
    }
    onUnload() {
      this.stickyEnabled &&
        document.removeEventListener("theme:resize", this.resizeEvent),
        theme.variables.productPageSticky &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
  }
  const productStickySection = {
      onLoad() {
        sections$6[this.id] = new ProductSticky(this);
      },
      onUnload() {
        sections$6[this.id].onUnload();
      },
    },
    selectors$a = {
      elements: {
        accordionHolder: "[data-accordion-holder]",
        accordion: "[data-accordion]",
        accordionToggle: "[data-accordion-toggle]",
        accordionBody: "[data-accordion-body]",
        accordionExpandValue: "data-accordion-expand",
        accordionBlockValue: "data-block-id",
      },
      classes: { open: "is-open" },
    },
    sections$5 = {};
  class GlobalAccordions {
    constructor(e) {
      (this.container = e.container),
        (this.accordion = this.container.querySelector(
          selectors$a.elements.accordion
        )),
        (this.accordionToggles = this.container.querySelectorAll(
          selectors$a.elements.accordionToggle
        )),
        (this.accordionTogglesLength = this.accordionToggles.length),
        (this.accordionBody = this.container.querySelector(
          selectors$a.elements.accordionBody
        )),
        this.accordionTogglesLength &&
          this.accordionBody &&
          this.accordionEvents();
    }
    accordionEvents() {
      this.accordionToggles.forEach((t) => {
        t.addEventListener(
          "click",
          throttle((e) => {
            e.preventDefault();
            e = t.parentElement.querySelector(
              selectors$a.elements.accordionBody
            );
            e && this.onAccordionToggle(t, e);
          }, 800)
        );
      }),
        "true" ===
          this.accordion.getAttribute(
            selectors$a.elements.accordionExpandValue
          ) &&
          (this.accordionToggles[0].classList.add(selectors$a.classes.open),
          showElement(
            this.accordionToggles[0].parentElement.querySelector(
              selectors$a.elements.accordionBody
            )
          ));
    }
    closeOtherAccordions(s, i = !0) {
      let e = [...this.accordionToggles];
      var t = this.container.closest(selectors$a.elements.accordionHolder);
      (e = t
        ? [...t.querySelectorAll(selectors$a.elements.accordionToggle)]
        : e).filter((e) => {
        var t = e.parentElement.querySelector(
          selectors$a.elements.accordionBody
        );
        e !== s &&
          e.classList.contains(selectors$a.classes.open) &&
          t &&
          this.onAccordionClose(e, t, i);
      });
    }
    onAccordionOpen(e, t, s = !0) {
      e.classList.add(selectors$a.classes.open),
        slideDown(t),
        this.closeOtherAccordions(e, s);
    }
    onAccordionClose(e, t, s = !0) {
      e.classList.remove(selectors$a.classes.open),
        (s ? slideUp : hideElement)(t);
    }
    onAccordionToggle(e, t) {
      e.classList.toggle(selectors$a.classes.open),
        slideToggle(t),
        this.closeOtherAccordions(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    onBlockToggle(e, t = !0) {
      var s,
        e = this.container.querySelector(
          `${selectors$a.elements.accordionToggle}[${selectors$a.elements.accordionBlockValue}="${e.detail.blockId}"]`
        );
      e &&
        (s = e.parentElement.querySelector(
          selectors$a.elements.accordionBody
        )) &&
        (t ? this.onAccordionOpen(e, s, !1) : this.onAccordionClose(e, s));
    }
    onSelectToggle(e = !0) {
      this.accordionBody &&
        this.accordionTogglesLength &&
        this.accordionTogglesLength < 2 &&
        (e
          ? this.onAccordionOpen(
              this.accordionToggles[0],
              this.accordionBody,
              !1
            )
          : this.onAccordionClose(
              this.accordionToggles[0],
              this.accordionBody
            ));
    }
    onSelect() {
      this.onSelectToggle(!0);
    }
    onDeselect() {
      this.onSelectToggle(!1);
    }
    onBlockSelect(e) {
      this.onBlockToggle(e, !0);
    }
    onBlockDeselect(e) {
      this.onBlockToggle(e, !1);
    }
  }
  const accordions = {
      onLoad() {
        sections$5[this.id] = new GlobalAccordions(this);
      },
      onSelect() {
        sections$5[this.id].onSelect();
      },
      onDeselect() {
        sections$5[this.id].onDeselect();
      },
      onBlockSelect(e) {
        sections$5[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        sections$5[this.id].onBlockDeselect(e);
      },
    },
    selectors$9 = {
      section: "data-section-type",
      shareButton: "[data-share-button]",
      shareMessage: "[data-share-message]",
    },
    classes$7 = { visible: "is-visible" };
  class ShareButton extends HTMLElement {
    constructor() {
      super(),
        (this.container = this.closest(`[${selectors$9.section}]`)),
        (this.shareButton = this.querySelector(selectors$9.shareButton)),
        (this.shareMessage = this.querySelector(selectors$9.shareMessage)),
        (this.urlToShare =
          this.shareButton.dataset.shareUrl || document.location.href),
        this.init(),
        this.updateShareLink();
    }
    init() {
      navigator.share
        ? this.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          })
        : this.shareButton.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          );
    }
    updateShareLink() {
      "product" == this.container.getAttribute(selectors$9.section) &&
        this.container.addEventListener("theme:variant:change", (e) => {
          e.detail.variant &&
            (this.urlToShare =
              this.urlToShare.split("?")[0] +
              "?variant=" +
              e.detail.variant.id);
        });
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.shareMessage.classList.add(classes$7.visible);
        const e = () => {
          this.shareMessage.classList.remove(classes$7.visible),
            this.shareMessage.removeEventListener("animationend", e);
        };
        this.shareMessage.addEventListener("animationend", e);
      });
    }
  }
  const selectors$8 = {
      addToCart: "[data-add-to-cart]",
      priceWrapper: "[data-price-wrapper]",
      productImage: "[data-product-image]",
      productJson: "[data-product-json]",
      form: "[data-product-form]",
      thumbs: "[data-product-thumbs]",
      dataSectionId: "data-section-id",
      dataCartBar: "data-cart-bar",
      cartBar: "#cart-bar",
      cartBarAdd: "data-add-to-cart-bar",
      cartBarScroll: "data-cart-bar-scroll",
      productSubmitAdd: ".product__submit__add",
      templateProduct: "#template-product",
      siteFooterWrapper: ".site-footer-wrapper",
      toggleTruncateHolder: "[data-truncated-holder]",
      toggleTruncateButton: "[data-truncated-button]",
      toggleTruncateContent: "[data-truncated-content]",
      toggleTruncateContentAttr: "data-truncated-content",
      productPopupButton: "data-product-popup",
      modalScrollContainer: "[data-tabs-holder]",
      formWrapper: "[data-form-wrapper]",
      slider: "[data-slider]",
      sliderIndex: "data-slider-index",
    },
    classes$6 = {
      expanded: "is-expanded",
      visible: "is-visible",
      loading: "is-loading",
      added: "is-added",
      siteFooterPush: "site-footer--push",
      hasPopup: "has-popup",
    },
    sections$4 = {};
  class Product {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.id = this.container.getAttribute(selectors$8.dataSectionId)),
        (this.sliders = this.container.querySelectorAll(selectors$8.slider)),
        (this.slider = []),
        (this.truncateElementHolder = this.container.querySelector(
          selectors$8.toggleTruncateHolder
        )),
        (this.truncateElement = this.container.querySelector(
          selectors$8.toggleTruncateContent
        )),
        (this.productPopupButton = this.container.querySelectorAll(
          `[${selectors$8.productPopupButton}]`
        )),
        (this.formWrapper = this.container.querySelector(
          selectors$8.formWrapper
        )),
        (this.cartBarExist =
          "true" === this.container.getAttribute(selectors$8.dataCartBar)),
        (this.cartBar = this.container.querySelector(selectors$8.cartBar)),
        (this.scrollToTop = this.scrollToTop.bind(this)),
        (this.scrollEvent = (e) => this.scrollEvents(e)),
        (this.resizeEvent = (e) => this.resizeEvents(e)),
        (this.unlockTimer = 0),
        (this.accessibility = a11y),
        this.truncateElementHolder &&
          this.truncateElement &&
          (setTimeout(() => this.truncateText(), 50),
          document.addEventListener("theme:resize", this.resizeEvent));
      t = this.container.querySelector(selectors$8.productJson);
      if ((t && !t.innerHTML) || !t) new QuantityCounter(this.container).init();
      else {
        t = JSON.parse(t.innerHTML).handle;
        let e = t ? { handle: t } : {};
        Shopify.Products.recordRecentlyViewed(e),
          (this.form = this.container.querySelector(selectors$8.form)),
          this.init(),
          this.sliders.length &&
            this.sliders.forEach((e, t) => {
              e.setAttribute(selectors$8.sliderIndex, t),
                this.slider.push(new Slider(this.container, e));
            }),
          this.cartBarExist &&
            (this.initCartBar(),
            document.addEventListener("theme:scroll", this.scrollEvent)),
          0 < this.productPopupButton.length && this.productPopup();
      }
    }
    init() {
      (theme.mediaInstances[this.id] = new Media(this.section)),
        theme.mediaInstances[this.id].init();
    }
    scrollEvents(e) {
      this.cartBarExist && this.cartBarScroll();
    }
    resizeEvents(e) {
      this.truncateText();
    }
    productPopup() {
      this.productPopupButton.forEach((s) => {
        s.addEventListener("click", (e) => {
          e.preventDefault();
          var e = document.querySelector(
              "#" + s.getAttribute(selectors$8.productPopupButton)
            ),
            t = e.querySelector(selectors$8.modalScrollContainer);
          "none" !== window.getComputedStyle(e).display &&
            (fadeOut(e),
            this.formWrapper.classList.remove(classes$6.hasPopup),
            this.accessibility.removeTrapFocus(),
            this.unlockTimer && clearTimeout(this.unlockTimer),
            (this.unlockTimer = setTimeout(() => {
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
            }, 300))),
            "none" === window.getComputedStyle(e).display &&
              (fadeIn(e),
              this.formWrapper.classList.add(classes$6.hasPopup),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t })
              ),
              this.accessibility.trapFocus(e));
        });
      });
    }
    truncateText() {
      var e, t, s;
      this.truncateElementHolder.classList.contains(classes$6.visible) ||
        ((e = this.truncateElement.querySelectorAll("style")).length &&
          e.forEach((e) => {
            this.truncateElementHolder.prepend(e);
          }),
        (e = this.truncateElement.cloneNode(!0)),
        (t = this.truncateElement.getAttribute(
          selectors$8.toggleTruncateContentAttr
        )),
        (s = this.truncateElement.nextElementSibling) && s.remove(),
        this.truncateElement.parentElement.append(e),
        (s = this.truncateElement.nextElementSibling).classList.add(t),
        s.removeAttribute(selectors$8.toggleTruncateContentAttr),
        showElement(s),
        ellipsis(s, 5, { replaceStr: "", delimiter: " " }),
        hideElement(s),
        this.truncateElement.innerHTML !== s.innerHTML
          ? this.truncateElementHolder.classList.add(classes$6.expanded)
          : (s.remove(),
            this.truncateElementHolder.classList.remove(classes$6.expanded)),
        this.toggleTruncatedContent(this.truncateElementHolder));
    }
    toggleTruncatedContent(t) {
      var e = t.querySelector(selectors$8.toggleTruncateButton);
      e &&
        e.addEventListener("click", (e) => {
          e.preventDefault(),
            t.classList.remove(classes$6.expanded),
            t.classList.add(classes$6.visible);
        });
    }
    initCartBar() {
      (this.cartBarBtn = this.cartBar.querySelector(
        selectors$8.productSubmitAdd
      )),
        this.cartBarBtn &&
          (this.cartBarBtn.addEventListener("click", (e) => {
            e.preventDefault(),
              e.currentTarget.hasAttribute(selectors$8.cartBarAdd)
                ? (theme.settings.cartDrawerEnabled &&
                    (e.currentTarget.classList.add(classes$6.loading),
                    e.currentTarget.setAttribute("disabled", "disabled")),
                  this.form
                    .querySelector(selectors$8.addToCart)
                    .dispatchEvent(new Event("click", { bubbles: !0 })))
                : e.currentTarget.hasAttribute(selectors$8.cartBarScroll) &&
                  this.scrollToTop();
          }),
          this.cartBarBtn.hasAttribute(selectors$8.cartBarAdd)) &&
          document.addEventListener(
            "theme:product:add-error",
            this.scrollToTop
          );
    }
    scrollToTop() {
      var e =
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) >= window.theme.sizes.small
          ? this.container
          : this.form;
      scrollTo(e.getBoundingClientRect().top);
    }
    cartBarScroll() {
      var e,
        t = window.pageYOffset,
        s =
          theme.variables.productPageSticky && this.formWrapper
            ? this.formWrapper
            : this.form;
      s &&
        this.cartBar &&
        ((e = document.querySelector(selectors$8.siteFooterWrapper)),
        (s = s.offsetTop + s.offsetHeight < t),
        this.cartBar.classList.toggle(classes$6.visible, s),
        e) &&
        (e.classList.toggle(classes$6.siteFooterPush, s),
        (e.style.marginBottom = e.classList.contains(classes$6.siteFooterPush)
          ? this.cartBar.offsetHeight + "px"
          : "0"));
    }
    onUnload() {
      document.removeEventListener("theme:product:add-error", this.scrollToTop),
        this.truncateElementHolder &&
          this.truncateElement &&
          document.removeEventListener("theme:resize", this.resizeEvent),
        this.cartBarExist &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
    onBlockSelect(e) {
      var t = e.srcElement.closest(selectors$8.slider);
      t &&
        this.slider.length &&
        ((t = t.hasAttribute(selectors$8.sliderIndex)
          ? t.getAttribute(selectors$8.sliderIndex)
          : 0),
        this.slider[t]) &&
        this.slider[t].onBlockSelect(e);
    }
    onBlockDeselect(e) {
      var t = e.srcElement.closest(selectors$8.slider);
      t &&
        this.slider.length &&
        ((t = t.hasAttribute(selectors$8.sliderIndex)
          ? t.getAttribute(selectors$8.sliderIndex)
          : 0),
        this.slider[t]) &&
        this.slider[t].onBlockDeselect(e);
    }
  }
  const productSection = {
      onLoad() {
        sections$4[this.id] = new Product(this);
      },
      onUnload(e) {
        sections$4[this.id].onUnload(e);
      },
      onBlockSelect(e) {
        sections$4[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        sections$4[this.id].onBlockDeselect(e);
      },
    },
    selectors$7 =
      (register("product", [
        productSection,
        pickupAvailability,
        productFormSection,
        swatchSection,
        tooltipSection,
        popoutSection,
        tabs,
        accordions,
        productStickySection,
        initSlider,
      ]),
      customElements.get("quick-add-product") ||
        customElements.define("quick-add-product", QuickAddProduct),
      customElements.get("complementary-products") ||
        customElements.define("complementary-products", ComplementaryProducts),
      customElements.get("share-button") ||
        customElements.define("share-button", ShareButton),
      {
        relatedSectionElem: "[data-related-section]",
        relatedProduct: "[data-product-grid-item]",
        recentlyViewed: "[data-recent-wrapper]",
        recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
        recentlyProduct: "#recently-viewed-products",
        productItem: ".product-item",
        slider: "[data-slider]",
      }),
    attributes$2 = {
      limit: "data-limit",
      minimum: "data-minimum",
      productId: "data-product-id",
    },
    classes$5 = { isHidden: "is-hidden" };
  class Related {
    constructor(e) {
      (this.section = e),
        (this.sectionId = e.id),
        (this.container = e.container),
        this.init(),
        this.recent();
    }
    init() {
      const s = this.container.querySelector(selectors$7.relatedSectionElem);
      if (s) {
        const i = this;
        var e = s.getAttribute(attributes$2.productId),
          t = s.getAttribute(attributes$2.limit),
          t =
            window.theme.routes.product_recommendations_url +
            `?section_id=related&limit=${t}&product_id=` +
            e;
        fetch(t)
          .then(function (e) {
            return e.text();
          })
          .then(function (e) {
            var t = document.createElement("div"),
              e =
                ((t.innerHTML = e),
                t.querySelector(selectors$7.relatedSectionElem));
            e.querySelector(selectors$7.relatedProduct)
              ? ((t = e.innerHTML),
                hideElement(s),
                (s.innerHTML = t),
                slideDown(s),
                (e = s.querySelectorAll(selectors$7.relatedProduct)),
                makeGridSwatches(i.section),
                new Siblings(i.section),
                4 < e.length &&
                  s.querySelector(selectors$7.slider) &&
                  new Slider(s))
              : s.dispatchEvent(
                  new CustomEvent("theme:tab:hide", { bubbles: !0 })
                );
          })
          .catch(function () {
            s.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
          });
      }
    }
    recent() {
      var e = this.container.querySelector(selectors$7.recentlyViewed),
        e = e ? parseInt(e.getAttribute(attributes$2.limit)) : 4;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: e,
        wrapperId: "recently-viewed-products-" + this.sectionId,
        section: this.section,
        onComplete: (e, t) => {
          var s = t.container,
            i = s.querySelector(selectors$7.recentlyViewed),
            s = s.querySelector(selectors$7.recentlyViewedWrapper),
            e = e.querySelectorAll(selectors$7.productItem),
            o = i.hasAttribute(attributes$2.minimum)
              ? parseInt(i.getAttribute(attributes$2.minimum))
              : 4,
            r = !s && 0 < e.length,
            o = s && e.length >= o;
          (r || o) &&
            (o && s.classList.remove(classes$5.isHidden),
            fadeIn(i),
            i.dispatchEvent(
              new CustomEvent("theme:tab:check", { bubbles: !0 })
            ),
            makeGridSwatches(t),
            new Siblings(t),
            4 < e.length) &&
            i.querySelector(selectors$7.slider) &&
            new Slider(i);
        },
      });
    }
  }
  const relatedSection = {
      onLoad() {
        this.section = new Related(this);
      },
    },
    sections$3 =
      (register("related", [relatedSection, popoutSection, tabs]),
      customElements.get("quick-add-product") ||
        customElements.define("quick-add-product", QuickAddProduct),
      register("reviews", [accordions, slider, blockScroll]),
      {}),
    selectors$6 = {
      sliderLogos: "[data-slider-logos]",
      sliderText: "[data-slider-text]",
      slide: "[data-slide]",
      slideIndex: "[data-slide-index]",
    },
    classes$4 = {
      isSelected: "is-selected",
      flickityEnabled: "flickity-enabled",
    },
    attributes$1 = { slideData: "data-slide", slideIndex: "data-slide-index" };
  class LogoList {
    constructor(e) {
      (this.container = e.container),
        (this.slideshowNav = this.container.querySelector(
          selectors$6.sliderLogos
        )),
        (this.slideshowText = this.container.querySelector(
          selectors$6.sliderText
        )),
        (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
        (this.flkty = null),
        (this.flktyNav = null),
        this.initSlideshowText(),
        this.initSlideshowNav();
    }
    initSlideshowText() {
      if (this.slideshowText) {
        this.flkty = new FlickityFade(this.slideshowText, {
          fade: !0,
          autoPlay: !1,
          prevNextButtons: !1,
          cellAlign: "left",
          contain: !0,
          pageDots: !1,
          wrapAround: !1,
          selectedAttraction: 0.2,
          friction: 0.6,
          draggable: !1,
          accessibility: !1,
          on: {
            ready: () => this.sliderAccessibility(),
            change: () => this.sliderAccessibility(),
          },
        });
        var e = this.slideshowText.querySelectorAll(selectors$6.slide);
        if (e.length) {
          let s = -1;
          e.forEach((e) => {
            e = parseFloat(getComputedStyle(e, null).height.replace("px", ""));
            e > s && (s = e);
          }),
            e.forEach((e) => {
              var t = parseFloat(
                getComputedStyle(e, null).height.replace("px", "")
              );
              t < s &&
                ((t = Math.ceil((s - t) / 2)), (e.style.margin = t + "px 0"));
            });
        }
      }
    }
    sliderAccessibility() {
      var e = this.slideshowText.querySelectorAll(
        `${selectors$6.slide} a, ${selectors$6.slide} button`
      );
      e.length &&
        e.forEach((e) => {
          var t = e.closest(selectors$6.slide);
          t &&
            ((t = t.classList.contains(classes$4.isSelected) ? 0 : -1),
            e.setAttribute("tabindex", t));
        });
    }
    initSlideshowNav() {
      this.slideshowNav &&
        ((this.logoSlides = this.slideshowNav.querySelectorAll(
          selectors$6.slideIndex
        )),
        this.logoSlides.length &&
          this.logoSlides.forEach((s) => {
            s.addEventListener("click", (e) => {
              e.preventDefault();
              var e = parseInt(s.getAttribute(attributes$1.slideIndex)),
                t = this.slideshowNav.classList.contains(
                  classes$4.flickityEnabled
                );
              this.flkty && this.flkty.select(e),
                t
                  ? (this.flktyNav.select(e),
                    this.slideshowNav.classList.contains(
                      classes$4.isSelected
                    ) || this.flktyNav.playPlayer())
                  : ((t = this.slideshowNav.querySelector(
                      "." + classes$4.isSelected
                    )) && t.classList.remove(classes$4.isSelected),
                    s.classList.add(classes$4.isSelected));
            });
          }),
        this.setSlideshowNavState(),
        document.addEventListener(
          "theme:resize",
          this.setSlideshowNavStateOnResize
        ));
    }
    setSlideshowNavState() {
      var e = this.slideshowNav.querySelectorAll(selectors$6.slide),
        t = e.length,
        s =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        t = 200 * t,
        i = this.slideshowNav.classList.contains(classes$4.flickityEnabled);
      s < t
        ? i ||
          ((s = this.slideshowNav.querySelector("." + classes$4.isSelected)) &&
            s.classList.remove(classes$4.isSelected),
          e[0].classList.add(classes$4.isSelected),
          (this.flktyNav = new Flickity(this.slideshowNav, {
            autoPlay: 4e3,
            prevNextButtons: !1,
            contain: !1,
            pageDots: !1,
            wrapAround: !0,
            watchCSS: !0,
            selectedAttraction: 0.05,
            friction: 0.8,
            initialIndex: 0,
          })),
          this.flkty &&
            (this.flkty.select(0),
            this.flktyNav.on("change", (e) => this.flkty.select(e))))
        : i &&
          (this.flktyNav.destroy(),
          e[0].classList.add(classes$4.isSelected),
          this.flkty) &&
          this.flkty.select(0);
    }
    onBlockSelect(e) {
      var t;
      this.slideshowNav &&
        ((e = this.slideshowNav.querySelector(
          `[${attributes$1.slideData}="${e.detail.blockId}"]`
        )),
        (t = parseInt(e.getAttribute(attributes$1.slideIndex))),
        this.slideshowNav.classList.contains(classes$4.flickityEnabled)
          ? (this.flktyNav.select(t),
            this.flktyNav.stopPlayer(),
            this.slideshowNav.classList.add(classes$4.isSelected))
          : e.dispatchEvent(new Event("click")));
    }
    onBlockDeselect() {
      this.slideshowNav &&
        this.slideshowNav.classList.contains(classes$4.flickityEnabled) &&
        (this.flktyNav.playPlayer(),
        this.slideshowNav.classList.remove(classes$4.isSelected));
    }
    onUnload() {
      this.slideshowNav &&
        (this.slideshowNav.classList.contains(classes$4.flickityEnabled) &&
          this.flktyNav.destroy(),
        this.flkty && this.flkty.destroy(),
        document.removeEventListener(
          "theme:resize",
          this.setSlideshowNavStateOnResize
        ));
    }
  }
  const LogoListSection = {
      onLoad() {
        sections$3[this.id] = new LogoList(this);
      },
      onUnload(e) {
        sections$3[this.id].onUnload(e);
      },
      onBlockSelect(e) {
        sections$3[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        sections$3[this.id].onBlockDeselect(e);
      },
    },
    selectors$5 =
      (register("logos", [LogoListSection, blockScroll]),
      { videoPlay: "[data-video-play]", videoPlayValue: "data-video-play" });
  class VideoPlay {
    constructor(e, t = selectors$5.videoPlay, s = selectors$5.videoPlayValue) {
      (this.container = e),
        (this.videoPlay = this.container.querySelectorAll(t)),
        this.videoPlay.length &&
          this.videoPlay.forEach((e) => {
            e.addEventListener("click", (e) => {
              var t = e.currentTarget;
              t.hasAttribute(s) &&
                "" !== t.getAttribute(s).trim() &&
                (e.preventDefault(),
                (e = [{ html: t.getAttribute(s) }]),
                new LoadPhotoswipe(e),
                (window.accessibility.lastElement = t));
            });
          });
    }
  }
  const videoPlay = {
      onLoad() {
        new VideoPlay(this.container);
      },
    },
    selectors$4 = {
      videoId: "[data-video-id]",
      videoPlayer: "[data-video-player]",
      videoTemplate: "[data-video-template]",
    },
    classes$3 = { loading: "is-loading" };
  class VideoBackground {
    constructor(e) {
      (this.container = e),
        (this.videoId = this.container.querySelector(selectors$4.videoId)),
        (this.videoPlayer = this.container.querySelector(
          selectors$4.videoPlayer
        )),
        (this.videoTemplate = this.container.querySelector(
          selectors$4.videoTemplate
        )),
        this.init();
    }
    init() {
      this.videoId &&
        (this.container.addEventListener(
          "touchstart",
          () => {
            this.video.play();
          },
          { passive: !0 }
        ),
        new IntersectionObserver(
          (e, s) => {
            e.forEach((e) => {
              var t;
              e.isIntersecting &&
                ((t = this.videoTemplate.content),
                this.videoTemplate.replaceWith(t),
                this.videoPlayer.classList.remove(classes$3.loading),
                s.unobserve(e.target));
            });
          },
          {
            root: null,
            rootMargin: "300px",
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
          }
        ).observe(this.videoPlayer));
    }
  }
  const videoBackground = {
      onLoad() {
        new VideoBackground(this.container);
      },
    },
    selectors$3 =
      (register("featured-video", [videoPlay, videoBackground, parallaxHero]),
      register("slideshow", [slider, parallaxHero]),
      {
        imagesHolder: "[data-images-holder]",
        imageHolder: "[data-image-holder]",
        imageElement: "[data-image-element]",
        imagesButton: "[data-images-button]",
        dataStartPosition: "data-start-position",
      }),
    sections$2 = {};
  class CompareImages {
    constructor(e) {
      (this.imagesHolder = e),
        this.imagesHolder &&
          ((this.imageHolder = this.imagesHolder.querySelector(
            selectors$3.imageHolder
          )),
          (this.imageElement = this.imagesHolder.querySelector(
            selectors$3.imageElement
          )),
          (this.imagesButton = this.imagesHolder.querySelector(
            selectors$3.imagesButton
          )),
          (this.startPosition = this.imagesHolder.hasAttribute(
            selectors$3.dataStartPosition
          )
            ? this.imagesHolder.getAttribute(selectors$3.dataStartPosition)
            : 0),
          (this.startX = 0),
          (this.x = 0),
          (this.changeValuesEvent = (e) => this.changeValues(e)),
          (this.onMoveEvent = (e) => this.onMove(e)),
          (this.onStopEvent = (e) => this.onStop(e)),
          (this.onStartEvent = (e) => this.onStart(e)),
          this.init(),
          document.addEventListener("theme:resize", this.changeValuesEvent));
    }
    init() {
      this.changeValues(),
        this.imagesButton.addEventListener("mousedown", this.onStartEvent),
        this.imagesButton.addEventListener("touchstart", this.onStartEvent);
    }
    changeValues(e) {
      var t = this.imagesHolder.offsetWidth,
        s = this.imagesButton.offsetWidth;
      (e && ("touchmove" === e.type || "mousemove" === e.type)) ||
        ((this.imageElement.style.width = t + "px"),
        (this.imageHolder.style.width =
          100 - parseInt(this.startPosition) + "%"),
        0 === this.startPosition) ||
        ((e = (t * parseInt(this.startPosition)) / 100), (this.x = e - s / 2)),
        this.x > t - s ? (this.x = t - s) : this.x < 0 && (this.x = 0),
        (this.imagesButton.style.left = (this.x / t) * 100 + "%"),
        (this.imageHolder.style.width =
          100 - ((this.x + s / 2) / t) * 100 + "%");
    }
    onStart(e) {
      e.preventDefault();
      let t = e;
      e.touches && (t = e.touches[0]),
        (this.x = this.imagesButton.offsetLeft),
        (this.startX = t.pageX - this.x),
        this.imagesHolder.addEventListener("mousemove", this.onMoveEvent),
        this.imagesHolder.addEventListener("mouseup", this.onStopEvent),
        this.imagesHolder.addEventListener("touchmove", this.onMoveEvent),
        this.imagesHolder.addEventListener("touchend", this.onStopEvent);
    }
    onMove(e) {
      let t = e;
      e.touches && (t = e.touches[0]),
        (this.x = t.pageX - this.startX),
        this.changeValues(e);
    }
    onStop(e) {
      this.imagesHolder.removeEventListener("mousemove", this.onMoveEvent),
        this.imagesHolder.removeEventListener("mouseup", this.onStopEvent),
        this.imagesHolder.removeEventListener("touchmove", this.onMoveEvent),
        this.imagesHolder.removeEventListener("touchend", this.onStopEvent);
    }
    onUnload() {
      this.changeValuesEvent &&
        document.removeEventListener("theme:resize", this.changeValuesEvent);
    }
  }
  const compareImages = {
    onLoad() {
      (sections$2[this.id] = []),
        this.container
          .querySelectorAll(selectors$3.imagesHolder)
          .forEach((e) => {
            sections$2[this.id].push(new CompareImages(e));
          });
    },
    onUnload() {
      sections$2[this.id].forEach((e) => {
        "function" == typeof e.onUnload && e.onUnload();
      });
    },
  };
  register("custom-content", [
    slider,
    videoPlay,
    videoBackground,
    parallaxHero,
    swatchGridSection,
    compareImages,
    newsletterCheckForResultSection,
    siblings,
  ]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  var styles = {};
  function mapStyle(e) {
    return styles[e];
  }
  (styles.basic = []),
    (styles.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (styles.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (styles.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let allMaps = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  class Map {
    constructor(e) {
      (this.container = e.container),
        (this.mapContainer = this.container.querySelector(
          "[data-map-container]"
        )),
        (this.key = this.container.getAttribute("data-api-key")),
        (this.styleString = this.container.getAttribute("data-style") || ""),
        (this.zoomString = this.container.getAttribute("data-zoom") || 14),
        (this.address = this.container.getAttribute("data-address")),
        (this.enableCorrection = this.container.getAttribute(
          "data-latlong-correction"
        )),
        (this.lat = this.container.getAttribute("data-lat")),
        (this.long = this.container.getAttribute("data-long")),
        this.key && this.initMaps();
    }
    initMaps() {
      loadAPI(this.key)
        .then(() =>
          "true" === this.enableCorrection &&
          "" !== this.lat &&
          "" !== this.long
            ? new google.maps.LatLng(this.lat, this.long)
            : geocodeAddressPromise(this.address)
        )
        .then((e) => {
          var t = parseInt(this.zoomString, 10),
            s = mapStyle(this.styleString);
          return createMap(this.mapContainer, {
            zoom: t,
            styles: s,
            center: e,
            draggable: !0,
            clickableIcons: !1,
            scrollwheel: !1,
            zoomControl: !1,
            disableDefaultUI: !0,
          });
        })
        .then((e) => {
          (this.map = e), (allMaps[this.id] = e);
        })
        .catch((e) => {
          console.log("Failed to load Google Map"), console.log(e);
        });
    }
    unload() {
      void 0 !== window.google &&
        google.maps.event.clearListeners(this.map, "resize");
    }
  }
  const mapSection = {
    onLoad() {
      allMaps[this.id] = new Map(this);
    },
    onUnload() {
      "function" == typeof allMaps[this.id].unload && allMaps[this.id].unload();
    },
  };
  function loadAPI(e) {
    return (
      null === window.theme.mapAPI &&
        (window.theme.mapAPI = loadScript({
          url: "https://maps.googleapis.com/maps/api/js?key=" + e,
        })),
      window.theme.mapAPI
    );
  }
  function createMap(e, t) {
    var s = new google.maps.Map(e, t),
      i = s.getCenter();
    return (
      new google.maps.Marker({ map: s, position: i }),
      google.maps.event.addDomListener(window, "resize", function () {
        google.maps.event.trigger(s, "resize"), s.setCenter(i);
      }),
      s
    );
  }
  function geocodeAddressPromise(e) {
    return new Promise((s, i) => {
      new google.maps.Geocoder().geocode({ address: e }, function (e, t) {
        "OK" == t
          ? ((e = {
              lat: e[0].geometry.location.lat(),
              lng: e[0].geometry.location.lng(),
            }),
            s(e))
          : i(t);
      });
    });
  }
  register("map", mapSection),
    register("search", [swatchGridSection, siblings]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  const selectors$2 = {
      largePromo: "[data-large-promo]",
      largePromoInner: "[data-large-promo-inner]",
      trackingInner: "[data-tracking-consent-inner]",
      tracking: "[data-tracking-consent]",
      trackingAccept: "[data-confirm-cookies]",
      close: "[data-close-modal]",
      modalUnderlay: "[data-modal-underlay]",
      modalBody: "[data-modal-body]",
      newsletterPopup: "[data-newsletter]",
      newsletterPopupHolder: "[data-newsletter-holder]",
      newsletterClose: "[data-newsletter-close]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterField: "[data-newsletter-field]",
      promoPopup: "[data-promo-text]",
      newsletterForm: "[data-newsletter-form]",
      delayAttribite: "data-popup-delay",
      cookieNameAttribute: "data-cookie-name",
      dataTargetReferrer: "data-target-referrer",
    },
    classes$2 = {
      hide: "hide",
      hasValue: "has-value",
      success: "has-success",
      selected: "selected",
      hasBlockSelected: "has-block-selected",
      mobile: "mobile",
      desktop: "desktop",
    },
    attributes = { enable: "data-enable" };
  let sections$1 = {};
  class DelayShow {
    constructor(e, t, s = null) {
      (this.element = t),
        (this.delay = e.getAttribute(selectors$2.delayAttribite)),
        (this.isSubmitted =
          -1 !== window.location.href.indexOf("accepts_marketing") ||
          -1 !== window.location.href.indexOf("customer_posted=true")),
        (this.callback = s),
        (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
        ("always" !== this.delay && !this.isSubmitted) || this.always(),
        this.delay &&
          this.delay.includes("delayed") &&
          !this.isSubmitted &&
          ((t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10),
          this.delayed(t)),
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
        "idle" !== this.delay || this.isSubmitted || this.idle();
    }
    always() {
      fadeIn(this.element, null, this.callback);
    }
    delayed(e = 10) {
      setTimeout(() => {
        fadeIn(this.element, null, this.callback);
      }, 1e3 * e);
    }
    idle() {
      let e = 0;
      const t = [
          "mousemove",
          "mousedown",
          "click",
          "touchmove",
          "touchstart",
          "touchend",
          "keydown",
          "keypress",
        ],
        s = ["load", "resize", "scroll"],
        i = () => {
          (e = setTimeout(() => {
            (e = 0), fadeIn(this.element, null, this.callback);
          }, 6e4)),
            t.forEach((e) => {
              document.addEventListener(e, o);
            }),
            s.forEach((e) => {
              window.addEventListener(e, o);
            });
        },
        o = () => {
          e && clearTimeout(e),
            t.forEach((e) => {
              document.removeEventListener(e, o);
            }),
            s.forEach((e) => {
              window.removeEventListener(e, o);
            }),
            i();
        };
      i();
    }
    bottom() {
      document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
    showPopupOnScroll() {
      window.scrollY + window.innerHeight >= document.body.clientHeight &&
        (fadeIn(this.element, null, this.callback),
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        ));
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
  }
  class TargetReferrer {
    constructor(e) {
      if (
        ((this.el = e),
        (this.locationPath = location.href),
        !this.el.hasAttribute(selectors$2.dataTargetReferrer))
      )
        return !1;
      this.init();
    }
    init() {
      -1 !==
        this.locationPath.indexOf(
          this.el.getAttribute(selectors$2.dataTargetReferrer)
        ) ||
        window.Shopify.designMode ||
        this.el.parentNode.removeChild(this.el);
    }
  }
  class LargePopup {
    constructor(e) {
      (this.popup = e),
        (this.modal = this.popup.querySelector(selectors$2.largePromoInner)),
        (this.modalBody = this.popup.querySelector(selectors$2.modalBody)),
        (this.close = this.popup.querySelector(selectors$2.close)),
        (this.underlay = this.popup.querySelector(selectors$2.modalUnderlay)),
        (this.form = this.popup.querySelector(selectors$2.newsletterForm)),
        (this.cookie = new PopupCookie(
          this.popup.getAttribute(selectors$2.cookieNameAttribute),
          "user_has_closed"
        )),
        (this.isTargeted = new TargetReferrer(this.popup)),
        (this.a11y = a11y),
        this.init();
    }
    init() {
      var e = !1 !== this.cookie.read(),
        t = this.popup.classList.contains(classes$2.mobile),
        s = this.popup.classList.contains(classes$2.desktop);
      let i = !0;
      (i =
        !(
          (t && window.innerWidth >= theme.sizes.small) ||
          (s && window.innerWidth < theme.sizes.small)
        ) && i)
        ? (e && !window.Shopify.designMode) ||
          (window.Shopify.designMode ||
            new DelayShow(this.popup, this.modal, () => this.scrollLock()),
          this.form &&
            this.form.classList.contains(classes$2.success) &&
            this.checkForSuccess(),
          this.initClosers())
        : this.scrollUnlock();
    }
    checkForSuccess() {
      fadeIn(this.modal, null, () => this.scrollLock()), this.cookie.write();
    }
    initClosers() {
      this.close.addEventListener("click", this.closeModal.bind(this)),
        this.underlay.addEventListener("click", this.closeModal.bind(this));
    }
    closeModal(e) {
      e.preventDefault(),
        fadeOut(this.modal),
        this.cookie.write(),
        this.scrollUnlock();
    }
    scrollLock() {
      "none" !== window.getComputedStyle(this.popup).display &&
        (this.a11y.trapFocus(this.modal),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.modalBody,
          })
        ));
    }
    scrollUnlock() {
      this.a11y.removeTrapFocus(),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    onBlockSelect(e) {
      this.popup.contains(e.target) &&
        (fadeIn(this.modal, null, () => this.scrollLock()),
        this.popup.classList.add(classes$2.selected),
        this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) &&
        (fadeOut(this.modal),
        this.scrollUnlock(),
        this.popup.classList.remove(classes$2.selected),
        this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
    }
  }
  class Tracking {
    constructor(e) {
      (this.popup = e),
        (this.modal = document.querySelector(selectors$2.tracking)),
        (this.acceptButton = this.modal.querySelector(
          selectors$2.trackingAccept
        )),
        (this.enable = "true" === this.modal.getAttribute(attributes.enable)),
        (this.showPopup = !1),
        window.Shopify.loadFeatures(
          [{ name: "consent-tracking-api", version: "0.1" }],
          (e) => {
            if (e) throw e;
            var e = window.Shopify.customerPrivacy.userCanBeTracked(),
              t = window.Shopify.customerPrivacy.getTrackingConsent();
            (this.showPopup = !e && "no_interaction" === t && this.enable),
              window.Shopify.designMode && (this.showPopup = !0),
              this.init();
          }
        );
    }
    init() {
      this.showPopup && fadeIn(this.modal), this.clickEvents();
    }
    clickEvents() {
      this.acceptButton.addEventListener("click", (e) => {
        e.preventDefault(),
          window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
            fadeOut(this.modal)
          ),
          document.documentElement.style.setProperty(
            "--cookie-bar-height",
            "0px"
          );
      }),
        document.addEventListener("trackingConsentAccepted", () => {});
    }
    onBlockSelect(e) {
      this.popup.contains(e.target) &&
        this.showPopup &&
        (fadeIn(this.modal),
        this.popup.classList.add(classes$2.selected),
        this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) &&
        (fadeOut(this.modal),
        this.popup.classList.remove(classes$2.selected),
        this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
    }
  }
  class PromoText {
    constructor(e) {
      (this.popup = e),
        (this.close = this.popup.querySelector(selectors$2.close)),
        (this.cookie = new PopupCookie(
          this.popup.getAttribute(selectors$2.cookieNameAttribute),
          "user_has_closed"
        )),
        (this.isTargeted = new TargetReferrer(this.popup)),
        this.init();
    }
    init() {
      (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
        (window.Shopify.designMode
          ? fadeIn(this.popup)
          : new DelayShow(this.popup, this.popup),
        this.clickEvents());
    }
    clickEvents() {
      this.close.addEventListener("click", (e) => {
        e.preventDefault(), fadeOut(this.popup), this.cookie.write();
      });
    }
    onBlockSelect(e) {
      this.popup.contains(e.target) &&
        (fadeIn(this.popup),
        this.popup.classList.add(classes$2.selected),
        this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) &&
        (fadeOut(this.popup),
        this.popup.classList.remove(classes$2.selected),
        this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
    }
  }
  class NewsletterPopup {
    constructor(e) {
      (this.popup = e),
        (this.holder = this.popup.querySelector(
          selectors$2.newsletterPopupHolder
        )),
        (this.close = this.popup.querySelector(selectors$2.newsletterClose)),
        (this.heading = this.popup.querySelector(
          selectors$2.newsletterHeading
        )),
        (this.newsletterField = this.popup.querySelector(
          selectors$2.newsletterField
        )),
        (this.cookie = new PopupCookie(
          this.popup.getAttribute(selectors$2.cookieNameAttribute),
          "newsletter_is_closed"
        )),
        (this.form = this.popup.querySelector(selectors$2.newsletterForm)),
        (this.isTargeted = new TargetReferrer(this.popup)),
        (this.resetClassTimer = 0),
        this.init();
    }
    init() {
      var e = !1 !== this.cookie.read();
      -1 !== window.location.search.indexOf("?customer_posted=true") &&
        (this.delay = 0),
        (e && !window.Shopify.designMode) ||
          (this.show(),
          this.form.classList.contains(classes$2.success) &&
            this.checkForSuccess());
    }
    show() {
      window.Shopify.designMode
        ? fadeIn(this.holder)
        : new DelayShow(this.popup, this.holder),
        this.showForm(),
        this.inputField(),
        this.closePopup();
    }
    checkForSuccess() {
      fadeIn(this.holder), this.cookie.write();
    }
    showForm() {
      this.heading.addEventListener("click", (e) => {
        e.preventDefault(),
          this.heading.classList.add(classes$2.hide),
          this.form.classList.remove(classes$2.hide),
          this.newsletterField.focus();
      }),
        this.heading.addEventListener("keyup", (e) => {
          e.code === window.theme.keyboardKeys.ENTER &&
            this.heading.dispatchEvent(new Event("click"));
        });
    }
    closePopup() {
      this.close.addEventListener("click", (e) => {
        e.preventDefault(), fadeOut(this.holder), this.cookie.write();
      });
    }
    inputField() {
      var e = () => {
        this.resetClassTimer && clearTimeout(this.resetClassTimer),
          "" !== this.newsletterField.value &&
            this.holder.classList.add(classes$2.hasValue);
      };
      this.newsletterField.addEventListener("input", e),
        this.newsletterField.addEventListener("focus", e),
        this.newsletterField.addEventListener("focusout", () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            (this.resetClassTimer = setTimeout(() => {
              this.holder.classList.remove(classes$2.hasValue);
            }, 2e3));
        });
    }
    onBlockSelect(e) {
      this.popup.contains(e.target) &&
        (fadeIn(this.holder),
        this.popup.classList.add(classes$2.selected),
        this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
    }
    onBlockDeselect(e) {
      this.popup.contains(e.target) &&
        (fadeOut(this.holder),
        this.popup.classList.remove(classes$2.selected),
        this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
    }
  }
  const popupSection = {
      onLoad() {
        (sections$1[this.id] = []),
          this.container
            .querySelectorAll(selectors$2.largePromo)
            .forEach((e) => {
              sections$1[this.id].push(new LargePopup(e));
            }),
          this.container.querySelectorAll(selectors$2.tracking).forEach((e) => {
            sections$1[this.id].push(new Tracking(e));
          }),
          this.container
            .querySelectorAll(selectors$2.newsletterPopup)
            .forEach((e) => {
              sections$1[this.id].push(new NewsletterPopup(e));
            }),
          this.container
            .querySelectorAll(selectors$2.promoPopup)
            .forEach((e) => {
              sections$1[this.id].push(new PromoText(e));
            });
      },
      onBlockSelect(t) {
        sections$1[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        sections$1[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    selectors$1 =
      (register("popups", [popupSection, newsletterCheckForResultSection]),
      {
        passwordLogin: "[data-password-login]",
        passwordModal: "[data-password-modal]",
        modalBody: "[data-modal-body]",
        close: "[data-modal-close]",
        loginErrors: "#login_form .errors",
      }),
    classes$1 = { open: "is-open" };
  class Password {
    constructor(e) {
      (this.container = e.container),
        (this.passwordLogin = this.container.querySelectorAll(
          selectors$1.passwordLogin
        )),
        (this.modal = this.container.querySelector(selectors$1.passwordModal)),
        (this.modalBody = this.container.querySelector(selectors$1.modalBody)),
        (this.closeButtons = this.container.querySelectorAll(
          selectors$1.close
        )),
        (this.a11y = a11y),
        (this.loginErrors = this.container.querySelector(
          selectors$1.loginErrors
        )),
        this.init();
    }
    init() {
      this.passwordLogin.length &&
        this.modal &&
        this.modalBody &&
        (this.passwordLogin.forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), this.openModal();
          });
        }),
        this.closeButtons.length &&
          this.closeButtons.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault(), this.closeModal();
            });
          }),
        this.loginErrors) &&
        this.openModal();
    }
    openModal() {
      fadeIn(this.modal, "block", () => {
        this.modal.classList.add(classes$1.open);
      }),
        this.scrollLock();
    }
    closeModal() {
      fadeOut(this.modal),
        this.modal.classList.remove(classes$1.open),
        this.scrollUnlock();
    }
    scrollLock() {
      "none" !== window.getComputedStyle(this.modal).display &&
        (this.a11y.trapFocus(this.modal),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.modalBody,
          })
        ));
    }
    scrollUnlock() {
      this.a11y.removeTrapFocus(),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
  }
  const passwordSection = {
      onLoad() {
        new Password(this);
      },
    },
    selectors =
      (register("password-template", passwordSection),
      register("faq", accordions),
      register("list-collections", [
        slider,
        swatchGridSection,
        blockScroll,
        siblings,
      ]),
      customElements.get("quick-add-product") ||
        customElements.define("quick-add-product", QuickAddProduct),
      register("columns", [blockScroll]),
      register("newsletter", newsletterCheckForResultSection),
      register("before-after", [compareImages]),
      {
        headerSticky: "[data-header-sticky]",
        headerHeight: "[data-header-height]",
        scrollToElement: "[data-scroll-to]",
        scrollToElementValue: "data-scroll-to",
        scrollToLinks: "[data-scroll-to-links]",
        scrollSpy: "[data-scroll-spy]",
        accordionHolder: "[data-accordion-holder]",
        accordionToggle: "[data-accordion-toggle]",
        tooltip: "[data-tooltip]",
        tooltipStopMousenterValue: "data-tooltip-stop-mouseenter",
      }),
    classes = { open: "is-open", selected: "is-selected" },
    sections = {};
  class ScrollToElement {
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.scrollToButtons = this.container.querySelectorAll(
          selectors.scrollToElement
        )),
        (this.scrollSpyElement = this.container.querySelector(
          selectors.scrollSpy
        )),
        this.scrollToButtons.length && this.init(),
        this.scrollSpyElement && this.scrollSpy();
    }
    init() {
      this.scrollToButtons.forEach((o) => {
        o.addEventListener("click", (t) => {
          t.preventDefault();
          const s = document.querySelector(
            o.getAttribute(selectors.scrollToElementValue)
          );
          if (s) {
            t = s.querySelector(selectors.accordionToggle);
            let e = !1;
            var i = o.closest(selectors.scrollToLinks);
            i &&
              !o.closest(selectors.scrollSpy) &&
              ((i = i.querySelectorAll("." + classes.selected)).length &&
                i.forEach((e) => {
                  e.classList.remove(classes.selected);
                }),
              o.classList.add(classes.selected)),
              t &&
                ((i = t.closest(selectors.accordionHolder)),
                !t.classList.contains(classes.open) &&
                  i &&
                  i.querySelector(
                    selectors.accordionToggle + "." + classes.open
                  ) &&
                  (e = !0),
                t.classList.contains(classes.open) ||
                  t.dispatchEvent(new Event("click"))),
              e
                ? setTimeout(() => this.scrollToElement(s), 500)
                : this.scrollToElement(s);
          }
        });
      });
    }
    scrollToElement(e) {
      scrollTo(e.getBoundingClientRect().top);
      e = document.querySelectorAll(
        `${selectors.tooltip}:not([${selectors.tooltipStopMousenterValue}])`
      );
      e.length &&
        e.forEach((e) => {
          e.setAttribute(selectors.tooltipStopMousenterValue, ""),
            setTimeout(() => {
              e.removeAttribute(selectors.tooltipStopMousenterValue);
            }, 1e3);
        });
    }
    scrollSpy() {
      const e = this.scrollSpyElement.querySelectorAll(
        selectors.scrollToElement
      );
      if (e) {
        const s =
          document.querySelector(selectors.headerSticky) &&
          document.querySelector(selectors.headerHeight)
            ? document
                .querySelector(selectors.headerHeight)
                .getBoundingClientRect().height
            : 0;
        window.addEventListener("scroll", () => {
          const t = Math.ceil(
            document.documentElement.scrollTop || document.body.scrollTop
          );
          e.forEach((e) => {
            e = document.querySelector(
              e.getAttribute(selectors.scrollToElementValue)
            );
            e.offsetTop - s <= t &&
              (this.scrollSpyElement
                .querySelector("." + classes.selected)
                .classList.remove(classes.selected),
              this.scrollSpyElement
                .querySelector(`[${selectors.scrollToElementValue}="#${e.id}"]`)
                .classList.add(classes.selected));
          });
        });
      }
    }
  }
  const scrollToElement = {
    onLoad() {
      sections[this.id] = new ScrollToElement(this);
    },
  };
  register("sidebar", [accordions, scrollToElement]),
    document.addEventListener("DOMContentLoaded", function () {
      load("*");
      const e = document.querySelector("[data-scroll-top-button]");
      e &&
        (e.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          e.classList.toggle(
            "is-visible",
            window.pageYOffset > window.innerHeight
          );
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          loadScript({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.BodyScrollLock,
  themeVendor.themeAddresses,
  themeVendor.themeCurrency,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.Rellax,
  themeVendor.MicroModal,
  themeVendor.themeImages
);
